import{useState,useCallback,useRef,useEffect,useMemo}from"react";

/* ── TOKENS ── */
const T={
  g9:"#1C1C1E",g8:"#2C2C2E",g7:"#3A3A3C",g6:"#48484A",g5:"#636366",
  g4:"#8E8E93",g3:"#C7C7CC",g2:"#E5E5EA",g15:"#EBEBF0",g1:"#F2F2F7",
  g05:"#F9F9FB",wh:"#FFFFFF",
  or:"#D44500",orl:"#FFF0E8",orm:"#FF6820",
  bl:"#007AFF",bll:"#E8F2FF",bld:"#005EC4",
  gr:"#34C759",grl:"#E9F9EE",
  am:"#FF9500",aml:"#FFF4E0",
  rd:"#FF3B30",rdl:"#FFEEED",
  pu:"#AF52DE",pul:"#F5EEFF",
};
const SYS="-apple-system,BlinkMacSystemFont,'Helvetica Neue',sans-serif";

const SP={
  "Planning":{bg:T.bll,tx:T.bld},"Waiting for Quotes":{bg:T.aml,tx:"#7A4500"},
  "Quote Review":{bg:T.pul,tx:"#5B2D9E"},"Approved":{bg:T.grl,tx:"#166534"},
  "In Progress":{bg:T.orl,tx:T.or},"On Hold":{bg:T.g1,tx:T.g5},
  "Completed":{bg:T.grl,tx:"#166534"},"Cancelled":{bg:T.rdl,tx:"#B91C1C"},
  "Not Requested":{bg:T.g1,tx:T.g4},"Quote Requested":{bg:T.bll,tx:T.bld},
  "Waiting for Quote":{bg:T.aml,tx:"#7A4500"},"Quote Received":{bg:T.pul,tx:"#5B2D9E"},
  "Under Review":{bg:T.pul,tx:"#5B2D9E"},"Rejected":{bg:T.rdl,tx:"#B91C1C"},
  "Scheduled":{bg:T.bll,tx:T.bld},"Work Completed":{bg:T.grl,tx:"#166534"},
  "Unpaid":{bg:T.rdl,tx:"#B91C1C"},"Deposit Paid":{bg:T.aml,tx:"#7A4500"},
  "Partially Paid":{bg:T.aml,tx:"#7A4500"},"Paid":{bg:T.grl,tx:"#166534"},
  "Overdue":{bg:T.rdl,tx:"#B91C1C"},"Ordered":{bg:T.bll,tx:T.bld},
  "Delivered":{bg:T.grl,tx:"#166534"},"Installed":{bg:T.grl,tx:"#166534"},
};
const AV=[
  {bg:T.grl,tx:"#166534"},
];
const CATS=["Plumbing","Electrical","Tiles","Paint","Kitchen","HVAC","Stone","Windows","Doors","Flooring","Cabinets","Countertops","Appliances","Hardware","Drywall","Framing","Roofing","Landscaping","Permits","General Contractor","Design","Labor","Materials","Other"];
const PROJ_ST=["Planning","Waiting for Quotes","Quote Review","Approved","In Progress","On Hold","Completed","Cancelled"];
const QUOTE_ST=["Not Requested","Quote Requested","Waiting for Quote","Quote Received","Under Review","Approved","Rejected","Scheduled","In Progress","Work Completed"];
const PAY_ST=["Unpaid","Deposit Paid","Partially Paid","Paid","Overdue"];

/* ── ATOMS ── */
function KarpLogo({h=28,inv=false}){
  return(
    <div style={{height:h,display:"inline-flex",alignItems:"center",filter:inv?"invert(1)":"none",flexShrink:0}}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.07 8.38" height={h} style={{display:"block",width:"auto"}}>
        <path d="M.01,0h21.06s0,8.37,0,8.37H0S.01,0,.01,0ZM20.08,7.32V1.02s0-.02,0-.03c0,0,0-.01-.02,0H1.01s0,6.37,0,6.37h19.06s.02-.01.01-.04Z"/>
        <path d="M19.19,2.76c.06.24.08.49.03.73-.1.57-.52.97-1.06,1.14-.21.07-.43.1-.65.1h-1.24s-.03.03-.03.05v1.83s-.04.08-.08.08h-1.92s-.08-.04-.09-.06l-1.48-2.01h-.78s-.03.03-.03.05v1.96s-.05.08-.09.08h-2.07s-.08-.04-.09-.08l-.25-.71h-2s-.04.02-.05.04l-.23.7s-.04.06-.08.06h-1.93s-.08-.04-.1-.07l-1.42-2.06s-.05,0-.07.02l-.51.57v1.42s-.02.11-.08.11h-.97s-.09-.03-.09-.07V1.79c0-.05.02-.12.08-.12h.94s.12.02.12.07v2.02s0,.03.01.03c0,0,.03,0,.04,0l1.86-2.05s.09-.05.13-.05h1.08s.05.01.05.03,0,.05-.01.07l-1.78,2.02s-.04.07-.01.12l1.65,2.36,1.63-4.53s.04-.07.09-.07h1.3s.07.03.09.07l1.64,4.57V1.77s.04-.08.08-.09h2.43c.29,0,.56.08.82.19.36.16.62.46.73.84.09.29.1.6.02.89-.13.49-.53.79-1,.93-.03.02,0,.06.02.08l1.27,1.67s.02.02.02,0V1.77c0-.07.05-.1.11-.1h2.32c.21,0,.41.03.61.09.48.14.89.5,1.02,1ZM13.72,3.19c0-.23-.1-.43-.29-.54-.12-.07-.25-.11-.39-.12h-1.13s-.04.01-.04.04v1.23s.03.03.05.03h1.12c.36,0,.68-.27.69-.64ZM17.93,3.71c.14-.12.21-.27.22-.45,0-.24-.09-.45-.29-.58-.13-.09-.28-.14-.45-.14h-1.11s-.04.02-.04.04v1.3s.02.05.05.05h1.08c.18,0,.44-.08.54-.22ZM9.05,4.94s.04-.02.03-.05l-.74-2.02-.73,2.03s.02.04.04.04h1.4Z"/>
      </svg>
    </div>
  );
}

function Badge({status}){
  return <span style={{background:T.g9,color:T.wh,borderRadius:20,padding:"3px 9px",fontSize:11,fontWeight:700,whiteSpace:"nowrap"}}>{status}</span>;
}

function Ava({name="?",size=40,idx=0}){
  const c=AV[Math.abs(idx)%AV.length];
  const ini=name.split(" ").filter(Boolean).map(w=>w[0]).join("").slice(0,2).toUpperCase();
  return <div style={{width:size,height:size,borderRadius:"50%",flexShrink:0,background:c.bg,color:c.tx,display:"flex",alignItems:"center",justifyContent:"center",fontSize:size*.34,fontWeight:800,letterSpacing:"-0.02em"}}>{ini||"?"}</div>;
}

const IS={width:"100%",padding:"11px 14px",borderRadius:12,border:`1.5px solid ${T.g2}`,background:T.wh,color:T.g9,fontSize:16,boxSizing:"border-box",outline:"none",fontFamily:SYS,WebkitAppearance:"none",appearance:"none"};

function Inp({value,onChange,placeholder,type="text"}){
  const [f,sf]=useState(false);
  return <input type={type} value={value||""} onChange={onChange} placeholder={placeholder} onFocus={()=>sf(true)} onBlur={()=>sf(false)} style={{...IS,borderColor:f?T.bl:T.g2}}/>;
}
function Txa({value,onChange,placeholder,rows=3}){
  const [f,sf]=useState(false);
  return <textarea value={value||""} onChange={onChange} placeholder={placeholder} rows={rows} onFocus={()=>sf(true)} onBlur={()=>sf(false)} style={{...IS,resize:"vertical",lineHeight:1.5,borderColor:f?T.bl:T.g2}}/>;
}
function Sel({value,onChange,options,placeholder}){
  return <select value={value||""} onChange={e=>onChange(e.target.value)} style={{...IS,cursor:"pointer",backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%238E8E93' stroke-width='1.5' fill='none'/%3E%3C/svg%3E")`,backgroundRepeat:"no-repeat",backgroundPosition:"right 13px center",paddingRight:36}}>
    {placeholder&&<option value="">{placeholder}</option>}
    {(options||[]).map(o=><option key={o} value={o}>{o}</option>)}
  </select>;
}
function FF({label,children}){
  return <div style={{marginBottom:16}}>
    <label style={{display:"block",fontSize:11,fontWeight:700,color:T.g5,marginBottom:6,textTransform:"uppercase",letterSpacing:"0.05em"}}>{label}</label>
    {children}
  </div>;
}
function Btn({children,onClick,variant="primary",size="md",icon,disabled,full}){
  const [pr,sp]=useState(false);
  const V={
    primary:{bg:T.or,co:T.wh,bo:"none"},
    blue:{bg:T.bl,co:T.wh,bo:"none"},
    secondary:{bg:T.wh,co:T.g8,bo:`1.5px solid ${T.g2}`},
    ghost:{bg:"transparent",co:T.g5,bo:"none"},
    outline_orange:{bg:T.orl,co:T.or,bo:`1.5px solid ${T.or}`},
  };
  const v=V[variant]||V.primary;
  const pd=size==="sm"?"7px 13px":size==="lg"?"14px 26px":"10px 18px";
  const fs=size==="sm"?12:size==="lg"?15:13;
  return <button onClick={onClick} disabled={disabled} onMouseDown={()=>sp(true)} onMouseUp={()=>sp(false)} onMouseLeave={()=>sp(false)}
    style={{background:v.bg,color:v.co,border:v.bo,borderRadius:12,padding:pd,fontSize:fs,fontWeight:700,cursor:disabled?"not-allowed":"pointer",display:"inline-flex",alignItems:"center",gap:6,opacity:disabled?.45:1,transform:pr?"scale(.97)":"scale(1)",transition:"transform .1s",fontFamily:SYS,width:full?"100%":"auto",justifyContent:full?"center":"flex-start",whiteSpace:"nowrap"}}>
    {icon&&<i className={`ti ti-${icon}`} style={{fontSize:fs+1}} aria-hidden="true"/>}
    {children}
  </button>;
}
function Card({children,style,onClick,noPad}){
  const [hov,sh]=useState(false);
  return <div onClick={onClick} onMouseEnter={()=>onClick&&sh(true)} onMouseLeave={()=>onClick&&sh(false)}
    style={{background:T.wh,borderRadius:16,border:`1.5px solid ${hov?T.g3:T.g2}`,padding:noPad?0:"16px 18px",cursor:onClick?"pointer":"default",transition:"border-color .15s",overflow:"hidden",...style}}>
    {children}
  </div>;
}

/* ── TOAST NOTIFICATION ── */
let _showToast = null;
function registerToast(fn){ _showToast = fn; }
function toast(msg="Saved", type="success"){
  if(_showToast) _showToast(msg, type);
}

function ToastContainer(){
  const [toasts, setToasts] = useState([]);
  useEffect(()=>{
    registerToast((msg, type)=>{
      const id = Date.now();
      setToasts(prev=>[...prev, {id, msg, type}]);
      setTimeout(()=>setToasts(prev=>prev.filter(t=>t.id!==id)), 2800);
    });
  },[]);

  return <div style={{
    position:"fixed", top:"50%", left:"50%", transform:"translate(-50%,-50%)",
    zIndex:99999, display:"flex", flexDirection:"column",
    alignItems:"center", gap:8, pointerEvents:"none",
  }}>
    {toasts.map(t=>(
      <div key={t.id} style={{
        display:"flex", alignItems:"center", gap:8,
        background: t.type==="error" ? T.g9 : T.g9,
        color: T.wh,
        padding:"10px 18px",
        borderRadius:999,
        fontSize:13, fontWeight:600, fontFamily:SYS,
        boxShadow:"0 8px 32px rgba(0,0,0,.25)",
        border:`1px solid ${t.type==="error"?"rgba(255,80,80,.3)":"rgba(255,255,255,.15)"}`,
        animation:"toastIn .3s cubic-bezier(.34,1.56,.64,1) forwards",
        letterSpacing:"0.01em",
        backdropFilter:"blur(12px)",
        whiteSpace:"nowrap",
      }}>
        <i className={`ti ti-${t.type==="error"?"alert-circle":"circle-check"}`}
           style={{fontSize:15, color: t.type==="error"?"#FF6B6B":T.gr}} aria-hidden="true"/>
        {t.msg}
      </div>
    ))}
    <style>{`
      @keyframes toastIn{
        0%{opacity:0;transform:translateY(-12px) scale(.92);}
        100%{opacity:1;transform:translateY(0) scale(1);}
      }
    `}</style>
  </div>;
}

function Modal({title,onClose,children,width=540}){
  useEffect(()=>{
    document.body.classList.add("karp-modal-open");
    return()=>document.body.classList.remove("karp-modal-open");
  },[]);
  return <div style={{position:"fixed",inset:0,background:"rgba(28,28,30,.55)",display:"flex",alignItems:"flex-end",justifyContent:"center",zIndex:9000,paddingTop:"env(safe-area-inset-top,44px)"}} onClick={e=>e.target===e.currentTarget&&onClose()}>
    <div style={{background:T.wh,borderRadius:"22px 22px 0 0",width:"100%",maxWidth:width,height:"calc(100% - 15px)",display:"flex",flexDirection:"column",boxShadow:"0 -8px 40px rgba(0,0,0,.22)",animation:"karpSlideUp .42s cubic-bezier(0.34,1.06,0.64,1) both"}}>
      {/* Handle + sticky title */}
      <div style={{flexShrink:0,background:T.wh,borderRadius:"22px 22px 0 0",borderBottom:`1px solid ${T.g15}`,zIndex:2}}>
        <div style={{display:"flex",justifyContent:"center",padding:"12px 0 8px"}}><div style={{width:36,height:4,borderRadius:4,background:T.g2}}/></div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 20px 10px"}}>
          <h2 style={{margin:0,fontSize:18,fontWeight:800,color:T.g9}}>{title}</h2>
          <button onClick={onClose} style={{background:T.g1,border:"none",cursor:"pointer",color:T.g5,width:32,height:32,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>✕</button>
        </div>
      </div>
      {/* Scrollable content — 15px top gap */}
      <div style={{flex:1,overflowY:"auto",padding:"15px 20px 40px"}}>
        {children}
      </div>
    </div>
  </div>;
}
function StatCard({label,value,icon,accent,color}){
  return <div style={{background:`linear-gradient(135deg,${T.g9} 0%,${T.g8} 100%)`,borderRadius:16,padding:"14px 16px",border:"none"}}>
    <div style={{width:30,height:30,borderRadius:10,background:"rgba(255,255,255,.12)",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:10}}>
      <i className={`ti ti-${icon}`} style={{fontSize:16,color:"rgba(255,255,255,.85)"}} aria-hidden="true"/>
    </div>
    <div style={{fontSize:22,fontWeight:800,color:T.wh,lineHeight:1}}>{value}</div>
    <div style={{fontSize:12,color:"rgba(255,255,255,.55)",marginTop:5,fontWeight:500}}>{label}</div>
  </div>;
}
function PBar({pct,over}){
  return <div style={{height:6,borderRadius:6,background:T.g15,overflow:"hidden"}}>
    <div style={{height:"100%",width:`${Math.min(100,pct)}%`,background:over?T.rd:pct>80?T.am:T.bl,borderRadius:6}}/>
  </div>;
}

/* ── CONFIRM DELETE ── */
function ConfirmDelete({label,onConfirm,onCancel,lang="en"}){
  const t=TR[lang]||TR.en;
  return <div style={{
    position:"fixed",inset:0,background:"rgba(0,0,0,.45)",
    display:"flex",alignItems:"center",justifyContent:"center",
    zIndex:2000,padding:24,
  }} onClick={e=>e.target===e.currentTarget&&onCancel()}>
    <div style={{background:T.wh,borderRadius:20,padding:"28px 24px",maxWidth:340,width:"100%",boxShadow:"0 12px 48px rgba(0,0,0,.22)",textAlign:"center"}}>
      <div style={{width:52,height:52,borderRadius:16,background:T.rdl,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 16px"}}>
        <i className="ti ti-trash" style={{fontSize:26,color:T.rd}} aria-hidden="true"/>
      </div>
      <div style={{fontSize:18,fontWeight:800,color:T.g9,marginBottom:8}}>{t.areYouSure||"Are you sure?"}</div>
      <div style={{fontSize:14,color:T.g5,marginBottom:24,lineHeight:1.5}}>
        <strong style={{color:T.g8}}>{label}</strong>{lang==="es"?" será eliminado permanentemente. Esta acción no se puede deshacer.":" will be permanently deleted. This cannot be undone."}
      </div>
      <div style={{display:"flex",gap:10}}>
        <button onClick={onCancel} style={{flex:1,padding:"12px",borderRadius:12,border:`1.5px solid ${T.g2}`,background:T.wh,color:T.g7,fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:SYS}}>
          {lang==="es"?"Cancelar":"Cancel"}
        </button>
        <button onClick={onConfirm} style={{flex:1,padding:"12px",borderRadius:12,border:"none",background:T.rd,color:T.wh,fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:SYS,boxShadow:"0 2px 10px rgba(255,59,48,.3)"}}>
          {lang==="es"?"Eliminar":"Delete"}
        </button>
      </div>
    </div>
  </div>;
}

/* ── AI PROXY HELPER ──────────────────────────────────────────────────────
   All AI vision calls go through the Netlify serverless function at
   /.netlify/functions/ai-proxy which adds the ANTHROPIC_API_KEY server-side.
   This avoids CORS and keeps the key out of the browser.
─────────────────────────────────────────────────────────────────────────── */
const callAIProxy=async(payload)=>{
  const res=await fetch("/.netlify/functions/ai-proxy",{
    method:"POST",
    headers:{"Content-Type":"application/json"},
    body:JSON.stringify(payload),
  });
  const d=await res.json();
  if(d.content) return d;
  // Show the actual error from Anthropic or proxy
  const errMsg=d.error?.message||d.error||JSON.stringify(d);
  throw new Error(errMsg);
};

/* ── SUPABASE CONFIG ── */
const SB_URL="https://oscmwkbrvircyvdrpwed.supabase.co";
const SB_KEY="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9zY213a2JydmlyY3l2ZHJwd2VkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkzODk3MjIsImV4cCI6MjA5NDk2NTcyMn0.2ezJvx5TCDuxpsTosVXtOeOMi8OJfV7uC4VaaN4Wsnk";
const SB_COLS=["projects","contacts","vendors","quotes","expenses","history"];

const SB_HEADERS={
  "Content-Type":"application/json",
  "apikey":SB_KEY,
  "Authorization":`Bearer ${SB_KEY}`,
  "Prefer":"return=representation",
};

const sbGet=async(table)=>{
  const res=await fetch(`${SB_URL}/rest/v1/${table}?order=created_at.asc&limit=1000`,{
    headers:SB_HEADERS
  });
  if(!res.ok){
    const txt=await res.text();
    throw new Error(`GET ${table} failed: ${res.status} ${txt}`);
  }
  return res.json();
};

const sbInsert=async(table,row)=>{
  const res=await fetch(`${SB_URL}/rest/v1/${table}`,{
    method:"POST",
    headers:SB_HEADERS,
    body:JSON.stringify(row),
  });
  if(!res.ok){
    const txt=await res.text();
    throw new Error(`INSERT ${table} failed: ${res.status} ${txt}`);
  }
  const txt=await res.text();
  return txt?JSON.parse(txt):[];
};

const sbDelete=async(table,sbid)=>{
  const res=await fetch(`${SB_URL}/rest/v1/${table}?id=eq.${sbid}`,{
    method:"DELETE",
    headers:SB_HEADERS,
  });
  if(!res.ok)throw new Error(`DELETE failed: ${res.status}`);
};

/* ── DATA HOOK (Supabase + localStorage cache) ── */
const CACHE_KEY="karp_cache_v3";
function useData(){
  const def={projects:[],contacts:[],vendors:[],quotes:[],expenses:[],history:[]};

  const [data,setData]=useState(()=>{
    try{const s=localStorage.getItem(CACHE_KEY);return s?{...def,...JSON.parse(s)}:def;}
    catch{return def;}
  });
  const [loading,setLoading]=useState(true);
  const [syncing,setSyncing]=useState(false);
  const [error,setError]=useState(null);
  const [dbOk,setDbOk]=useState(false);

  const cache=useCallback(d=>{
    try{localStorage.setItem(CACHE_KEY,JSON.stringify(d));}catch{}
  },[]);

  // Load from Supabase on mount + poll every 30s for other users' changes
  const loadFromDB = useCallback(async(isInitial=false)=>{
    try{
      setError(null);
      const results=await Promise.all(SB_COLS.map(col=>sbGet(col)));
      const fresh={};
      SB_COLS.forEach((col,i)=>{
        const rows=Array.isArray(results[i])?results[i]:[];
        fresh[col]=rows.map(row=>({...row.data,_sbid:row.id,created_at:row.created_at||row.data?.created_at||row.data?.createdAt}));
      });
      setData(prev=>({...prev,...fresh}));
      cache({...def,...fresh});
      setDbOk(true);
    }catch(e){
      console.error("Supabase load error:",e.message);
      setError(`Database error: ${e.message}`);
    }finally{
      if(isInitial)setLoading(false);
    }
  },[cache]);

  useEffect(()=>{
    let alive=true;
    loadFromDB(true).then(()=>{if(!alive)return;});
    // Poll every 30 seconds to pick up changes from other users
    const interval=setInterval(()=>{if(alive)loadFromDB(false);},30000);
    return()=>{alive=false;clearInterval(interval);};
  },[loadFromDB]);

  const add=useCallback(async(col,item)=>{
    const localId=`tmp_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    const newItem={...item,id:localId,created_at:new Date().toISOString(),createdAt:new Date().toISOString()};
    // Show immediately
    setData(prev=>{const n={...prev,[col]:[...prev[col],newItem]};cache(n);return n;});
    setSyncing(true);
    try{
      const rows=await sbInsert(col,{data:newItem});
      const row=Array.isArray(rows)?rows[0]:rows;
      if(row?.id){
        const saved={...newItem,_sbid:row.id};
        setData(prev=>{const n={...prev,[col]:prev[col].map(x=>x.id===localId?saved:x)};cache(n);return n;});
      }
      setError(null);
      setDbOk(true);
    }catch(e){
      console.error("Supabase insert error:",e.message);
      setError("Could not save to cloud. Check your Supabase table permissions.");
    }finally{setSyncing(false);}
  },[cache]);

  const remove=useCallback(async(col,itemId)=>{
    const item=data[col].find(x=>x.id===itemId);
    setData(prev=>{const n={...prev,[col]:prev[col].filter(x=>x.id!==itemId)};cache(n);return n;});
    if(item?._sbid){
      try{await sbDelete(col,item._sbid);}
      catch(e){console.error("Delete error:",e.message);}
    }
  },[data,cache]);

  const update=useCallback(async(col,itemId,changes)=>{
    setData(prev=>{
      const n={...prev,[col]:prev[col].map(x=>x.id===itemId?{...x,...changes}:x)};
      cache(n);return n;
    });
    const item=data[col]?.find(x=>x.id===itemId);
    if(item?._sbid){
      try{await fetch(`${SB_URL}/rest/v1/${col}?id=eq.${item._sbid}`,{method:"PATCH",headers:SB_HEADERS,body:JSON.stringify({data:{...item,...changes}})});}
      catch(e){console.error("Update error:",e.message);}
    }
  },[data,cache]);

  const hist=useCallback(async(entry)=>{
    const item={...entry,id:`h_${Date.now()}`,ts:new Date().toISOString()};
    setData(prev=>{const n={...prev,history:[item,...prev.history].slice(0,200)};cache(n);return n;});
    try{await sbInsert("history",{data:item});}catch{}
  },[cache]);

  return{data,add,remove,hist,loading,syncing,error,dbOk,update};
}

/* ── AI EMAIL ── */
function AIEmail({contact,vendor,project,category,tab,onClose,onSent,allContacts,allVendors,lang="en"}){
  const needsPick=!contact&&!vendor;
  const [step,ss]=useState(needsPick?-1:0);
  const [pickedContact,setPContact]=useState(contact||null);
  const [pickedVendor,setPVendor]=useState(vendor||null);
  const [pickQ,setPQ]=useState("");
  const [form,sf]=useState({project:project||"",category:category||"",tab:tab||"Labor",scope:""});
  const [email,se]=useState(null);
  const [loading,sl]=useState(false);
  const [attachMode,setAM]=useState("none");
  const [attachFile,setAF]=useState(null);
  const [attachUrl,setAU]=useState("");
  const fileRef=useRef(null);

  const u=(k,v)=>sf(f=>({...f,[k]:v}));
  const aC=pickedContact||contact;
  const aV=pickedVendor||vendor;
  const rName=aC?.firstName?`${aC.firstName} ${aC.lastName}`:aV?.name||"";
  const rEmail=aC?.email||aV?.email||"";
  const lq=pickQ.toLowerCase();
  const fC=(allContacts||[]).filter(c=>!pickQ||[c.firstName,c.lastName,c.role,c.company,c.email,...(c.categories||[])].some(f=>f&&f.toLowerCase().includes(lq)));
  const fV=(allVendors||[]).filter(v=>!pickQ||[v.name,...(v.categories||[])].some(f=>f&&f.toLowerCase().includes(lq)));
  const aSum=attachFile?attachFile.name:attachUrl||"";
  const handleFile=e=>{const f=e.target.files?.[0];if(!f)return;const r=new FileReader();r.onload=ev=>setAF({name:f.name,size:f.size,dataUrl:ev.target.result});r.readAsDataURL(f);e.target.value="";};
  const clearA=()=>{setAF(null);setAU("");setAM("none");};
  const fmtSz=b=>b<1024*1024?`${Math.round(b/1024)}KB`:`${(b/1024/1024).toFixed(1)}MB`;

  const generate=async()=>{
    sl(true);
    const aN=aSum?`\nAttachment: ${aSum}`:"";
    const prompt=`Generate a professional renovation quote request email. Recipient: ${rName}. Project: ${form.project}. Type: ${form.tab} - ${form.category}. Scope: ${form.scope}.${aN} Return ONLY valid JSON with keys: subject, body (\n for newlines). Mention attachment if present.`;
    try{
      const d=await callAIProxy({model:"claude-sonnet-4-5",max_tokens:800,messages:[{role:"user",content:prompt}]});
      se({...JSON.parse((d.content?.[0]?.text||"{}").replace(/```json|```/g,"").trim()),to:rEmail,rName});
    }catch{
      se({to:rEmail,rName,subject:`Quote Request – ${form.category} | ${form.project}`,body:`Dear ${rName},\n\nI am writing to request a quote for:\n\nProject: ${form.project}\nScope: ${form.scope}\nCategory: ${form.tab} – ${form.category}${aSum?`\n\nAttachment: ${aSum}`:""}\n\nPlease provide pricing and timeline.\n\nBest regards`});
    }
    sl(false);ss(1);
  };

  const open=()=>{
    const body=attachUrl?`${email.body}\n\nLink: ${attachUrl}`:email.body;
    window.open(`mailto:${email.to}?subject=${encodeURIComponent(email.subject)}&body=${encodeURIComponent(body)}`);
    onSent&&onSent(email);onClose();
  };

  /* Shared attachment UI */
  const AttachPicker=()=><div style={{marginBottom:16}}>
    <label style={{display:"block",fontSize:11,fontWeight:800,color:T.g4,marginBottom:8,textTransform:"uppercase",letterSpacing:"0.05em"}}>Attachment (optional)</label>
    {attachFile&&<div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",background:T.grl,borderRadius:12,marginBottom:8,border:`1px solid ${T.gr}`}}>
      <i className="ti ti-file-filled" style={{fontSize:20,color:T.gr,flexShrink:0}} aria-hidden="true"/>
      <div style={{flex:1,minWidth:0}}><div style={{fontSize:13,fontWeight:700,color:"#166534",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{attachFile.name}</div><div style={{fontSize:11,color:"#166534",opacity:.7}}>{fmtSz(attachFile.size)}</div></div>
      <button onClick={clearA} style={{background:"none",border:"none",cursor:"pointer",color:"#166534",fontSize:16,padding:0}}>✕</button>
    </div>}
    {attachUrl&&!attachFile&&<div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",background:T.bll,borderRadius:12,marginBottom:8,border:`1px solid ${T.bl}`}}>
      <i className="ti ti-link" style={{fontSize:18,color:T.bl,flexShrink:0}} aria-hidden="true"/>
      <div style={{flex:1,minWidth:0}}><div style={{fontSize:12,fontWeight:700,color:T.bld,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{attachUrl}</div><div style={{fontSize:10,color:T.bl,opacity:.7}}>Added to email body</div></div>
      <button onClick={clearA} style={{background:"none",border:"none",cursor:"pointer",color:T.bl,fontSize:16,padding:0}}>✕</button>
    </div>}
    {!attachFile&&!attachUrl&&<>
      {attachMode!=="url"&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
        <button onClick={()=>fileRef.current&&fileRef.current.click()} style={{display:"flex",alignItems:"center",justifyContent:"center",gap:7,padding:"11px",borderRadius:12,cursor:"pointer",fontFamily:SYS,border:`1.5px dashed ${T.g3}`,background:T.g05,color:T.g6,fontSize:12,fontWeight:700}}>
          <i className="ti ti-folder-open" style={{fontSize:18}} aria-hidden="true"/>Browse Files
        </button>
        <button onClick={()=>setAM("url")} style={{display:"flex",alignItems:"center",justifyContent:"center",gap:7,padding:"11px",borderRadius:12,cursor:"pointer",fontFamily:SYS,border:`1.5px dashed ${T.bl}`,background:T.bll,color:T.bld,fontSize:12,fontWeight:700}}>
          <i className="ti ti-link" style={{fontSize:18}} aria-hidden="true"/>Add URL
        </button>
      </div>}
      {attachMode==="url"&&<div style={{display:"flex",gap:8}}>
        <div style={{flex:1,position:"relative"}}>
          <i className="ti ti-link" style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:T.g4,fontSize:15,pointerEvents:"none"}} aria-hidden="true"/>
          <input autoFocus value={attachUrl} onChange={e=>setAU(e.target.value)} placeholder="https://…" style={{...IS,paddingLeft:36}}/>
        </div>
        <button onClick={()=>{if(!attachUrl.trim())setAM("none");}} style={{padding:"0 14px",borderRadius:12,border:`1px solid ${T.g2}`,background:T.wh,color:T.g5,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:SYS,flexShrink:0}}>{attachUrl.trim()?"Done":"Cancel"}</button>
      </div>}
    </>}
    <input ref={fileRef} type="file" accept="*/*" style={{display:"none"}} onChange={handleFile}/>
  </div>;

  return <Modal title={step===-1?"Select Recipient":"Request Quote via AI"} onClose={onClose} width={560}>

    {/* ── STEP -1: Pick contact / vendor ── */}
    {step===-1&&<div>
      <div style={{fontSize:13,color:T.g5,marginBottom:12}}>Choose who to send the quote request to.</div>
      <div style={{position:"relative",marginBottom:14}}>
        <i className="ti ti-search" style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:T.g4,fontSize:16,pointerEvents:"none"}} aria-hidden="true"/>
        <input autoFocus value={pickQ} onChange={e=>setPQ(e.target.value)} placeholder="Search contacts or vendors…" style={{...IS,paddingLeft:38,borderRadius:12}}/>
        {pickQ&&<button onClick={()=>setPQ("")} style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",background:T.g2,border:"none",borderRadius:"50%",width:20,height:20,cursor:"pointer",color:T.g6,fontSize:12,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>}
      </div>
      <div style={{maxHeight:400,overflowY:"auto",display:"flex",flexDirection:"column",gap:6}}>
        {fC.length>0&&<>
          <div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",padding:"4px 2px"}}>Contacts</div>
          {fC.map((c,i)=>(
            <button key={c.id} onClick={()=>{setPContact(c);setPVendor(null);ss(0);}} style={{display:"flex",alignItems:"center",gap:12,padding:"11px 14px",borderRadius:12,border:`1.5px solid ${T.g15}`,background:T.wh,cursor:"pointer",textAlign:"left",fontFamily:SYS,width:"100%",transition:"border-color .12s"}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor=T.bl}} onMouseLeave={e=>{e.currentTarget.style.borderColor=T.g15}}>
              <Ava name={`${c.firstName} ${c.lastName}`} size={40} idx={i}/>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:700,fontSize:14,color:T.g9}}>{c.firstName} {c.lastName}</div>
                <div style={{fontSize:12,color:T.g4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{[c.role,c.company].filter(Boolean).join(" · ")}</div>
                {c.email&&<div style={{fontSize:11,color:T.g5}}>{c.email}</div>}
              </div>
              <i className="ti ti-chevron-right" style={{fontSize:14,color:T.g3}} aria-hidden="true"/>
            </button>
          ))}
        </>}
        {fV.length>0&&<>
          <div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",padding:"4px 2px",marginTop:4}}>Vendors</div>
          {fV.map((v,i)=>(
            <button key={v.id} onClick={()=>{setPVendor(v);setPContact(null);ss(0);}} style={{display:"flex",alignItems:"center",gap:12,padding:"11px 14px",borderRadius:12,border:`1.5px solid ${T.g15}`,background:T.wh,cursor:"pointer",textAlign:"left",fontFamily:SYS,width:"100%",transition:"border-color .12s"}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor=T.or}} onMouseLeave={e=>{e.currentTarget.style.borderColor=T.g15}}>
              <Ava name={v.name} size={40} idx={i+3}/>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:700,fontSize:14,color:T.g9}}>{v.name}</div>
                {(v.categories||[]).length>0&&<div style={{fontSize:12,color:T.g4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{v.categories.slice(0,3).join(", ")}</div>}
                {v.email&&<div style={{fontSize:11,color:T.g5}}>{v.email}</div>}
              </div>
              <i className="ti ti-chevron-right" style={{fontSize:14,color:T.g3}} aria-hidden="true"/>
            </button>
          ))}
        </>}
        {fC.length===0&&fV.length===0&&<div style={{textAlign:"center",padding:"32px 0",color:T.g4}}>
          <i className="ti ti-mood-empty" style={{fontSize:32,display:"block",marginBottom:8,opacity:.3}} aria-hidden="true"/>
          <div style={{fontSize:13,fontWeight:600}}>No contacts or vendors found</div>
        </div>}
      </div>
      <div style={{marginTop:14}}><Btn variant="secondary" onClick={onClose} full>{lang==="es"?"Cancelar":"Cancel"}</Btn></div>
    </div>}

    {/* ── STEP 0: Form ── */}
    {step===0&&<div>
      <div style={{display:"flex",gap:12,alignItems:"center",background:T.g05,borderRadius:12,padding:"11px 14px",marginBottom:16,border:`1.5px solid ${T.g15}`}}>
        <Ava name={rName||"?"} size={40} idx={1}/>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontWeight:700,fontSize:14,color:T.g9}}>{rName||"No recipient"}</div>
          <div style={{fontSize:12,color:T.g4}}>{rEmail||"No email on file"}</div>
        </div>
        <button onClick={()=>ss(-1)} style={{background:T.bll,border:`1px solid ${T.bl}`,borderRadius:8,padding:"5px 10px",cursor:"pointer",color:T.bld,fontSize:11,fontWeight:700,fontFamily:SYS,flexShrink:0}}>Change</button>
      </div>
      <FF label="Project"><Inp value={form.project} onChange={e=>u("project",e.target.value)} placeholder="Project name"/></FF>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <FF label="Type"><Sel value={form.tab} onChange={v=>u("tab",v)} options={["Labor","Materials","Mortgage"]}/></FF>
        <FF label="Category"><Sel value={form.category} onChange={v=>u("category",v)} options={CATS} placeholder="Select…"/></FF>
      </div>
      <FF label="Scope of work"><Txa value={form.scope} onChange={e=>u("scope",e.target.value)} placeholder="Describe what you need…" rows={3}/></FF>
      <AttachPicker/>
      <div style={{display:"flex",gap:10,marginTop:4}}>
        <Btn variant="secondary" onClick={onClose} full>Cancel</Btn>
        <Btn icon="sparkles" onClick={generate} disabled={loading||!form.scope||!form.category||!rName} full>{loading?"Generating…":"Generate with AI"}</Btn>
      </div>
    </div>}

    {/* ── STEP 1: Email preview ── */}
    {step===1&&email&&<div>
      {attachFile&&<div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",background:T.aml,borderRadius:12,marginBottom:12,border:`1px solid ${T.am}`}}>
        <i className="ti ti-paperclip" style={{fontSize:16,color:"#7A4500",flexShrink:0}} aria-hidden="true"/>
        <div style={{flex:1}}><div style={{fontSize:12,fontWeight:700,color:"#7A4500"}}>Attach manually: <strong>{attachFile.name}</strong></div><div style={{fontSize:11,color:"#7A4500",opacity:.8}}>Add in your email app before sending</div></div>
      </div>}
      <div style={{background:T.g05,borderRadius:14,padding:16,marginBottom:14}}>
        <div style={{marginBottom:10}}><div style={{fontSize:10,fontWeight:700,color:T.g4,letterSpacing:"0.08em",marginBottom:4}}>TO</div><div style={{fontSize:13,color:T.g8}}>{email.rName} &lt;{email.to}&gt;</div></div>
        <div style={{marginBottom:10}}><div style={{fontSize:10,fontWeight:700,color:T.g4,letterSpacing:"0.08em",marginBottom:4}}>SUBJECT</div><Inp value={email.subject} onChange={e=>se(em=>({...em,subject:e.target.value}))}/></div>
        <div><div style={{fontSize:10,fontWeight:700,color:T.g4,letterSpacing:"0.08em",marginBottom:4}}>BODY</div><Txa value={email.body} onChange={e=>se(em=>({...em,body:e.target.value}))} rows={8}/></div>
      </div>
      <div style={{display:"flex",gap:10}}>
        <Btn variant="secondary" icon="arrow-left" onClick={()=>ss(0)} full>Back</Btn>
        <Btn icon="mail" onClick={open} full>Open in Email App</Btn>
      </div>
    </div>}
  </Modal>;
}

/* ── BUSINESS CARD SCANNER ── */
function CardScanner({onFilled}){
  const inputRef=useRef(null);
  const [st,setSt]=useState("idle");
  const [preview,setPreview]=useState(null);
  const [extracted,setExtracted]=useState(null);
  const [msg,setMsg]=useState("");
  const FIELDS=[
    {key:"firstName",label:"First Name"},{key:"lastName",label:"Last Name"},
    {key:"role",label:"Role"},{key:"company",label:"Company"},
    {key:"phone",label:"Phone"},{key:"businessPhone",label:"Business Phone"},
    {key:"email",label:"Email"},{key:"address",label:"Address"},
  ];

  // Compress image before sending to keep payload small
  const compressImage=(dataUrl,maxW=1200)=>new Promise(resolve=>{
    const img=new Image();
    img.onload=()=>{
      const scale=Math.min(1,maxW/img.width);
      const canvas=document.createElement("canvas");
      canvas.width=img.width*scale;
      canvas.height=img.height*scale;
      canvas.getContext("2d").drawImage(img,0,0,canvas.width,canvas.height);
      resolve(canvas.toDataURL("image/jpeg",0.85));
    };
    img.onerror=()=>resolve(dataUrl);
    img.src=dataUrl;
  });

  const callAI=async(b64,mediaType)=>{
    const payload={
      model:"claude-sonnet-4-5",
      max_tokens:600,
      messages:[{role:"user",content:[
        {type:"image",source:{type:"base64",media_type:mediaType,data:b64}},
        {type:"text",text:`Extract contact information from this business card photo. Look carefully at ALL text visible. Return ONLY a valid JSON object with these exact keys (empty string "" if not found):
{"firstName":"","lastName":"","role":"","company":"","phone":"","businessPhone":"","email":"","address":""}
If only one phone number exists put it in phone. No markdown, no explanation, just the JSON.`}
      ]}]
    };
    const d=await callAIProxy(payload);
    return d.content?.[0]?.text||"{}";
  };

  const scan=async(file)=>{
    if(!file)return;
    setSt("scanning");setMsg("Reading card…");
    const reader=new FileReader();
    reader.onload=async(e)=>{
      try{
        const original=e.target.result;
        setMsg("Optimising image…");
        const compressed=await compressImage(original);
        setPreview(compressed);
        const b64=compressed.split(",")[1];
        const mediaType="image/jpeg";
        setMsg("Extracting contact details with AI…");
        const rawText=await callAI(b64,mediaType);
        // Try multiple JSON extraction strategies
        let parsed=null;
        // Strategy 1: find first complete JSON object
        const matches=rawText.match(/\{[^{}]*\}/g);
        if(matches){
          for(const m of matches){
            try{const p=JSON.parse(m);if(Object.keys(p).length>0){parsed=p;break;}}catch{}
          }
        }
        // Strategy 2: extract between first { and last }
        if(!parsed){
          try{
            const start=rawText.indexOf("{");
            const end=rawText.lastIndexOf("}");
            if(start>=0&&end>start) parsed=JSON.parse(rawText.slice(start,end+1));
          }catch{}
        }
        if(!parsed) throw new Error("Could not parse response");
        const hasData=Object.values(parsed).some(v=>v&&String(v).trim());
        if(!hasData) throw new Error("No data found on card");
        setExtracted(parsed);setSt("preview");
      }catch(err){
        console.error("Card scan error:",err.message);
        setSt("error");
        setMsg(`Error: ${err.message}`);
      }
    };
    reader.onerror=()=>{setSt("error");setMsg("Could not read the image file. Please try again.");};
    reader.readAsDataURL(file);
  };

  const apply=()=>{
    if(!extracted)return;
    const patch={};
    Object.entries(extracted).forEach(([k,v])=>{if(v&&String(v).trim())patch[k]=String(v).trim();});
    onFilled(patch);setSt("done");
    setTimeout(()=>{setSt("idle");setPreview(null);setExtracted(null);},1200);
  };

  return <div style={{marginBottom:16}}>
    <input ref={inputRef} type="file" accept="image/*" capture="environment" style={{display:"none"}}
      onChange={e=>{const f=e.target.files?.[0];if(f)scan(f);e.target.value="";}}/>

    {st==="idle"&&<button onClick={()=>inputRef.current&&inputRef.current.click()}
      style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:10,padding:"14px",borderRadius:14,cursor:"pointer",fontFamily:SYS,border:`2px dashed ${T.bl}`,background:T.bll,color:T.bl,fontSize:13,fontWeight:700}}>
      <i className="ti ti-camera" style={{fontSize:20}} aria-hidden="true"/>
      Scan Business Card (AI)
    </button>}

    {st==="scanning"&&<div style={{borderRadius:12,border:`1.5px solid ${T.bl}`,background:T.bll,padding:"18px 16px"}}>
      <div style={{display:"flex",alignItems:"center",gap:12}}>
        <div style={{width:20,height:20,borderRadius:"50%",border:`2.5px solid ${T.bl}`,borderTopColor:"transparent",animation:"spin .7s linear infinite",flexShrink:0}}/>
        <div>
          <div style={{fontSize:13,fontWeight:700,color:T.bld}}>Scanning…</div>
          <div style={{fontSize:12,color:T.bl,marginTop:2}}>{msg}</div>
        </div>
      </div>
    </div>}

    {st==="preview"&&extracted&&<div style={{borderRadius:12,border:`1.5px solid ${T.bl}`,overflow:"hidden",background:T.wh}}>
      {preview&&<div style={{position:"relative"}}>
        <img src={preview} alt="Business card" style={{width:"100%",maxHeight:130,objectFit:"cover",display:"block"}}/>
        <div style={{position:"absolute",inset:0,background:"linear-gradient(to bottom,transparent 50%,rgba(0,0,0,.5))"}}/>
        <div style={{position:"absolute",bottom:8,left:12,display:"flex",alignItems:"center",gap:6}}>
          <div style={{width:16,height:16,borderRadius:"50%",background:T.gr,display:"flex",alignItems:"center",justifyContent:"center"}}>
            <i className="ti ti-check" style={{fontSize:9,color:T.wh}} aria-hidden="true"/>
          </div>
          <span style={{fontSize:11,fontWeight:700,color:T.wh}}>
            {Object.values(extracted).filter(v=>v&&String(v).trim()).length} fields found
          </span>
        </div>
      </div>}
      <div style={{padding:"12px 14px"}}>
        <div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginBottom:8}}>EXTRACTED INFO</div>
        {FIELDS.map(({key,label})=>{
          const val=extracted[key];const has=val&&String(val).trim();
          return <div key={key} style={{display:"flex",alignItems:"center",gap:8,padding:"6px 0",borderBottom:`1px solid ${T.g15}`}}>
            <i className={`ti ti-${has?"circle-check":"circle-dashed"}`} style={{fontSize:14,color:has?T.gr:T.g3,flexShrink:0}} aria-hidden="true"/>
            <span style={{fontSize:11,color:T.g4,width:110,flexShrink:0}}>{label}</span>
            <span style={{fontSize:12,fontWeight:has?600:400,color:has?T.g9:T.g3,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{has||"—"}</span>
          </div>;
        })}
        <div style={{display:"flex",gap:8,marginTop:14}}>
          <button onClick={()=>{setSt("idle");setPreview(null);setExtracted(null);}} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:7,background:"#E0E0E0",color:"#2C2C2E",border:"1px solid #bababa",borderRadius:999,padding:"11px 16px",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:SYS}}>
            Retake
          </button>
          <button onClick={apply} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:7,background:T.or,color:"#FFF",border:"none",borderRadius:999,padding:"11px 16px",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:SYS}}>
            <i className="ti ti-check" style={{fontSize:15}} aria-hidden="true"/>Fill Form
          </button>
        </div>
      </div>
    </div>}

    {st==="error"&&<div style={{borderRadius:12,border:`1.5px solid ${T.rd}`,background:T.rdl,padding:"14px"}}>
      <div style={{display:"flex",gap:10,alignItems:"flex-start",marginBottom:10}}>
        <i className="ti ti-alert-circle" style={{fontSize:18,color:T.rd,flexShrink:0,marginTop:1}} aria-hidden="true"/>
        <div>
          <div style={{fontSize:13,fontWeight:700,color:"#B91C1C",marginBottom:2}}>Scan failed</div>
          <div style={{fontSize:12,color:"#B91C1C"}}>{msg}</div>
        </div>
      </div>
      <div style={{fontSize:11,color:"#B91C1C",marginBottom:10,paddingLeft:28}}>
        Tips: good lighting, hold camera steady, card fills the frame.
      </div>
      <Btn variant="secondary" size="sm" onClick={()=>setSt("idle")} full>Try Again</Btn>
    </div>}

    {st==="done"&&<div style={{borderRadius:12,border:`1.5px solid ${T.gr}`,background:T.grl,padding:"12px 14px",display:"flex",alignItems:"center",gap:8}}>
      <i className="ti ti-circle-check" style={{fontSize:18,color:T.gr}} aria-hidden="true"/>
      <span style={{fontSize:13,fontWeight:700,color:"#166534"}}>Fields filled! Review below.</span>
    </div>}
  </div>;
}

/* ── COMPANY PICKER ── */
function CompanyPicker({vendors,value,onChange,onNewVendor}){
  const [adding,setAdding]=useState(false);
  const [nv,snv]=useState({name:"",phone:"",email:"",categories:[]});
  const un=(k,v)=>snv(p=>({...p,[k]:v}));
  const saveNew=()=>{
    if(!nv.name.trim())return;
    onNewVendor&&onNewVendor(nv);
    onChange(nv.name);
    snv({name:"",phone:"",email:"",categories:[]});
    setAdding(false);
  };
  return <div>
    <div style={{display:"flex",gap:8}}>
      <div style={{flex:1}}>
        <select value={value||""} onChange={e=>onChange(e.target.value)} style={{...IS,cursor:"pointer",backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%238E8E93' stroke-width='1.5' fill='none'/%3E%3C/svg%3E")`,backgroundRepeat:"no-repeat",backgroundPosition:"right 13px center",paddingRight:36}}>
          <option value="">— None —</option>
          {(vendors||[]).map(v=><option key={v.id||v.name} value={v.name}>{v.name}</option>)}
        </select>
      </div>
      <button onClick={()=>setAdding(a=>!a)} style={{flexShrink:0,padding:"0 14px",height:46,borderRadius:12,border:`1.5px solid ${adding?T.or:T.bl}`,background:adding?T.orl:T.bll,color:adding?T.or:T.bl,cursor:"pointer",fontWeight:700,fontSize:12,fontFamily:SYS}}>
        {adding?"Cancel":"+ New"}
      </button>
    </div>
    {value&&!adding&&<div style={{display:"flex",alignItems:"center",gap:8,marginTop:8,padding:"7px 12px",borderRadius:10,background:T.bll}}>
      <i className="ti ti-building" style={{fontSize:14,color:T.bl}} aria-hidden="true"/>
      <span style={{fontSize:13,fontWeight:600,color:T.bld,flex:1}}>{value}</span>
      <button onClick={()=>onChange("")} style={{background:"none",border:"none",cursor:"pointer",color:T.bl,fontSize:14,lineHeight:1,padding:0}}>✕</button>
    </div>}
    {adding&&<div style={{marginTop:10,border:`1.5px solid ${T.or}`,borderRadius:12,overflow:"hidden",background:T.orl}}>
      <div style={{padding:"10px 14px 8px",borderBottom:"1px solid rgba(212,69,0,.15)",fontSize:11,fontWeight:800,color:T.or,letterSpacing:"0.06em",textTransform:"uppercase"}}>Add New Company</div>
      <div style={{padding:"12px 14px"}}>
        <FF label="Company name *"><Inp value={nv.name} onChange={e=>un("name",e.target.value)} placeholder="ABC Plumbing Co."/></FF>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
          <FF label="Phone"><Inp value={nv.phone} onChange={e=>un("phone",e.target.value)} placeholder="555-000-0000"/></FF>
          <FF label="Email"><Inp value={nv.email} onChange={e=>un("email",e.target.value)} placeholder="info@co.com"/></FF>
        </div>
        <div style={{display:"flex",gap:8,marginTop:4}}>
          <button onClick={()=>{setAdding(false);snv({name:"",phone:"",email:"",categories:[]});}} style={{flex:1,padding:"9px",borderRadius:10,border:`1px solid ${T.g2}`,background:T.wh,color:T.g6,fontSize:13,fontWeight:600,cursor:"pointer",fontFamily:SYS}}>Cancel</button>
          <button onClick={saveNew} disabled={!nv.name.trim()} style={{flex:1,padding:"9px",borderRadius:10,border:"none",background:nv.name.trim()?T.or:T.g2,color:nv.name.trim()?T.wh:T.g4,fontSize:13,fontWeight:700,cursor:nv.name.trim()?"pointer":"not-allowed",fontFamily:SYS}}>Save & Select</button>
        </div>
      </div>
    </div>}
  </div>;
}

/* ── FORMS ── */
function CatPicker({selected,onChange}){
  const t=c=>onChange(selected.includes(c)?selected.filter(x=>x!==c):[...selected,c]);
  return <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
    {CATS.map(c=><button key={c} onClick={()=>t(c)} style={{padding:"5px 11px",borderRadius:20,fontSize:11.5,fontWeight:600,cursor:"pointer",border:"none",fontFamily:SYS,background:selected.includes(c)?T.bl:T.g1,color:selected.includes(c)?T.wh:T.g6,transition:"all .15s"}}>{c}</button>)}
  </div>;
}

function SecHead({label}){
  return <div style={{display:"flex",alignItems:"center",gap:8,margin:"18px 0 12px"}}>
    <div style={{width:3,height:14,borderRadius:2,background:T.or}}/>
    <span style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase"}}>{label}</span>
  </div>;
}

function ContactForm({vendors,onSave,onClose,onNewVendor,lang="en"}){
  const [f,sf]=useState({firstName:"",lastName:"",company:"",role:"",phone:"",businessPhone:"",email:"",address:"",preferredContact:"Email",status:"Active",categories:[],notes:""});
  const u=(k,v)=>sf(p=>({...p,[k]:v}));
  const [lv,slv]=useState(vendors||[]);
  const handleNV=(nv)=>{onNewVendor&&onNewVendor(nv);slv(p=>[...p,{...nv,id:Date.now()}]);};
  return <div>
    <CardScanner onFilled={patch=>{
      sf(p=>({...p,...patch}));
      // Auto-create vendor if company scanned and not already in list
      if(patch.company){
        const exists=lv.find(v=>v.name.toLowerCase()===patch.company.toLowerCase());
        if(!exists){
          const nv={name:patch.company,phone:patch.businessPhone||patch.phone||"",email:patch.email||"",address:patch.address||"",notes:"Auto-created from business card scan"};
          handleNV(nv);
        }
      }
    }}/>
    <SecHead label="Identity"/>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
      <FF label="First name *"><Inp value={f.firstName} onChange={e=>u("firstName",e.target.value)} placeholder="John"/></FF>
      <FF label="Last name"><Inp value={f.lastName} onChange={e=>u("lastName",e.target.value)} placeholder="Smith"/></FF>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
      <FF label="Role / Trade"><Inp value={f.role} onChange={e=>u("role",e.target.value)} placeholder="Estimator"/></FF>
      <FF label="Status"><Sel value={f.status} onChange={v=>u("status",v)} options={["Active","Preferred","Inactive","Blacklisted"]}/></FF>
    </div>
    <SecHead label="Company"/>
    <FF label="Company / Vendor"><CompanyPicker vendors={lv} value={f.company} onChange={v=>u("company",v)} onNewVendor={handleNV}/></FF>
    <SecHead label="Contact Info"/>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
      <FF label="Direct phone"><Inp value={f.phone} onChange={e=>u("phone",e.target.value)} placeholder="555-000-0000"/></FF>
      <FF label="Business phone"><Inp value={f.businessPhone} onChange={e=>u("businessPhone",e.target.value)} placeholder="555-000-0000"/></FF>
    </div>
    <FF label="Email"><Inp value={f.email} onChange={e=>u("email",e.target.value)} placeholder="john@company.com"/></FF>
    <FF label="Address"><Inp value={f.address} onChange={e=>u("address",e.target.value)} placeholder="123 Main St, Miami FL"/></FF>
    <FF label="Preferred contact">
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        {["Email","Phone","Text","WhatsApp"].map(m=><button key={m} onClick={()=>u("preferredContact",m)} style={{padding:"7px 14px",borderRadius:20,fontSize:12,fontWeight:600,cursor:"pointer",border:"none",background:f.preferredContact===m?T.bl:T.g1,color:f.preferredContact===m?T.wh:T.g6,fontFamily:SYS}}>{m}</button>)}
      </div>
    </FF>
    <SecHead label="Trade Categories"/>
    <CatPicker selected={f.categories||[]} onChange={v=>u("categories",v)}/>
    <SecHead label={lang==="es"?"Notas":"Notes"}/>
    <FF label="Internal notes"><Txa value={f.notes} onChange={e=>u("notes",e.target.value)} placeholder="Reliability notes, pricing history…" rows={3}/></FF>
    <div style={{display:"flex",gap:10,marginTop:12}}>
      <Btn variant="secondary" onClick={onClose} full>Cancel</Btn>
      <Btn icon="user-plus" onClick={()=>onSave(f)} disabled={!f.firstName} full>Save Contact</Btn>
    </div>
  </div>;
}

function VendorForm({onSave,onClose}){
  const [f,sf]=useState({name:"",phone:"",email:"",website:"",address:"",notes:"",categories:[]});
  const u=(k,v)=>sf(p=>({...p,[k]:v}));
  return <div>
    <FF label="Company name *"><Inp value={f.name} onChange={e=>u("name",e.target.value)} placeholder="ABC Plumbing Co."/></FF>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
      <FF label="Phone"><Inp value={f.phone} onChange={e=>u("phone",e.target.value)}/></FF>
      <FF label="Email"><Inp value={f.email} onChange={e=>u("email",e.target.value)}/></FF>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
      <FF label="Website"><Inp value={f.website} onChange={e=>u("website",e.target.value)}/></FF>
      <FF label="Address"><Inp value={f.address} onChange={e=>u("address",e.target.value)}/></FF>
    </div>
    <FF label="Categories"><CatPicker selected={f.categories||[]} onChange={v=>u("categories",v)}/></FF>
    <FF label="Notes"><Txa value={f.notes} onChange={e=>u("notes",e.target.value)} rows={2}/></FF>
    <div style={{display:"flex",gap:10,marginTop:12}}>
      <Btn variant="secondary" onClick={onClose} full>Cancel</Btn>
      <Btn onClick={()=>onSave(f)} disabled={!f.name} full>Save Vendor</Btn>
    </div>
  </div>;
}

function ProjectForm({onSave,onClose}){
  const [f,sf]=useState({name:"",description:"",address:"",startDate:"",endDate:"",status:"Planning",budget:"",notes:"",photo:null});
  const u=(k,v)=>sf(p=>({...p,[k]:v}));
  const photoRef=useRef(null);

  const handlePhoto=async(e)=>{
    const file=e.target.files?.[0];
    if(!file)return;
    const compressed=await compressImage(file,800,800,0.75);
    u("photo",compressed);
    e.target.value="";
  };

  return <div>
    {/* Photo upload */}
    <div style={{marginBottom:18}}>
      <input ref={photoRef} type="file" accept="image/*" style={{display:"none"}} onChange={handlePhoto}/>
      {f.photo
        ?<div style={{position:"relative",borderRadius:14,overflow:"hidden",height:140,marginBottom:4}}>
          <img src={f.photo} alt="Project" style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
          <div style={{position:"absolute",inset:0,background:"linear-gradient(to top,rgba(0,0,0,.35) 0%,transparent 50%)"}}/>
          <button onClick={()=>u("photo",null)} style={{position:"absolute",top:8,right:8,background:"rgba(0,0,0,.55)",border:"none",borderRadius:"50%",width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",color:"#fff",fontSize:14}}>✕</button>
          <button onClick={()=>photoRef.current?.click()} style={{position:"absolute",bottom:8,right:8,background:"rgba(0,0,0,.55)",border:"none",borderRadius:8,padding:"5px 10px",cursor:"pointer",color:"#fff",fontSize:11,fontWeight:700,fontFamily:SYS}}>Change</button>
        </div>
        :<button onClick={()=>photoRef.current?.click()} style={{
          width:"100%",height:100,borderRadius:14,border:`2px dashed ${T.g2}`,
          background:T.g05,cursor:"pointer",display:"flex",flexDirection:"column",
          alignItems:"center",justifyContent:"center",gap:6,marginBottom:4,
        }}>
          <i className="ti ti-camera" style={{fontSize:22,color:T.g4}} aria-hidden="true"/>
          <span style={{fontSize:12,fontWeight:600,color:T.g4,fontFamily:SYS}}>Add Project Photo</span>
        </button>
      }
    </div>
    <FF label="Project name *"><Inp value={f.name} onChange={e=>u("name",e.target.value)} placeholder="Twin Lakes Renovation"/></FF>
    <FF label="Address"><Inp value={f.address} onChange={e=>u("address",e.target.value)}/></FF>
    <FF label="Description"><Txa value={f.description} onChange={e=>u("description",e.target.value)} rows={2}/></FF>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
      <FF label="Start date"><input type="date" style={IS} value={f.startDate} onChange={e=>u("startDate",e.target.value)}/></FF>
      <FF label="Est. completion"><input type="date" style={IS} value={f.endDate} onChange={e=>u("endDate",e.target.value)}/></FF>
      <FF label="Budget ($)"><Inp type="number" value={f.budget} onChange={e=>u("budget",e.target.value)}/></FF>
    </div>
    <FF label="Status"><Sel value={f.status} onChange={v=>u("status",v)} options={PROJ_ST}/></FF>
    <div style={{display:"flex",gap:10,marginTop:12}}>
      <Btn variant="secondary" onClick={onClose} full>Cancel</Btn>
      <Btn onClick={()=>onSave(f)} disabled={!f.name} full>Save Project</Btn>
    </div>
  </div>;
}

function QuoteForm({data,onSave,onClose,initialProject,initialTab,lang="en"}){
  const today=new Date().toISOString().slice(0,10);
  const [f,sf]=useState({
    title:"",vendorId:"",contactId:"",projectId:initialProject?.id||"",
    tab:initialTab||"Labor",category:"",amount:"",
    quoteDate:today,validUntil:"",status:"Quote Received",notes:"",
    attachFile:null,attachUrl:"",
  });
  const u=(k,v)=>sf(p=>({...p,[k]:v}));
  const fileRef=useRef(null);

  // Auto-populate vendor when contact is selected
  const handleContactChange=(contactId)=>{
    u("contactId",contactId);
    if(contactId){
      const contact=data.contacts.find(c=>c.id===contactId);
      if(contact?.company){
        // Try exact match first, then case-insensitive, then partial
        const co=contact.company.toLowerCase();
        const vendor=data.vendors.find(v=>v.name===contact.company)
          ||data.vendors.find(v=>v.name.toLowerCase()===co)
          ||data.vendors.find(v=>v.name.toLowerCase().includes(co)||co.includes(v.name.toLowerCase()));
        if(vendor) sf(p=>({...p,contactId,vendorId:vendor.id}));
        else sf(p=>({...p,contactId}));
      }
    }
  };

  const [scanning,setScanning]=useState(false);
  const [scanError,setScanError]=useState("");

  const handleFile=async e=>{
    const file=e.target.files?.[0];
    if(!file)return;
    const reader=new FileReader();
    reader.onload=async ev=>{
      const dataUrl=ev.target.result;
      const b64=dataUrl.split(",")[1];
      u("attachFile",{name:file.name,size:file.size,type:file.type,dataUrl});
      // Only AI-scan images and PDFs
      if(file.type.includes("image")||file.type.includes("pdf")){
        setScanning(true);setScanError("");
        try{
          const mediaType=file.type.includes("pdf")?"application/pdf":file.type;
          const d=await callAIProxy({
            model:"claude-sonnet-4-5",
            max_tokens:800,
            messages:[{role:"user",content:[
              {type:"image",source:{type:"base64",media_type:mediaType.includes("pdf")?"image/jpeg":mediaType,data:b64}},
              {type:"text",text:`Extract quote/invoice information from this document. Return ONLY valid JSON with these keys (empty string if not found):
{"title":"brief quote description or project name","vendorName":"company or vendor name","contactName":"person name","amount":"total amount as number only no $ sign","category":"one of: Plumbing,Electrical,Tiles,Paint,Kitchen,HVAC,Stone,Windows,Doors,Flooring,Cabinets,Countertops,Appliances,Hardware,Drywall,Framing,Roofing,Landscaping,Permits,General Contractor,Design,Labor,Materials,Other","tab":"Labor or Materials or Labor & Materials or Mortgage","quoteDate":"date in YYYY-MM-DD format","validUntil":"expiry date in YYYY-MM-DD format","notes":"any other relevant details","status":"Quote Received"}`}
            ]}]
          });
          const raw=(d.content?.[0]?.text||"{}");
          const jm=raw.match(/\{[\s\S]*\}/);
          const parsed=JSON.parse(jm?jm[0]:"{}");

          sf(prev=>{
            const updates={...prev};
            if(parsed.title&&!prev.title) updates.title=parsed.title;
            if(parsed.amount) updates.amount=parsed.amount;
            if(parsed.category) updates.category=parsed.category;
            if(parsed.tab) updates.tab=parsed.tab;
            if(parsed.quoteDate) updates.quoteDate=parsed.quoteDate;
            if(parsed.validUntil) updates.validUntil=parsed.validUntil;
            if(parsed.notes&&!prev.notes) updates.notes=parsed.notes;
            if(parsed.status) updates.status=parsed.status;
            // Try to match vendor by name
            if(parsed.vendorName){
              const vn=parsed.vendorName.toLowerCase();
              const vendor=data.vendors.find(v=>v.name.toLowerCase()===vn||v.name.toLowerCase().includes(vn)||vn.includes(v.name.toLowerCase()));
              if(vendor) updates.vendorId=vendor.id;
            }
            // Try to match contact by name
            if(parsed.contactName){
              const cn=parsed.contactName.toLowerCase();
              const contact=data.contacts.find(c=>`${c.firstName} ${c.lastName}`.toLowerCase().includes(cn)||cn.includes(c.firstName.toLowerCase()));
              if(contact) updates.contactId=contact.id;
            }
            return updates;
          });
        }catch(err){
          setScanError(`Could not auto-fill: ${err.message}`);
        }finally{setScanning(false);}
      }
    };
    reader.readAsDataURL(file);
    e.target.value="";
  };

  const fmtSz=b=>b<1024*1024?`${Math.round(b/1024)}KB`:`${(b/1024/1024).toFixed(1)}MB`;

  return <div>
    <FF label="Quote title *"><Inp value={f.title} onChange={e=>u("title",e.target.value)} placeholder="Stone countertops – ABC Stone"/></FF>

    {/* Project */}
    <FF label="Project">
      <select style={IS} value={f.projectId} onChange={e=>u("projectId",e.target.value)}>
        <option value="">Select…</option>
        {data.projects.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
      </select>
    </FF>

    {/* Type — Labor / Materials / Both */}
    <FF label="Type">
      <div style={{display:"flex",gap:8}}>
        {["Labor","Materials","Labor & Materials","Mortgage"].map(tabOpt=><button key={tabOpt} onClick={()=>u("tab",tabOpt)} style={{flex:1,padding:"10px",borderRadius:10,border:`1.5px solid ${f.tab===tabOpt?T.bl:T.g2}`,background:f.tab===tabOpt?T.bl:T.wh,color:f.tab===tabOpt?T.wh:T.g6,fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:SYS,transition:"all .15s"}}>{tabOpt}</button>)}
      </div>
    </FF>

    <FF label="Category"><Sel value={f.category} onChange={v=>u("category",v)} options={CATS} placeholder="Select…"/></FF>

    {/* Contact — auto-fills vendor */}
    <FF label="Contact">
      <select style={IS} value={f.contactId} onChange={e=>handleContactChange(e.target.value)}>
        <option value="">Select contact…</option>
        {data.contacts.map(c=><option key={c.id} value={c.id}>{c.firstName} {c.lastName}{c.company?` · ${c.company}`:""}</option>)}
      </select>
    </FF>
    {f.contactId&&data.contacts.find(c=>c.id===f.contactId)?.company&&!f.vendorId&&<div style={{marginTop:-10,marginBottom:12,fontSize:11,color:T.g4,paddingLeft:2}}>
      No matching vendor found for this contact's company
    </div>}

    {/* Vendor */}
    <FF label={lang==="es"?"Proveedor":"Vendor"}>
      <select style={IS} value={f.vendorId} onChange={e=>u("vendorId",e.target.value)}>
        <option value="">{lang==="es"?"Seleccionar proveedor…":"Select vendor…"}</option>
        {data.vendors.map(v=><option key={v.id} value={v.id}>{v.name}</option>)}
      </select>
    </FF>

    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
      <FF label="Amount ($)"><Inp type="number" value={f.amount} onChange={e=>u("amount",e.target.value)} placeholder="0.00"/></FF>
      <FF label="Status"><Sel value={f.status} onChange={v=>u("status",v)} options={QUOTE_ST}/></FF>
    </div>

    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
      <FF label="Quote date"><input type="date" style={IS} value={f.quoteDate} onChange={e=>u("quoteDate",e.target.value)}/></FF>
      <FF label="Valid until"><input type="date" style={IS} value={f.validUntil} onChange={e=>u("validUntil",e.target.value)}/></FF>
    </div>

    {/* Attachment */}
    <div style={{marginBottom:16}}>
      <label style={{display:"block",fontSize:11,fontWeight:800,color:T.g4,marginBottom:8,textTransform:"uppercase",letterSpacing:"0.05em"}}>Attachment (optional)</label>
      {f.attachFile&&<div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",background:T.grl,borderRadius:12,marginBottom:8,border:`1px solid ${T.gr}`}}>
        <i className="ti ti-file-filled" style={{fontSize:18,color:T.gr,flexShrink:0}} aria-hidden="true"/>
        <div style={{flex:1,minWidth:0}}>
          <div style={{fontSize:13,fontWeight:700,color:"#166534",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{f.attachFile.name}</div>
          <div style={{fontSize:11,color:"#166534",opacity:.7}}>{fmtSz(f.attachFile.size)}</div>
        </div>
        <button onClick={()=>u("attachFile",null)} style={{background:"none",border:"none",cursor:"pointer",color:"#166534",fontSize:16,padding:0}}>✕</button>
      </div>}
      {f.attachUrl&&!f.attachFile&&<div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",background:T.bll,borderRadius:12,marginBottom:8,border:`1px solid ${T.bl}`}}>
        <i className="ti ti-link" style={{fontSize:16,color:T.bl,flexShrink:0}} aria-hidden="true"/>
        <div style={{flex:1,minWidth:0,fontSize:12,fontWeight:700,color:T.bld,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{f.attachUrl}</div>
        <button onClick={()=>u("attachUrl","")} style={{background:"none",border:"none",cursor:"pointer",color:T.bl,fontSize:16,padding:0}}>✕</button>
      </div>}
      {!f.attachFile&&!f.attachUrl&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
        <button onClick={()=>fileRef.current&&fileRef.current.click()} style={{display:"flex",alignItems:"center",justifyContent:"center",gap:6,padding:"11px",borderRadius:12,cursor:"pointer",fontFamily:SYS,border:`1.5px dashed ${T.g3}`,background:T.g05,color:T.g6,fontSize:12,fontWeight:700}}>
          <i className="ti ti-folder-open" style={{fontSize:16}} aria-hidden="true"/>Browse Files
        </button>
        <button onClick={()=>{const url=prompt("Paste URL:");if(url&&url.trim())u("attachUrl",url.trim());}} style={{display:"flex",alignItems:"center",justifyContent:"center",gap:6,padding:"11px",borderRadius:12,cursor:"pointer",fontFamily:SYS,border:`1.5px dashed ${T.bl}`,background:T.bll,color:T.bld,fontSize:12,fontWeight:700}}>
          <i className="ti ti-link" style={{fontSize:16}} aria-hidden="true"/>Add URL
        </button>
      </div>}
      <input ref={fileRef} type="file" accept="*/*" style={{display:"none"}} onChange={handleFile}/>
    </div>

    {/* AI scanning status */}
    {scanning&&<div style={{display:"flex",alignItems:"center",gap:10,padding:"12px 14px",background:T.bll,borderRadius:12,marginBottom:16,border:`1px solid ${T.bl}`}}>
      <div style={{width:18,height:18,border:`2px solid ${T.bl}`,borderTopColor:"transparent",borderRadius:"50%",animation:"spin 1s linear infinite",flexShrink:0}}/>
      <div style={{fontSize:13,fontWeight:600,color:T.bld}}>Reading document and filling fields…</div>
    </div>}
    {scanError&&<div style={{display:"flex",alignItems:"center",gap:8,padding:"10px 14px",background:T.rdl,borderRadius:12,marginBottom:16,border:`1px solid ${T.rd}`}}>
      <i className="ti ti-alert-circle" style={{fontSize:16,color:T.rd,flexShrink:0}} aria-hidden="true"/>
      <div style={{fontSize:12,color:T.rd}}>{scanError}</div>
    </div>}

    <FF label="Notes"><Txa value={f.notes} onChange={e=>u("notes",e.target.value)} rows={2} placeholder="Additional notes…"/></FF>

    <div style={{display:"flex",gap:10,marginTop:12}}>
      <Btn variant="secondary" onClick={onClose} full>Cancel</Btn>
      <Btn icon="file-text" onClick={()=>onSave(f)} disabled={!f.title} full>Save Quote</Btn>
    </div>
  </div>;
}

/* ── QUOTE DETAIL / EDIT MODAL ── */
function QuoteDetailModal({quote,data,onClose,onUpdate,onDelete,lang="en"}){
  const t=TR[lang]||TR.en;
  const [editing,setEditing]=useState(false);
  const [replying,setReplying]=useState(false);
  const [f,sf]=useState({...quote});
  const [confirmDel,setConfirmDel]=useState(false);
  const [zoom,setZoom]=useState(1);
  const fileRef=useRef(null);
  const u=(k,v)=>sf(p=>({...p,[k]:v}));
  const vendor=data.vendors.find(x=>x.id===quote.vendorId);
  const contact=data.contacts.find(x=>x.id===quote.contactId);
  const project=data.projects.find(x=>x.id===quote.projectId);
  const fmtSz=b=>b<1024*1024?`${Math.round(b/1024)}KB`:`${(b/1024/1024).toFixed(1)}MB`;

  // If replying, show AIEmail modal
  if(replying) return <AIEmail
    contact={contact||null}
    vendor={vendor||null}
    project={project?.name||""}
    category={quote.category||""}
    tab={quote.tab||"Labor"}
    allContacts={data.contacts}
    allVendors={data.vendors}
    onClose={()=>setReplying(false)}
    onSent={()=>{setReplying(false);}}
  />;

  const handleFile=e=>{
    const file=e.target.files?.[0];if(!file)return;
    const reader=new FileReader();
    reader.onload=ev=>u("attachFile",{name:file.name,size:file.size,type:file.type,dataUrl:ev.target.result});
    reader.readAsDataURL(file);e.target.value="";
  };

  const handleContactChange=(contactId)=>{
    u("contactId",contactId);
    if(contactId){
      const c=data.contacts.find(x=>x.id===contactId);
      if(c?.company){
        const co=c.company.toLowerCase();
        const v=data.vendors.find(x=>x.name===c.company)
          ||data.vendors.find(x=>x.name.toLowerCase()===co)
          ||data.vendors.find(x=>x.name.toLowerCase().includes(co)||co.includes(x.name.toLowerCase()));
        if(v) sf(p=>({...p,contactId,vendorId:v.id}));
        else sf(p=>({...p,contactId}));
      }
    }
  };

  return <Modal title={editing?t.editQuote:t.quoteDetails} onClose={onClose} width={580}>
    {confirmDel&&<ConfirmDelete label={quote.title} onConfirm={()=>{onDelete&&onDelete(quote.id);onClose();}} onCancel={()=>setConfirmDel(false)}/>}

    {!editing?<div>
      {/* Action buttons */}
      <div style={{display:"flex",gap:8,marginBottom:16}}>
        <button onClick={()=>setConfirmDel(true)} style={{flex:1,padding:"11px",borderRadius:999,border:`1px solid ${T.rd}`,background:T.rdl,color:T.rd,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:SYS,display:"flex",alignItems:"center",justifyContent:"center",gap:4}}>
          <i className="ti ti-trash" style={{fontSize:13}} aria-hidden="true"/>{t.delete}
        </button>
        <button onClick={()=>setReplying(true)} style={{flex:1,padding:"11px",borderRadius:999,border:`1px solid ${T.or}`,background:T.orl,color:T.or,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:SYS,display:"flex",alignItems:"center",justifyContent:"center",gap:4}}>
          <i className="ti ti-mail" style={{fontSize:13}} aria-hidden="true"/>Reply
        </button>
        <button onClick={()=>{
          let resolved={...quote};
          if(quote.vendorId&&!data.vendors.find(v=>v.id===quote.vendorId)&&vendor){
            const match=data.vendors.find(v=>v.name===vendor.name||v.name.toLowerCase()===vendor.name?.toLowerCase());
            if(match) resolved={...resolved,vendorId:match.id};
          }
          sf(resolved);setEditing(true);
        }} style={{flex:1,padding:"11px",borderRadius:999,border:"none",background:T.bl,color:T.wh,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:SYS,display:"flex",alignItems:"center",justifyContent:"center",gap:4}}>
          <i className="ti ti-pencil" style={{fontSize:13}} aria-hidden="true"/>Edit
        </button>
      </div>

      {/* Dark header card */}
      <div style={{background:`linear-gradient(135deg,${T.g9},${T.g8})`,borderRadius:16,padding:"16px",marginBottom:16,color:T.wh}}>
        <div style={{fontSize:17,fontWeight:800,marginBottom:8}}>{quote.title}</div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:10}}>
          <Badge status={quote.status}/>
          {quote.tab&&<span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:6,background:"rgba(255,255,255,.15)",color:T.wh}}>{quote.tab}</span>}
          {quote.category&&<span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:6,background:"rgba(255,255,255,.15)",color:T.wh}}>{quote.category}</span>}
        </div>
        {quote.amount&&<div style={{fontSize:26,fontWeight:800}}>${Number(quote.amount).toLocaleString()}</div>}
      </div>

      {/* Details */}
      {[
        {icon:"building",label:"Project",val:project?.name},
        {icon:"briefcase",label:"Vendor",val:vendor?.name},
        {icon:"user",label:"Contact",val:contact?`${contact.firstName} ${contact.lastName}`:null},
        {icon:"calendar",label:"Quote Date",val:quote.quoteDate},
        {icon:"calendar-off",label:"Valid Until",val:quote.validUntil},
      ].filter(r=>r.val).map(r=><div key={r.label} style={{display:"flex",gap:10,padding:"10px 0",borderBottom:`1px solid ${T.g15}`}}>
        <div style={{width:26,height:26,borderRadius:8,background:T.g1,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ti-${r.icon}`} style={{fontSize:13,color:T.g5}} aria-hidden="true"/>
        </div>
        <div><div style={{fontSize:10,color:T.g4,fontWeight:600}}>{r.label}</div><div style={{fontSize:13,color:T.g9,fontWeight:600,marginTop:1}}>{r.val}</div></div>
      </div>)}

      {/* Attachment — PDF viewer */}
      {quote.attachFile&&<div style={{marginTop:16}}>
        <div style={{fontSize:11,fontWeight:700,color:T.g4,marginBottom:8,textTransform:"uppercase",letterSpacing:"0.06em"}}>Attachment</div>
        {quote.attachFile.type?.includes("image")
          ?<div style={{borderRadius:12,overflow:"hidden",border:`1px solid ${T.g2}`,background:T.g1}}>
            <img src={quote.attachFile.dataUrl} alt="attachment" style={{width:"100%",display:"block"}}/>
          </div>
          :<div style={{background:T.g05,borderRadius:12,border:`1px solid ${T.g2}`,padding:"14px 16px"}}>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:14}}>
              <div style={{width:44,height:44,borderRadius:10,background:T.rdl,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                <i className="ti ti-file-type-pdf" style={{fontSize:24,color:T.rd}} aria-hidden="true"/>
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:14,fontWeight:700,color:T.g9,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{quote.attachFile.name}</div>
                <div style={{fontSize:12,color:T.g4,marginTop:2}}>{fmtSz(quote.attachFile.size)}</div>
              </div>
            </div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={()=>{
                const win=window.open();
                if(win){
                  win.document.write('<html><head><title>'+quote.attachFile.name+'</title><meta name="viewport" content="width=device-width,initial-scale=1"><style>body{margin:0;background:#525659;}embed{width:100vw;height:100vh;}</style></head><body><embed src="'+quote.attachFile.dataUrl+'" type="application/pdf"/></body></html>');
                  win.document.close();
                }
              }} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6,padding:"11px",borderRadius:10,border:`1px solid ${T.g2}`,background:T.wh,color:T.g7,fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:SYS}}>
                <i className="ti ti-zoom-in" style={{fontSize:15}} aria-hidden="true"/>Open & Zoom
              </button>
              <button onClick={()=>{
                saveFile(quote.attachFile.dataUrl, quote.attachFile.name||"document.pdf");
              }} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6,padding:"11px",borderRadius:10,border:"none",background:T.bl,color:T.wh,fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:SYS}}>
                <i className="ti ti-download" style={{fontSize:15}} aria-hidden="true"/>Download
              </button>
            </div>
          </div>
        }
      </div>}

      {quote.attachUrl&&<div style={{marginTop:14}}>
        <div style={{fontSize:11,fontWeight:700,color:T.g4,marginBottom:8,textTransform:"uppercase",letterSpacing:"0.06em"}}>Link</div>
        <a href={quote.attachUrl} target="_blank" rel="noreferrer" style={{display:"flex",alignItems:"center",gap:8,padding:"11px 14px",background:T.bll,borderRadius:12,border:`1px solid ${T.bl}`,textDecoration:"none"}}>
          <i className="ti ti-external-link" style={{fontSize:15,color:T.bl,flexShrink:0}} aria-hidden="true"/>
          <span style={{fontSize:12,fontWeight:700,color:T.bld,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{quote.attachUrl}</span>
        </a>
      </div>}

      {quote.notes&&<div style={{marginTop:14}}>
        <div style={{fontSize:11,fontWeight:700,color:T.g4,marginBottom:6,textTransform:"uppercase",letterSpacing:"0.06em"}}>Notes</div>
        <div style={{background:T.g05,borderRadius:10,padding:"10px 12px",fontSize:13,color:T.g7,lineHeight:1.6}}>{quote.notes}</div>
      </div>}
    </div>

    :<div>
      <FF label="Quote title *"><Inp value={f.title} onChange={e=>u("title",e.target.value)}/></FF>
      <FF label="Project"><select style={IS} value={f.projectId||""} onChange={e=>u("projectId",e.target.value)}><option value="">Select…</option>{data.projects.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}</select></FF>
      <FF label="Type"><div style={{display:"flex",gap:8}}>{["Labor","Materials","Labor & Materials","Mortgage"].map(tabOpt=><button key={tabOpt} onClick={()=>u("tab",tabOpt)} style={{flex:1,padding:"9px",borderRadius:10,border:`1.5px solid ${f.tab===tabOpt?T.bl:T.g2}`,background:f.tab===tabOpt?T.bl:T.wh,color:f.tab===tabOpt?T.wh:T.g6,fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:SYS}}>{tabOpt}</button>)}</div></FF>
      <FF label="Category"><Sel value={f.category||""} onChange={v=>u("category",v)} options={CATS} placeholder="Select…"/></FF>
      <FF label="Contact"><select style={IS} value={f.contactId||""} onChange={e=>handleContactChange(e.target.value)}><option value="">Select…</option>{data.contacts.map(c=><option key={c.id} value={c.id}>{c.firstName} {c.lastName}{c.company?` · ${c.company}`:""}</option>)}</select></FF>
      <FF label="Vendor">
        <select style={IS} value={f.vendorId||""} onChange={e=>u("vendorId",e.target.value)}>
          <option value="">Select vendor…</option>
          {data.vendors.map(v=><option key={v.id} value={v.id}>{v.name}</option>)}
        </select>
        {/* If vendorId set but not found in list, show warning */}
        {f.vendorId&&!data.vendors.find(v=>v.id===f.vendorId)&&vendor&&
          <div style={{marginTop:6,fontSize:11,color:T.am,display:"flex",alignItems:"center",gap:4}}>
            <i className="ti ti-alert-triangle" style={{fontSize:12}} aria-hidden="true"/>
            Previously: {vendor.name} — please re-select from the list
          </div>
        }
      </FF>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <FF label="Amount ($)"><Inp type="number" value={f.amount||""} onChange={e=>u("amount",e.target.value)}/></FF>
        <FF label="Status"><Sel value={f.status||""} onChange={v=>u("status",v)} options={QUOTE_ST}/></FF>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <FF label="Quote date"><input type="date" style={IS} value={f.quoteDate||""} onChange={e=>u("quoteDate",e.target.value)}/></FF>
        <FF label="Valid until"><input type="date" style={IS} value={f.validUntil||""} onChange={e=>u("validUntil",e.target.value)}/></FF>
      </div>
      {/* Attachment in edit mode */}
      <div style={{marginBottom:16}}>
        <label style={{display:"block",fontSize:11,fontWeight:800,color:T.g4,marginBottom:8,textTransform:"uppercase",letterSpacing:"0.05em"}}>Attachment</label>
        {f.attachFile&&<div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",background:T.grl,borderRadius:12,marginBottom:8,border:`1px solid ${T.gr}`}}>
          <i className="ti ti-file-filled" style={{fontSize:18,color:T.gr,flexShrink:0}} aria-hidden="true"/>
          <div style={{flex:1,minWidth:0}}><div style={{fontSize:13,fontWeight:700,color:"#166534",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{f.attachFile.name}</div></div>
          <button onClick={()=>u("attachFile",null)} style={{background:"none",border:"none",cursor:"pointer",color:"#166534",fontSize:16,padding:0}}>✕</button>
        </div>}
        {f.attachUrl&&!f.attachFile&&<div style={{display:"flex",alignItems:"center",gap:8,padding:"10px 14px",background:T.bll,borderRadius:12,marginBottom:8,border:`1px solid ${T.bl}`}}>
          <i className="ti ti-link" style={{fontSize:16,color:T.bl,flexShrink:0}} aria-hidden="true"/>
          <div style={{flex:1,minWidth:0,fontSize:12,color:T.bld,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{f.attachUrl}</div>
          <button onClick={()=>u("attachUrl","")} style={{background:"none",border:"none",cursor:"pointer",color:T.bl,fontSize:16,padding:0}}>✕</button>
        </div>}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
          <button onClick={()=>fileRef.current&&fileRef.current.click()} style={{display:"flex",alignItems:"center",justifyContent:"center",gap:6,padding:"10px",borderRadius:12,cursor:"pointer",fontFamily:SYS,border:`1.5px dashed ${T.g3}`,background:T.g05,color:T.g6,fontSize:12,fontWeight:700}}>
            <i className="ti ti-folder-open" style={{fontSize:15}} aria-hidden="true"/>{f.attachFile?"Replace File":"Browse Files"}
          </button>
          <button onClick={()=>{const url=prompt("Paste URL:");if(url?.trim())u("attachUrl",url.trim());}} style={{display:"flex",alignItems:"center",justifyContent:"center",gap:6,padding:"10px",borderRadius:12,cursor:"pointer",fontFamily:SYS,border:`1.5px dashed ${T.bl}`,background:T.bll,color:T.bld,fontSize:12,fontWeight:700}}>
            <i className="ti ti-link" style={{fontSize:15}} aria-hidden="true"/>Add URL
          </button>
        </div>
        <input ref={fileRef} type="file" accept="*/*" style={{display:"none"}} onChange={handleFile}/>
      </div>
      <FF label="Notes"><Txa value={f.notes||""} onChange={e=>u("notes",e.target.value)} rows={2}/></FF>
      <div style={{display:"flex",gap:10,marginTop:12}}>
        <Btn variant="secondary" onClick={()=>setEditing(false)} full>Cancel</Btn>
        <Btn icon="check" onClick={()=>{onUpdate&&onUpdate(quote.id,f);toast("Quote saved");setEditing(false);onClose();}} disabled={!f.title} full>Save Changes</Btn>
      </div>
    </div>}
  </Modal>;
}

/* ── RECEIPT / INVOICE SCANNER ── */
/* ── IMAGE COMPRESSION ── */
function compressImage(file, maxW=900, maxH=1400, quality=0.65){
  return new Promise((resolve)=>{
    // Non-image files (PDFs etc) — return as-is
    if(!file.type.startsWith("image/")){
      const r=new FileReader();
      r.onload=e=>resolve(e.target.result);
      r.readAsDataURL(file);
      return;
    }
    const img=new Image();
    const url=URL.createObjectURL(file);
    img.onload=()=>{
      URL.revokeObjectURL(url);
      let {width:w,height:h}=img;
      // Scale down if larger than max dimensions
      if(w>maxW){h=Math.round(h*(maxW/w));w=maxW;}
      if(h>maxH){w=Math.round(w*(maxH/h));h=maxH;}
      const canvas=document.createElement("canvas");
      canvas.width=w;canvas.height=h;
      const ctx=canvas.getContext("2d");
      ctx.drawImage(img,0,0,w,h);
      resolve(canvas.toDataURL("image/jpeg",quality));
    };
    img.onerror=()=>{
      // Fallback to FileReader if image fails
      const r=new FileReader();
      r.onload=e=>resolve(e.target.result);
      r.readAsDataURL(file);
    };
    img.src=url;
  });
}

function ReceiptScanner({onFilled,lang="en"}){
  const inputRef=useRef(null);
  const [st,setSt]=useState("idle");
  const [preview,setPreview]=useState(null);
  const [extracted,setExtracted]=useState(null);
  const [msg,setMsg]=useState("");
  const FIELDS=[
    {key:"name",label:"Description / Item"},
    {key:"vendorName",label:"Vendor / Supplier"},
    {key:"amount",label:"Total Amount"},
    {key:"date",label:lang==="es"?"Fecha":"Date"},
    {key:"invoiceNumber",label:lang==="es"?"N° Factura / Recibo":"Invoice / Receipt #"},
    {key:"category",label:"Category"},
    {key:"tax",label:"Tax Amount"},
    {key:"notes",label:"Notes / Details"},
  ];
  const scan=async(file)=>{
    if(!file)return;
    setSt("scanning");setMsg(lang==="es"?"Comprimiendo imagen…":"Compressing image…");
    try{
      // Compress before sending to AI and storing
      const dataUrl=await compressImage(file, 900, 1400, 0.65);
      setPreview(dataUrl);
      const b64=dataUrl.split(",")[1];
      const mediaType=dataUrl.startsWith("data:image/jpeg")?"image/jpeg":
                       dataUrl.startsWith("data:image/png")?"image/png":"image/jpeg";
      setMsg(lang==="es"?"Extrayendo datos con IA…":"Extracting expense details with AI…");
      const d=await callAIProxy({model:"claude-sonnet-4-5",max_tokens:600,
        messages:[{role:"user",content:[
          {type:"image",source:{type:"base64",media_type:mediaType,data:b64}},
          {type:"text",text:`Extract expense/invoice information from this receipt or invoice. Return ONLY valid JSON with these exact keys (empty string if not found):
{"name":"4-word max summary of what was purchased e.g. Home Depot Materials or Oscar Plumber Labor","vendorName":"company or store name","amount":"total amount as number only","date":"receipt or invoice date in YYYY-MM-DD format - look carefully for any date on the document","invoiceNumber":"invoice or receipt number","category":"one of: Plumbing, Electrical, Tiles, Paint, Kitchen, HVAC, Stone, Windows, Doors, Flooring, Cabinets, Countertops, Appliances, Hardware, Drywall, Framing, Roofing, Landscaping, Permits, General Contractor, Design, Labor, Materials, Other","tax":"tax amount as number only","notes":"full itemized list of all line items from receipt with quantities and prices","paymentMethod":"detect payment method from receipt: if Visa card look for last 4 digits and return Visa XXXX, if Mastercard return Mastercard XXXX, if Amex return Amex XXXX, if cash return Cash, if Zelle return Zelle, if bank transfer or ACH return Bank Transfer, if debit card return Debit XXXX with last 4 digits, otherwise empty string"}`}
        ]}]
      });
      const raw=(d.content?.[0]?.text||"{}");
      const jsonMatch=raw.match(/\{[\s\S]*\}/);
      const parsed=JSON.parse(jsonMatch?jsonMatch[0]:"{}");
      setExtracted(parsed);setSt("preview");
    }catch(err){
      console.error("Receipt scan error:",err.message);
      setSt("error");setMsg(`Error: ${err.message}`);
    }
  };
  const apply=()=>{
    if(!extracted)return;
    const patch={};
    Object.entries(extracted).forEach(([k,v])=>{if(v&&String(v).trim())patch[k]=String(v).trim();});
    if(preview) patch.receiptPreview=preview;
    onFilled(patch);setSt("done");
    setTimeout(()=>{setSt("idle");setPreview(null);setExtracted(null);},1200);
  };
  return <div style={{marginBottom:16}}>
    <input ref={inputRef} type="file" accept="image/*,application/pdf" capture="environment" style={{display:"none"}} onChange={e=>scan(e.target.files?.[0])}/>
    {st==="idle"&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
      <button onClick={()=>inputRef.current&&inputRef.current.click()} style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,padding:"13px",borderRadius:12,cursor:"pointer",fontFamily:SYS,border:`2px dashed ${T.gr}`,background:T.grl,color:"#166534",fontSize:13,fontWeight:700}}>
        <i className="ti ti-camera" style={{fontSize:18}} aria-hidden="true"/>{lang==="es"?"Tomar Foto":"Take Photo"}
      </button>
      <button onClick={()=>{if(inputRef.current){inputRef.current.removeAttribute("capture");inputRef.current.click();setTimeout(()=>inputRef.current&&inputRef.current.setAttribute("capture","environment"),500);}}} style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,padding:"13px",borderRadius:12,cursor:"pointer",fontFamily:SYS,border:`2px dashed ${T.bl}`,background:T.bll,color:T.bld,fontSize:13,fontWeight:700}}>
        <i className="ti ti-upload" style={{fontSize:18}} aria-hidden="true"/>{lang==="es"?"Subir Archivo":"Upload File"}
      </button>
    </div>}
    {st==="scanning"&&<div style={{borderRadius:12,border:`1.5px solid ${T.gr}`,background:T.grl,padding:"16px",textAlign:"center"}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:10}}>
        <div style={{width:18,height:18,borderRadius:"50%",border:`2.5px solid ${T.gr}`,borderTopColor:"transparent",animation:"spin .7s linear infinite"}}/>
        <div style={{fontSize:13,fontWeight:700,color:"#166534"}}>{msg}</div>
      </div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>}
    {st==="preview"&&extracted&&<div style={{borderRadius:12,border:`1.5px solid ${T.gr}`,overflow:"hidden",background:T.wh}}>
      {preview&&<div style={{position:"relative"}}>
        <img src={preview} alt="receipt" style={{width:"100%",maxHeight:140,objectFit:"cover",display:"block",filter:"brightness(.95)"}}/>
        <div style={{position:"absolute",inset:0,background:"linear-gradient(to bottom,transparent 40%,rgba(0,0,0,.5))"}}/>
        <div style={{position:"absolute",bottom:10,left:12,display:"flex",alignItems:"center",gap:6}}>
          <div style={{width:18,height:18,borderRadius:"50%",background:T.gr,display:"flex",alignItems:"center",justifyContent:"center"}}><i className="ti ti-check" style={{fontSize:10,color:T.wh}} aria-hidden="true"/></div>
          <span style={{fontSize:12,fontWeight:700,color:T.wh}}>{Object.values(extracted).filter(v=>v&&String(v).trim()).length} fields detected</span>
        </div>
      </div>}
      <div style={{padding:"12px 14px"}}>
        <div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginBottom:8}}>EXTRACTED INFORMATION</div>
        {FIELDS.map(({key,label})=>{
          const val=extracted[key];const has=val&&String(val).trim();
          return <div key={key} style={{display:"flex",alignItems:"center",gap:8,padding:"5px 0",borderBottom:`1px solid ${T.g15}`}}>
            <i className={`ti ti-${has?"circle-check":"circle-dashed"}`} style={{fontSize:14,color:has?T.gr:T.g3,flexShrink:0}} aria-hidden="true"/>
            <span style={{fontSize:11,color:T.g4,width:130,flexShrink:0}}>{label}</span>
            <span style={{fontSize:12,fontWeight:has?600:400,color:has?T.g9:T.g3,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{has||"—"}</span>
          </div>;
        })}
        <div style={{display:"flex",gap:8,marginTop:12}}>
          <Btn variant="secondary" size="sm" onClick={()=>{setSt("idle");setPreview(null);setExtracted(null);}} full>Retake</Btn>
          <Btn size="sm" icon="arrow-right" onClick={apply} full>Fill Form</Btn>
        </div>
      </div>
    </div>}
    {st==="error"&&<div style={{borderRadius:12,border:`1.5px solid ${T.rd}`,background:T.rdl,padding:"12px 14px",display:"flex",gap:10,alignItems:"center"}}>
      <i className="ti ti-alert-circle" style={{fontSize:18,color:T.rd,flexShrink:0}} aria-hidden="true"/>
      <span style={{fontSize:13,color:"#B91C1C",flex:1}}>{msg}</span>
      <Btn variant="secondary" size="sm" onClick={()=>setSt("idle")}>Retry</Btn>
    </div>}
    {st==="done"&&<div style={{borderRadius:12,border:`1.5px solid ${T.gr}`,background:T.grl,padding:"11px 14px",display:"flex",alignItems:"center",gap:8}}>
      <i className="ti ti-circle-check" style={{fontSize:18,color:T.gr}} aria-hidden="true"/>
      <span style={{fontSize:13,fontWeight:700,color:"#166534"}}>Fields filled! Review and complete below.</span>
    </div>}
  </div>;
}


const DEFAULT_ACCOUNTS=["KARP Concept","ALOF","Med2u INC","SAV Amex"];
function getAccounts(){
  try{const s=localStorage.getItem("karp_accounts");return s?JSON.parse(s):DEFAULT_ACCOUNTS;}
  catch{return DEFAULT_ACCOUNTS;}
}
function saveAccount(name){
  const accs=getAccounts();
  if(!accs.includes(name)){accs.push(name);try{localStorage.setItem("karp_accounts",JSON.stringify(accs));}catch{}}
}

function ExpenseForm({data,onSave,onClose,onAddVendor,lang="en",isReturn=false}){
  const t=TR[lang]||TR.en;
  const [f,sf]=useState({name:"",projectId:"",tab:"Labor",category:"",vendorId:"",vendorName:"",amount:"",date:new Date().toISOString().slice(0,10),paymentStatus:"Unpaid",invoiceNumber:"",tax:"",notes:"",receiptPreview:null,paymentMethod:"",account:""});
  const u=(k,v)=>sf(p=>({...p,[k]:v}));

  const handleScan=(patch)=>{
    sf(prev=>{
      const next={...prev};
      if(patch.name)next.name=patch.name;
      if(patch.amount)next.amount=patch.amount;
      if(patch.date&&patch.date.match(/^\d{4}-\d{2}-\d{2}$/))next.date=patch.date;
      if(patch.invoiceNumber)next.invoiceNumber=patch.invoiceNumber;
      if(patch.tax)next.tax=patch.tax;
      if(patch.notes)next.notes=patch.notes;
      if(patch.category&&CATS.includes(patch.category))next.category=patch.category;
      // Auto-set Paid when scanned from receipt
      next.paymentStatus="Paid";
      if(patch.receiptPreview) next.receiptPreview=patch.receiptPreview;
      if(patch.paymentMethod) next.paymentMethod=patch.paymentMethod;
      if(patch.vendorName){
        next.vendorName=patch.vendorName;
        const vn=patch.vendorName.toLowerCase();
        const matched=data.vendors.find(v=>
          v.name.toLowerCase()===vn||
          v.name.toLowerCase().includes(vn)||
          vn.includes(v.name.toLowerCase())
        );
        if(matched){
          next.vendorId=matched.id;
          next.vendorName="";
        }else{
          // Auto-create vendor and set it immediately
          const tempId=`tmp_${Date.now()}_${Math.random().toString(36).slice(2)}`;
          const newVendor={id:tempId,name:patch.vendorName,phone:"",email:"",address:"",notes:"Auto-created from receipt scan"};
          onAddVendor&&onAddVendor(newVendor);
          next.vendorId=tempId;
          next.vendorName=patch.vendorName;
          next._newVendor=newVendor; // store locally for dropdown
        }
      }
      return next;
    });
  };

  return <div>
    {/* Return mode indicator */}
    {isReturn&&<div style={{display:"flex",alignItems:"center",gap:10,background:"rgba(52,199,89,.12)",border:"1px solid rgba(52,199,89,.35)",borderRadius:12,padding:"12px 14px",marginBottom:16}}>
      <i className="ti ti-arrow-back-up" style={{fontSize:20,color:T.gr,flexShrink:0}} aria-hidden="true"/>
      <div>
        <div style={{fontSize:13,fontWeight:700,color:"#166534"}}>{lang==="es"?"Modo Devolución":"Return Mode"}</div>
        <div style={{fontSize:11,color:"#166834",opacity:.8}}>{lang==="es"?"El monto se restará del total del proyecto":"Amount will be subtracted from project total"}</div>
      </div>
    </div>}
    {/* Scanner section */}
    <div style={{background:T.g05,borderRadius:14,padding:"14px",marginBottom:16,border:`1px solid ${T.g15}`}}>
      <div style={{fontSize:11,fontWeight:800,color:T.g4,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:10,display:"flex",alignItems:"center",gap:6}}>
        <i className="ti ti-scan" style={{fontSize:14}} aria-hidden="true"/>
        {lang==="es"?"Escanear Recibo (IA)":"Scan Receipt or Invoice (AI Auto-Fill)"}
      </div>
      <ReceiptScanner onFilled={handleScan} lang={lang}/>
    </div>

    {/* Divider */}
    <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
      <div style={{flex:1,height:1,background:T.g15}}/>
      <span style={{fontSize:11,fontWeight:700,color:T.g4,textTransform:"uppercase",letterSpacing:"0.07em"}}>{lang==="es"?"O llenar manualmente":"Or fill in manually"}</span>
      <div style={{flex:1,height:1,background:T.g15}}/>
    </div>

    {/* Project assignment — prominent */}
    <div style={{background:T.bll,borderRadius:12,padding:"12px 14px",marginBottom:16,border:`1px solid #C0D8F8`}}>
      <div style={{fontSize:11,fontWeight:800,color:T.bld,letterSpacing:"0.07em",textTransform:"uppercase",marginBottom:8,display:"flex",alignItems:"center",gap:5}}>
        <i className="ti ti-building" style={{fontSize:13}} aria-hidden="true"/>{lang==="es"?"Asignar a Proyecto":"Assign to Project"}
      </div>
      <select style={{...IS,borderColor:T.bl}} value={f.projectId} onChange={e=>u("projectId",e.target.value)}>
        <option value="">{lang==="es"?"— Sin proyecto —":"— No project selected —"}</option>
        {data.projects.map(p=><option key={p.id} value={p.id}>{p.name}{p.address?` · ${p.address}`:""}</option>)}
      </select>
      <div style={{marginTop:10}}>
        <div style={{fontSize:11,fontWeight:800,color:T.bld,letterSpacing:"0.07em",textTransform:"uppercase",marginBottom:6}}>{lang==="es"?"Tipo":"Type"}</div>
        <div style={{display:"flex",gap:8}}>
          {[t.labor,t.materials,t.mortgage].map(tt=><button key={tt} onClick={()=>u("tab",tt)} style={{flex:1,padding:"9px",borderRadius:8,border:`1.5px solid ${f.tab===tt?T.bl:T.g2}`,background:f.tab===tt?T.bl:T.wh,color:f.tab===tt?T.wh:T.g6,fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:SYS,transition:"all .15s"}}>{tt}</button>)}
        </div>
      </div>
    </div>

    <FF label={lang==="es"?"Descripción del gasto *":"Expense description *"}><Inp value={f.name} onChange={e=>u("name",e.target.value)} placeholder={lang==="es"?"ej. Materiales de instalación":"e.g. Tile installation materials"}/></FF>

    {/* Category chip picker — prominent, right after description */}
    <div style={{marginBottom:16}}>
      <label style={{display:"block",fontSize:11,fontWeight:800,color:T.g4,marginBottom:10,textTransform:"uppercase",letterSpacing:"0.07em"}}>
        {lang==="es"?"Categoría de Gasto ":"Expense Category "}<span style={{color:T.rd}}>*</span>
      </label>
      <div style={{display:"flex",flexWrap:"wrap",gap:7}}>
        {CATS.map(cat=>{
          const act=f.category===cat;
          const icons={
            "Plumbing":"droplet","Electrical":"bolt","Tiles":"grid-dots","Paint":"brush",
            "Kitchen":"tools-kitchen","HVAC":"air-conditioning","Stone":"mountain","Windows":"window",
            "Doors":"door","Flooring":"layout-board","Cabinets":"box","Countertops":"minus",
            "Appliances":"washing-machine","Hardware":"tool","Drywall":"square","Framing":"border-all",
            "Roofing":"home-2","Landscaping":"trees","Permits":"file-certificate",
            "General Contractor":"hard-hat","Labor":"user-cog","Materials":"package","Other":"dots-circle-horizontal"
          };
          return <button key={cat} onClick={()=>u("category",act?"":cat)} style={{
            display:"flex",alignItems:"center",gap:5,
            padding:"7px 12px",borderRadius:999,cursor:"pointer",
            border:`1.5px solid ${act?T.or:T.g2}`,
            background:act?T.or:T.wh,
            color:act?T.wh:T.g6,
            fontSize:12,fontWeight:act?700:500,
            fontFamily:SYS,transition:"all .15s",
          }}>
            <i className={`ti ti-${icons[cat]||"tag"}`} style={{fontSize:13}} aria-hidden="true"/>
            {cat}
          </button>;
        })}
      </div>
      {f.category&&<div style={{display:"flex",alignItems:"center",gap:6,marginTop:8,padding:"7px 12px",borderRadius:8,background:T.orl,fontSize:12,fontWeight:700,color:T.or}}>
        <i className="ti ti-check" style={{fontSize:13}} aria-hidden="true"/>
        {lang==="es"?"Seleccionado: ":"Selected: "}<strong>{f.category}</strong>
      </div>}
    </div>

    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
      <FF label={lang==="es"?"Monto ($) *":"Amount ($) *"}><Inp type="number" value={f.amount} onChange={e=>u("amount",e.target.value)} placeholder="0.00"/></FF>
      <FF label={lang==="es"?"Impuesto ($)":"Tax ($)"}><Inp type="number" value={f.tax} onChange={e=>u("tax",e.target.value)} placeholder="0.00"/></FF>
    </div>
    <FF label={lang==="es"?"Fecha":"Date"}><input type="date" style={IS} value={f.date} onChange={e=>u("date",e.target.value)}/></FF>

    {f.amount&&f.tax&&<div style={{background:T.g05,borderRadius:8,padding:"8px 12px",marginTop:-6,marginBottom:12,fontSize:13,color:T.g7,display:"flex",justifyContent:"space-between"}}>
      <span>{lang==="es"?"Total con impuesto":"Total incl. tax"}</span>
      <span style={{fontWeight:800,color:T.g9}}>${(Number(f.amount)+Number(f.tax)).toFixed(2)}</span>
    </div>}

    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
      <FF label={lang==="es"?"Estado de pago":"Payment status"}><Sel value={f.paymentStatus} onChange={v=>u("paymentStatus",v)} options={PAY_ST}/></FF>
      <FF label={lang==="es"?"Método de Pago *":"Payment Method *"}>
        <select style={IS} value={f.paymentMethod} onChange={e=>{
          const v=e.target.value;
          if(v==="Visa"||v==="Mastercard"||v==="Amex"){
            const last4=window.prompt(lang==="es"?`Últimos 4 dígitos de ${v}:`:`Last 4 digits of ${v}:`);
            if(last4&&/^\d{4}$/.test(last4)) u("paymentMethod",v+" "+last4);
            else if(last4!==null) u("paymentMethod",v);
          }else{
            u("paymentMethod",v);
          }
        }}>
          <option value="">{lang==="es"?"Seleccionar…":"Select…"}</option>
          <option value="Cash">{lang==="es"?"Efectivo":"Cash"}</option>
          <option value="Zelle">Zelle</option>
          <option value="Bank Transfer">{lang==="es"?"Transferencia":"Bank Transfer"}</option>
          <option value="Visa">Visa</option>
          <option value="Mastercard">Mastercard</option>
          <option value="Amex">Amex</option>
          {f.paymentMethod&&f.paymentMethod.includes(" ")&&<option value={f.paymentMethod}>{f.paymentMethod}</option>}
        </select>
        {f.paymentMethod&&f.receiptPreview&&<div style={{marginTop:4,fontSize:11,color:T.gr,fontWeight:600,display:"flex",alignItems:"center",gap:4}}>
          <i className="ti ti-circle-check" style={{fontSize:12}} aria-hidden="true"/>
          {lang==="es"?"Auto-detectado del recibo":"Auto-detected from receipt"}
        </div>}
      </FF>
    </div>

    {/* Account field — only for Cash, Zelle, Bank Transfer */}
    {["Cash","Zelle","Bank Transfer"].some(m=>f.paymentMethod===m||f.paymentMethod?.startsWith(m))&&<AccountField
      lang={lang} value={f.account} onChange={v=>u("account",v)}
    />}

    <FF label={lang==="es"?"N° Factura / Recibo":"Invoice / Receipt #"}><Inp value={f.invoiceNumber} onChange={e=>u("invoiceNumber",e.target.value)} placeholder="INV-0001"/></FF>

    <FF label={lang==="es"?"Proveedor":"Vendor"}>
      <select style={IS} value={f.vendorId} onChange={e=>u("vendorId",e.target.value)}>
        <option value="">{lang==="es"?"Seleccionar proveedor…":"Select vendor…"}</option>
        {data.vendors.map(v=><option key={v.id} value={v.id}>{v.name}</option>)}
        {/* Show newly created vendor immediately before Supabase syncs */}
        {f._newVendor&&!data.vendors.find(v=>v.id===f._newVendor.id)&&
          <option key={f._newVendor.id} value={f._newVendor.id}>{f._newVendor.name}</option>}
      </select>
    </FF>

    {/* Confirmed auto-created vendor notice */}
    {f._newVendor&&f.vendorId===f._newVendor.id&&<div style={{marginTop:-8,marginBottom:12,padding:"8px 12px",borderRadius:8,background:T.grl,fontSize:12,color:"#166534",display:"flex",gap:6,alignItems:"center"}}>
      <i className="ti ti-circle-check" style={{fontSize:14,flexShrink:0}} aria-hidden="true"/>
      {lang==="es"?"Proveedor creado automáticamente:":"Auto-created vendor:"} <strong>{f._newVendor.name}</strong>
    </div>}

    <FF label="Notes"><Txa value={f.notes} onChange={e=>u("notes",e.target.value)} placeholder={lang==="es"?"Detalles adicionales, notas del sitio…":"Additional details, job site notes…"} rows={2}/></FF>

    {/* Summary preview before saving */}
    {f.name&&f.amount&&<div style={{background:T.g05,borderRadius:12,padding:"12px 14px",marginBottom:4,border:`1px solid ${T.g15}`}}>
      <div style={{fontSize:11,fontWeight:800,color:T.g4,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:8}}>{lang==="es"?"Resumen":"Summary"}</div>
      <div style={{display:"flex",justifyContent:"space-between",fontSize:13}}>
        <span style={{color:T.g7}}>{f.name}</span>
        <span style={{fontWeight:800,color:T.g9,fontSize:16}}>${Number(f.amount).toFixed(2)}</span>
      </div>
      {f.projectId&&<div style={{fontSize:12,color:T.g4,marginTop:3}}>
        {data.projects.find(p=>p.id===f.projectId)?.name} · {f.tab}
        {f.category&&` · ${f.category}`}
      </div>}
    </div>}

    <div style={{display:"flex",gap:10,marginTop:12}}>
      <Btn variant="secondary" onClick={onClose} full>Cancel</Btn>
      <Btn icon="receipt" onClick={()=>onSave(f)} disabled={!f.name||!f.amount||!f.paymentMethod||(["Cash","Zelle","Bank Transfer"].some(m=>f.paymentMethod===m||f.paymentMethod?.startsWith(m))&&!f.account&&f.account!=="__other__")} full>{isReturn?(lang==="es"?"Guardar Devolución":"Save Return"):(lang==="es"?"Guardar Gasto":"Save Expense")}</Btn>
    </div>
  </div>;
}

/* ── ACCOUNT FIELD (reusable) ── */
function AccountField({lang,value,onChange}){
  const [accounts,setAccounts]=useState(()=>getAccounts());
  const [custom,setCustom]=useState("");
  return <div style={{marginBottom:14}}>
    <div style={{fontSize:11,fontWeight:700,color:T.g4,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:8}}>{lang==="es"?"Cuenta *":"Account *"}</div>
    <select style={IS} value={value==="__other__"?"__other__":value} onChange={e=>{
      if(e.target.value==="__other__") onChange("__other__");
      else onChange(e.target.value);
    }}>
      <option value="">{lang==="es"?"Seleccionar cuenta…":"Select account…"}</option>
      {accounts.map(a=><option key={a} value={a}>{a}</option>)}
      <option value="__other__">{lang==="es"?"Otra (escribir)…":"Other (type)…"}</option>
    </select>
    {value==="__other__"&&<div style={{marginTop:8,display:"flex",gap:8}}>
      <input
        style={{...IS,flex:1}}
        placeholder={lang==="es"?"Nombre de la cuenta…":"Account name…"}
        value={custom}
        onChange={e=>setCustom(e.target.value)}
        autoFocus
      />
      <button onClick={()=>{
        if(!custom.trim()) return;
        const name=custom.trim();
        saveAccount(name);
        setAccounts(getAccounts());
        onChange(name);
        setCustom("");
      }} style={{background:T.bl,color:T.wh,border:"none",borderRadius:10,padding:"0 14px",fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:SYS,flexShrink:0}}>
        {lang==="es"?"Guardar":"Save"}
      </button>
    </div>}
  </div>;
}

/* ── EXPENSE DETAIL / EDIT MODAL ── */
function ExpenseDetailModal({expense,data,onClose,onUpdate,onDelete,lang="en"}){
  const t=TR[lang]||TR.en;
  const [editing,setEditing]=useState(false);
  const [f,sf]=useState({...expense});
  const [confirmDel,setConfirmDel]=useState(false);
  const u=(k,v)=>sf(p=>({...p,[k]:v}));
  const vendor=data.vendors.find(x=>x.id===expense.vendorId);
  const project=data.projects.find(x=>x.id===expense.projectId);

  const icons={
    "Plumbing":"droplet","Electrical":"bolt","Tiles":"grid-dots","Paint":"brush",
    "Kitchen":"tools-kitchen","HVAC":"air-conditioning","Stone":"mountain","Windows":"window",
    "Doors":"door","Flooring":"layout-board","Cabinets":"box","Countertops":"minus",
    "Appliances":"washing-machine","Hardware":"tool","Drywall":"square","Framing":"border-all",
    "Roofing":"home-2","Landscaping":"trees","Permits":"file-certificate",
    "General Contractor":"hard-hat","Labor":"user-cog","Materials":"package","Other":"dots-circle-horizontal"
  };

  return <Modal title={editing?t.editExpense:expense.name} onClose={onClose} width={580}>
    {confirmDel&&<ConfirmDelete label={expense.name} onConfirm={()=>{onDelete&&onDelete(expense.id);onClose();}} onCancel={()=>setConfirmDel(false)}/>}

    {!editing?<div>
      {/* Action buttons */}
      <div style={{display:"flex",gap:8,marginBottom:16}}>
        <button onClick={()=>setConfirmDel(true)} style={{flex:1,padding:"11px",borderRadius:999,border:`1px solid ${T.rd}`,background:T.rdl,color:T.rd,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:SYS,display:"flex",alignItems:"center",justifyContent:"center",gap:4}}>
          <i className="ti ti-trash" style={{fontSize:13}} aria-hidden="true"/>Delete
        </button>
        <button onClick={()=>{sf({...expense});setEditing(true);}} style={{flex:2,padding:"11px",borderRadius:999,border:"none",background:T.bl,color:T.wh,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:SYS,display:"flex",alignItems:"center",justifyContent:"center",gap:4}}>
          <i className="ti ti-pencil" style={{fontSize:13}} aria-hidden="true"/>Edit Expense
        </button>
      </div>

      {/* Amount + status header */}
      <div style={{background:`linear-gradient(135deg,${T.g9},${T.g8})`,borderRadius:16,padding:"16px",marginBottom:16,color:T.wh}}>
        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10,flexWrap:"wrap"}}>
          <Badge status={expense.paymentStatus}/>
          {expense.tab&&<span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:6,background:"rgba(255,255,255,.15)",color:T.wh}}>{expense.tab}</span>}
          {expense.category&&<span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:6,background:"rgba(255,255,255,.15)",color:T.wh,display:"flex",alignItems:"center",gap:4}}>
            <i className={`ti ti-${icons[expense.category]||"tag"}`} style={{fontSize:11}} aria-hidden="true"/>{expense.category}
          </span>}
        </div>
        <div style={{fontSize:28,fontWeight:800}}>${Number(expense.amount).toLocaleString()}</div>
        {expense.tax&&<div style={{fontSize:12,color:T.g4,marginTop:4}}>+ ${Number(expense.tax).toLocaleString()} tax = ${(Number(expense.amount)+Number(expense.tax)).toFixed(2)} total</div>}
      </div>

      {/* Details */}
      {[
        {icon:"building",label:lang==="es"?"Proyecto":"Project",val:project?.name},
        {icon:"tag",label:lang==="es"?"Tipo":"Type",val:expense.tab},
        {icon:"category",label:lang==="es"?"Categoría":"Category",val:expense.category},
        {icon:"briefcase",label:lang==="es"?"Proveedor":"Vendor",val:vendor?.name},
        {icon:"calendar",label:lang==="es"?"Fecha":"Date",val:expense.date},
        {icon:"credit-card",label:lang==="es"?"Método de Pago":"Payment Method",val:expense.paymentMethod},
        {icon:"building-bank",label:lang==="es"?"Cuenta":"Account",val:expense.account&&expense.account!=="__other__"?expense.account:null},
        {icon:"receipt",label:lang==="es"?"N° Factura / Recibo":"Invoice / Receipt #",val:expense.invoiceNumber},
      ].filter(r=>r.val).map(r=><div key={r.label} style={{display:"flex",gap:10,padding:"10px 0",borderBottom:`1px solid ${T.g15}`}}>
        <div style={{width:26,height:26,borderRadius:8,background:T.g1,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ti-${r.icon}`} style={{fontSize:13,color:T.g5}} aria-hidden="true"/>
        </div>
        <div><div style={{fontSize:10,color:T.g4,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.05em"}}>{r.label}</div><div style={{fontSize:13,color:T.g9,fontWeight:600,marginTop:1}}>{r.val}</div></div>
      </div>)}

      {expense.notes&&<div style={{marginTop:14}}>
        <div style={{fontSize:11,fontWeight:700,color:T.g4,marginBottom:6,textTransform:"uppercase",letterSpacing:"0.06em"}}>{t.notes||"Notes"}</div>
        <div style={{background:T.g05,borderRadius:10,padding:"10px 12px",fontSize:13,color:T.g7,lineHeight:1.6}}>{expense.notes}</div>
      </div>}

      {/* Receipt preview button — only shown if receipt image was scanned */}
      {expense.receiptPreview&&<div style={{marginTop:18}}>
        <div style={{fontSize:11,fontWeight:700,color:T.g4,marginBottom:8,textTransform:"uppercase",letterSpacing:"0.06em"}}>{lang==="es"?"RECIBO":"RECEIPT"}</div>
        <button onClick={()=>{
          const win=window.open();
          if(win){
            win.document.write('<html><head><title>Receipt</title><meta name="viewport" content="width=device-width,initial-scale=1"><style>body{margin:0;background:#000;display:flex;align-items:center;justify-content:center;min-height:100vh;}img{max-width:100%;height:auto;}</style></head><body><img src="'+expense.receiptPreview+'"/></body></html>');
            win.document.close();
          }
        }} style={{
          width:"100%",
          display:"flex",alignItems:"center",justifyContent:"center",gap:10,
          padding:"14px",
          background:`linear-gradient(135deg,${T.g9} 0%,${T.g8} 100%)`,
          border:"none",borderRadius:14,
          color:T.wh,fontSize:14,fontWeight:700,
          cursor:"pointer",fontFamily:SYS,
          boxShadow:"0 4px 16px rgba(0,0,0,.2)",
        }}>
          <i className="ti ti-eye" style={{fontSize:18}} aria-hidden="true"/>
          {lang==="es"?"Ver Recibo":"View Receipt"}
        </button>
        {/* Thumbnail preview */}
        <div style={{marginTop:10,borderRadius:12,overflow:"hidden",border:`1px solid ${T.g15}`,maxHeight:180,display:"flex",alignItems:"center",justifyContent:"center",background:T.g05}}>
          <img src={expense.receiptPreview} alt="Receipt" style={{width:"100%",objectFit:"cover",display:"block"}}/>
        </div>
      </div>}
    </div>

    :<div>
      <FF label={lang==="es"?"Descripción *":"Description *"}><Inp value={f.name||""} onChange={e=>u("name",e.target.value)}/></FF>

      {/* Project + Type */}
      <div style={{background:T.bll,borderRadius:14,padding:"12px 14px",marginBottom:14,border:`1.5px solid ${T.bld}22`}}>
        <div style={{fontSize:11,fontWeight:800,color:T.bl,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:8,display:"flex",alignItems:"center",gap:6}}>
          <i className="ti ti-building" style={{fontSize:13}} aria-hidden="true"/>
          {lang==="es"?"Asignar a Proyecto":"Assign to Project"}
        </div>
        <select style={IS} value={f.projectId||""} onChange={e=>u("projectId",e.target.value)}>
          <option value="">{lang==="es"?"— Sin proyecto —":"— No project selected —"}</option>
          {data.projects.map(p=><option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
        <div style={{fontSize:11,fontWeight:800,color:T.bl,textTransform:"uppercase",letterSpacing:"0.07em",margin:"10px 0 8px"}}>
          {lang==="es"?"Tipo":"Type"}
        </div>
        <div style={{display:"flex",gap:8}}>
          {[t.labor,t.materials,t.mortgage].map(tt=><button key={tt} onClick={()=>u("tab",tt)} style={{flex:1,padding:"9px",borderRadius:10,border:`1.5px solid ${f.tab===tt?T.bl:T.g2}`,background:f.tab===tt?T.bl:T.wh,color:f.tab===tt?T.wh:T.g6,fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:SYS}}>{tt}</button>)}
        </div>
      </div>

      {/* Category chips */}
      <div style={{marginBottom:14}}>
        <div style={{fontSize:11,fontWeight:700,color:T.g4,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:8}}>
          {lang==="es"?"Categoría":"Category"}
        </div>
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {CATS.map(cat=><button key={cat} onClick={()=>u("category",cat===f.category?"":cat)} style={{padding:"5px 11px",borderRadius:999,fontSize:11,fontWeight:600,cursor:"pointer",border:`1.5px solid ${f.category===cat?T.or:T.g2}`,background:f.category===cat?T.or:T.wh,color:f.category===cat?T.wh:T.g6,fontFamily:SYS}}>{cat}</button>)}
        </div>
      </div>

      {/* Amount + Tax */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <FF label={lang==="es"?"Monto ($) *":"Amount ($) *"}><Inp type="number" value={f.amount||""} onChange={e=>u("amount",e.target.value)} placeholder="0.00"/></FF>
        <FF label={lang==="es"?"Impuesto ($)":"Tax ($)"}><Inp type="number" value={f.tax||""} onChange={e=>u("tax",e.target.value)} placeholder="0.00"/></FF>
      </div>
      <FF label={lang==="es"?"Fecha":"Date"}><input type="date" style={IS} value={f.date||""} onChange={e=>u("date",e.target.value)}/></FF>

      {/* Payment status + method */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
        <FF label={lang==="es"?"Estado de pago":"Payment status"}><Sel value={f.paymentStatus||"Unpaid"} onChange={v=>u("paymentStatus",v)} options={PAY_ST}/></FF>
        <FF label={lang==="es"?"Método de Pago":"Payment Method"}>
          <select style={IS} value={f.paymentMethod||""} onChange={e=>{
            const v=e.target.value;
            if(v==="Visa"||v==="Mastercard"||v==="Amex"){
              const last4=window.prompt(lang==="es"?`Últimos 4 dígitos de ${v}:`:`Last 4 digits of ${v}:`);
              if(last4&&/^\d{4}$/.test(last4)) u("paymentMethod",v+" "+last4);
              else if(last4!==null) u("paymentMethod",v);
            }else{u("paymentMethod",v);}
          }}>
            <option value="">{lang==="es"?"Seleccionar…":"Select…"}</option>
            <option value="Cash">{lang==="es"?"Efectivo":"Cash"}</option>
            <option value="Zelle">Zelle</option>
            <option value="Bank Transfer">{lang==="es"?"Transferencia":"Bank Transfer"}</option>
            <option value="Visa">Visa</option>
            <option value="Mastercard">Mastercard</option>
            <option value="Amex">Amex</option>
            {f.paymentMethod&&f.paymentMethod.includes(" ")&&<option value={f.paymentMethod}>{f.paymentMethod}</option>}
          </select>
        </FF>
      </div>

      {/* Account — only for Cash/Zelle/Bank Transfer */}
      {["Cash","Zelle","Bank Transfer"].some(m=>(f.paymentMethod||"")===m||(f.paymentMethod||"").startsWith(m))&&<AccountField
        lang={lang} value={f.account||""} onChange={v=>u("account",v)}
      />}

      <FF label={lang==="es"?"N° Factura":"Invoice #"}><Inp value={f.invoiceNumber||""} onChange={e=>u("invoiceNumber",e.target.value)} placeholder="INV-0001"/></FF>

      <FF label={lang==="es"?"Proveedor":"Vendor"}>
        <select style={IS} value={f.vendorId||""} onChange={e=>u("vendorId",e.target.value)}>
          <option value="">{lang==="es"?"Seleccionar proveedor…":"Select vendor…"}</option>
          {data.vendors.map(v=><option key={v.id} value={v.id}>{v.name}</option>)}
        </select>
      </FF>

      <FF label={lang==="es"?"Notas":"Notes"}><Txa value={f.notes||""} onChange={e=>u("notes",e.target.value)} placeholder={lang==="es"?"Detalles adicionales…":"Additional details…"} rows={2}/></FF>

      <div style={{display:"flex",gap:10,marginTop:12}}>
        <Btn variant="secondary" onClick={()=>setEditing(false)} full>{lang==="es"?"Cancelar":"Cancel"}</Btn>
        <Btn icon="check" onClick={()=>{onUpdate&&onUpdate(expense.id,f);toast("Expense saved");setEditing(false);onClose();}} disabled={!f.name||!f.amount||!f.paymentMethod||(["Cash","Zelle","Bank Transfer"].some(m=>(f.paymentMethod||"")===m||(f.paymentMethod||"").startsWith(m))&&!(f.account||"")&&(f.account||"")!=="__other__")} full>{lang==="es"?"Guardar Cambios":"Save Changes"}</Btn>
      </div>
    </div>}
  </Modal>;
}

/* ── VIEWS ── */
const fmt=n=>"$"+Math.round(n).toLocaleString();

/* ── QUICK PREVIEW CONTENT COMPONENTS ── */
function ExpensePreviewContent({expense,data,lang}){
  const vendor=data.vendors.find(x=>x.id===expense.vendorId);
  const project=data.projects.find(x=>x.id===expense.projectId);
  const isReturn=Number(expense.amount)<0;
  const rows=[
    {icon:"building",label:lang==="es"?"Proyecto":"Project",val:project?.name},
    {icon:"tag",label:lang==="es"?"Tipo":"Type",val:expense.tab},
    {icon:"category",label:lang==="es"?"Categoría":"Category",val:expense.category},
    {icon:"briefcase",label:lang==="es"?"Proveedor":"Vendor",val:vendor?.name},
    {icon:"calendar",label:lang==="es"?"Fecha":"Date",val:expense.date},
    {icon:"credit-card",label:lang==="es"?"Método de Pago":"Payment Method",val:expense.paymentMethod},
    {icon:"building-bank",label:lang==="es"?"Cuenta":"Account",val:expense.account&&expense.account!=="__other__"?expense.account:null},
    {icon:"receipt",label:lang==="es"?"N° Factura":"Invoice #",val:expense.invoiceNumber},
    {icon:"coin",label:lang==="es"?"Estado de Pago":"Payment Status",val:expense.paymentStatus},
  ].filter(r=>r.val);
  return <div>
    <div style={{background:`linear-gradient(135deg,${isReturn?T.gr:T.or},${isReturn?"#166534":"#7A2700"})`,borderRadius:14,padding:"16px",marginBottom:16,color:T.wh}}>
      <div style={{fontSize:11,fontWeight:700,opacity:.7,marginBottom:4}}>{isReturn?(lang==="es"?"DEVOLUCIÓN":"RETURN"):(lang==="es"?"GASTO":"EXPENSE")}</div>
      <div style={{fontSize:32,fontWeight:800}}>{isReturn?"+":"-"}${Math.abs(Number(expense.amount)).toLocaleString()}</div>
      {expense.tax&&<div style={{fontSize:12,opacity:.7,marginTop:4}}>+ ${Number(expense.tax).toLocaleString()} tax</div>}
    </div>
    {rows.map(r=><div key={r.label} style={{display:"flex",gap:10,padding:"9px 0",borderBottom:`1px solid ${T.g15}`}}>
      <div style={{width:24,height:24,borderRadius:7,background:T.g1,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
        <i className={`ti ti-${r.icon}`} style={{fontSize:12,color:T.g5}} aria-hidden="true"/>
      </div>
      <div><div style={{fontSize:10,color:T.g4,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.05em"}}>{r.label}</div><div style={{fontSize:13,color:T.g9,fontWeight:600,marginTop:1}}>{r.val}</div></div>
    </div>)}
    {expense.notes&&<div style={{marginTop:12,background:T.g05,borderRadius:10,padding:"10px 12px",fontSize:13,color:T.g7,lineHeight:1.6}}>{expense.notes}</div>}
    {expense.receiptPreview&&<div style={{marginTop:12,borderRadius:12,overflow:"hidden",border:`1px solid ${T.g15}`,maxHeight:200,display:"flex",alignItems:"center",justifyContent:"center",background:T.g05}}>
      <img src={expense.receiptPreview} alt="Receipt" style={{width:"100%",objectFit:"cover",display:"block"}}/>
    </div>}
  </div>;
}

function QuotePreviewContent({quote,data,lang}){
  const vendor=data.vendors.find(x=>x.id===quote.vendorId);
  const contact=data.contacts.find(x=>x.id===quote.contactId);
  const project=data.projects.find(x=>x.id===quote.projectId);
  const rows=[
    {icon:"building",label:lang==="es"?"Proyecto":"Project",val:project?.name},
    {icon:"user",label:lang==="es"?"Contacto":"Contact",val:contact?`${contact.firstName} ${contact.lastName}`:null},
    {icon:"briefcase",label:lang==="es"?"Proveedor":"Vendor",val:vendor?.name},
    {icon:"tag",label:lang==="es"?"Categoría":"Category",val:quote.category},
    {icon:"calendar",label:lang==="es"?"Fecha":"Date",val:quote.quoteDate},
    {icon:"clock",label:lang==="es"?"Válida hasta":"Valid Until",val:quote.validUntil},
    {icon:"circle-check",label:lang==="es"?"Estado":"Status",val:quote.status},
  ].filter(r=>r.val);
  return <div>
    <div style={{background:`linear-gradient(135deg,${T.g9},${T.g8})`,borderRadius:14,padding:"16px",marginBottom:16,color:T.wh}}>
      <div style={{fontSize:11,fontWeight:700,opacity:.7,marginBottom:4}}>{lang==="es"?"COTIZACIÓN":"QUOTE"}</div>
      {quote.amount&&<div style={{fontSize:32,fontWeight:800}}>${Number(quote.amount).toLocaleString()}</div>}
      <div style={{fontSize:14,marginTop:4,opacity:.8}}>{quote.title}</div>
    </div>
    {rows.map(r=><div key={r.label} style={{display:"flex",gap:10,padding:"9px 0",borderBottom:`1px solid ${T.g15}`}}>
      <div style={{width:24,height:24,borderRadius:7,background:T.g1,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
        <i className={`ti ti-${r.icon}`} style={{fontSize:12,color:T.g5}} aria-hidden="true"/>
      </div>
      <div><div style={{fontSize:10,color:T.g4,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.05em"}}>{r.label}</div><div style={{fontSize:13,color:T.g9,fontWeight:600,marginTop:1}}>{r.val}</div></div>
    </div>)}
    {quote.notes&&<div style={{marginTop:12,background:T.g05,borderRadius:10,padding:"10px 12px",fontSize:13,color:T.g7,lineHeight:1.6}}>{quote.notes}</div>}
  </div>;
}

function VendorPreviewContent({vendor,lang}){
  const rows=[
    {icon:"phone",label:lang==="es"?"Teléfono":"Phone",val:vendor.phone},
    {icon:"mail",label:lang==="es"?"Email":"Email",val:vendor.email},
    {icon:"map-pin",label:lang==="es"?"Dirección":"Address",val:vendor.address},
    {icon:"category",label:lang==="es"?"Categorías":"Categories",val:(vendor.categories||[]).join(", ")||null},
  ].filter(r=>r.val);
  return <div>
    <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:16,padding:"14px",background:T.g05,borderRadius:14}}>
      <Ava name={vendor.name||"?"} size={48}/>
      <div><div style={{fontSize:18,fontWeight:800,color:T.g9}}>{vendor.name}</div>
      {vendor.notes&&<div style={{fontSize:12,color:T.g5,marginTop:2}}>{vendor.notes}</div>}</div>
    </div>
    {rows.map(r=><div key={r.label} style={{display:"flex",gap:10,padding:"9px 0",borderBottom:`1px solid ${T.g15}`}}>
      <div style={{width:24,height:24,borderRadius:7,background:T.g1,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
        <i className={`ti ti-${r.icon}`} style={{fontSize:12,color:T.g5}} aria-hidden="true"/>
      </div>
      <div><div style={{fontSize:10,color:T.g4,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.05em"}}>{r.label}</div><div style={{fontSize:13,color:T.g9,fontWeight:600,marginTop:1}}>{r.val}</div></div>
    </div>)}
  </div>;
}

function RecentActivity({data,history,lang,onNav}){
  const [showAll,setShowAll]=useState(false);
  const [preview,setPreview]=useState(null); // {type, item}

  // Build unified activity feed from ALL data sources + manual history entries
  const items=useMemo(()=>{
    const feed=[];

    // Expenses
    (data.expenses||[]).forEach(e=>{
      feed.push({
        id:`exp-${e.id}`,
        ts:e.created_at||e.date||0,
        icon:Number(e.amount)<0?"arrow-back-up":"receipt",
        message:Number(e.amount)<0
          ?`Return: ${e.name} — $${Math.abs(Number(e.amount)).toLocaleString()}`
          :`Expense: ${e.name} — $${Number(e.amount).toLocaleString()}`,
        sub:e.tab+(e.category?` · ${e.category}`:"")+(e.paymentMethod?` · ${e.paymentMethod}`:""),
        type:"expense",ref:e,
      });
    });

    // Quotes
    (data.quotes||[]).forEach(q=>{
      feed.push({
        id:`quo-${q.id}`,
        ts:q.created_at||q.quoteDate||0,
        icon:"file-text",
        message:`Quote: ${q.title||q.id}`,
        sub:q.status||(q.amount?`$${Number(q.amount).toLocaleString()}`:""),
        type:"quote",ref:q,
      });
    });

    // Projects
    (data.projects||[]).forEach(p=>{
      feed.push({
        id:`prj-${p.id}`,
        ts:p.created_at||0,
        icon:"building",
        message:`Project: ${p.name}`,
        sub:p.status||"",
        type:"project",ref:p,
      });
    });

    // Contacts
    (data.contacts||[]).forEach(c=>{
      feed.push({
        id:`con-${c.id}`,
        ts:c.created_at||0,
        icon:"user",
        message:`Contact: ${c.firstName} ${c.lastName}`,
        sub:c.role||c.company||"",
        type:"contact",ref:c,
      });
    });

    // Vendors
    (data.vendors||[]).forEach(v=>{
      feed.push({
        id:`ven-${v.id}`,
        ts:v.created_at||0,
        icon:"briefcase",
        message:`Vendor: ${v.name}`,
        sub:"",
        type:"vendor",ref:v,
      });
    });

    // Sort newest first
    feed.sort((a,b)=>{
      const ta=a.ts?new Date(a.ts).getTime():0;
      const tb=b.ts?new Date(b.ts).getTime():0;
      return tb-ta;
    });

    return feed;
  },[data]);

  const visible=showAll?items:items.slice(0,8);

  const fmtDate=(ts)=>{
    if(!ts) return "";
    try{
      const d=new Date(ts);
      if(isNaN(d.getTime())) return ts;
      return d.toLocaleDateString(lang==="es"?"es-ES":"en-US",{month:"short",day:"numeric",year:"numeric"})
        +" · "+d.toLocaleTimeString(lang==="es"?"es-ES":"en-US",{hour:"2-digit",minute:"2-digit"});
    }catch{return "";}
  };

  const handleTap=(h)=>{
    if(h.type==="project"&&onNav) onNav("projects",h.ref);
    else if(h.type==="contact"&&onNav) onNav("contacts",h.ref);
    else if(h.type==="expense"||h.type==="quote") setPreview(h);
    else if(h.type==="vendor") setPreview(h);
    else if(onNav) onNav(h.type+"s");
  };

  // Accent colors per type
  const typeColor={expense:T.or,quote:T.bl,project:T.g9,contact:T.gr,vendor:T.am||"#F59E0B",return:T.gr};

  return <div>
    <div style={{fontSize:11,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginBottom:10}}>
      {lang==="es"?"ACTIVIDAD RECIENTE":"RECENT ACTIVITY"}
    </div>
    <Card noPad>
      {visible.length===0&&<div style={{padding:"20px 16px",fontSize:13,color:T.g4,textAlign:"center"}}>{lang==="es"?"Sin actividad":"No activity yet"}</div>}
      {visible.map((h,i)=>(
        <div key={h.id} onClick={()=>handleTap(h)} style={{
          display:"flex",gap:10,padding:"11px 16px",alignItems:"flex-start",
          borderBottom:i<visible.length-1?`1px solid ${T.g15}`:"none",
          cursor:"pointer",transition:"background .12s",
        }}
          onMouseEnter={e=>e.currentTarget.style.background=T.g05}
          onMouseLeave={e=>e.currentTarget.style.background="transparent"}
        >
          <div style={{width:28,height:28,borderRadius:8,background:T.g1,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginTop:1}}>
            <i className={`ti ti-${h.icon||"circle-dot"}`} style={{fontSize:13,color:typeColor[h.type]||T.g5}} aria-hidden="true"/>
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:13,color:T.g7,lineHeight:1.4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{h.message}</div>
            {h.sub&&<div style={{fontSize:11,color:T.g4,marginTop:1}}>{h.sub}</div>}
            <div style={{fontSize:10,color:T.g3,marginTop:2}}>{fmtDate(h.ts)}</div>
          </div>
          <i className="ti ti-chevron-right" style={{fontSize:13,color:T.g2,flexShrink:0,marginTop:6}} aria-hidden="true"/>
        </div>
      ))}
      {items.length>8&&<button onClick={()=>setShowAll(s=>!s)} style={{
        width:"100%",padding:"11px 16px",background:"none",border:"none",
        borderTop:`1px solid ${T.g15}`,color:T.bl,fontSize:13,fontWeight:700,
        cursor:"pointer",fontFamily:SYS,display:"flex",alignItems:"center",justifyContent:"center",gap:6,
      }}>
        <i className={`ti ti-chevron-${showAll?"up":"down"}`} style={{fontSize:13}} aria-hidden="true"/>
        {showAll?(lang==="es"?"Ver menos":"Show less"):(lang==="es"?`Ver ${items.length-8} más`:`Show ${items.length-8} more`)}
      </button>}
    </Card>

    {/* Inline preview modal for expenses / quotes / vendors */}
    {preview&&<div style={{position:"fixed",inset:0,background:"rgba(28,28,30,.6)",zIndex:9500,display:"flex",alignItems:"flex-end"}} onClick={e=>e.target===e.currentTarget&&setPreview(null)}>
      <div style={{background:T.wh,borderRadius:"22px 22px 0 0",width:"100%",maxHeight:"80vh",overflowY:"auto",boxShadow:"0 -8px 40px rgba(0,0,0,.22)",animation:"karpSlideUp .38s cubic-bezier(0.34,1.06,0.64,1) both"}}>
        {/* Handle */}
        <div style={{display:"flex",justifyContent:"center",padding:"12px 0 6px"}}>
          <div style={{width:36,height:4,borderRadius:4,background:T.g2}}/>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 20px 14px",borderBottom:`1px solid ${T.g15}`}}>
          <h2 style={{margin:0,fontSize:17,fontWeight:800,color:T.g9}}>{preview.message}</h2>
          <button onClick={()=>setPreview(null)} style={{background:T.g1,border:"none",cursor:"pointer",color:T.g5,width:30,height:30,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:15}}>✕</button>
        </div>
        <div style={{padding:"16px 20px 40px"}}>
          {/* EXPENSE / RETURN preview */}
          {(preview.type==="expense")&&<ExpensePreviewContent expense={preview.ref} data={data} lang={lang}/>}
          {/* QUOTE preview */}
          {preview.type==="quote"&&<QuotePreviewContent quote={preview.ref} data={data} lang={lang}/>}
          {/* VENDOR preview */}
          {preview.type==="vendor"&&<VendorPreviewContent vendor={preview.ref} lang={lang}/>}
        </div>
      </div>
    </div>}
  </div>;
}

function Dashboard({data,onNav,onAdd,lang}){
  const t=TR[lang]||TR.en;
  const active=data.projects.filter(p=>!["Completed","Cancelled"].includes(p.status));
  const pending=data.quotes.filter(q=>["Waiting for Quote","Quote Requested"].includes(q.status));
  const budget=data.projects.reduce((s,p)=>s+(Number(p.budget)||0),0);
  const spent=data.expenses.reduce((s,e)=>s+(Number(e.amount)||0),0);
  if(!data.projects.length)return <div style={{textAlign:"center",padding:"64px 20px"}}>
    <div style={{display:"flex",justifyContent:"center",marginBottom:20}}><KarpLogo h={56}/></div>
    <div style={{fontSize:13,fontWeight:700,color:T.g4,letterSpacing:"0.12em",textTransform:"uppercase",marginBottom:4}}>Concept</div>
    <div style={{fontSize:24,fontWeight:800,color:T.g9,marginBottom:10,letterSpacing:"-0.02em"}}>{lang==="es"?"Tu centro de renovaciones":"Your renovation command center"}</div>
    <div style={{fontSize:14,color:T.g4,marginBottom:28,lineHeight:1.7}}>{lang==="es"?"Gestiona proyectos, contactos, proveedores,\ncotizaciones y gastos en un solo lugar.":"Manage projects, contacts, vendors,\nquotes and expenses in one place."}</div>
    <Btn icon="plus" size="lg" onClick={onAdd}>{lang==="es"?"Crear Primer Proyecto":"Create First Project"}</Btn>
  </div>;
  return <div>
    {/* Quick action buttons — home tab only */}
    {onAdd&&<div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:20}}>
      <button onClick={()=>onAdd("addReturn")} style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:6,background:T.gr,color:"#FFF",border:"none",borderRadius:16,padding:"14px 8px",fontFamily:SYS,fontSize:13,fontWeight:700,cursor:"pointer"}}>
        <i className="ti ti-arrow-back-up" style={{fontSize:22}} aria-hidden="true"/>
        {lang==="es"?"Devolución":"Return"}
      </button>
      <button onClick={()=>onAdd("addExpense")} style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:6,background:T.or,color:"#FFF",border:"none",borderRadius:16,padding:"14px 8px",fontFamily:SYS,fontSize:13,fontWeight:700,cursor:"pointer"}}>
        <i className="ti ti-receipt" style={{fontSize:22}} aria-hidden="true"/>
        {lang==="es"?"Gasto":"Expense"}
      </button>
      <button onClick={()=>onAdd("addContact")} style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:6,background:T.bl,color:"#FFF",border:"none",borderRadius:16,padding:"14px 8px",fontFamily:SYS,fontSize:13,fontWeight:700,cursor:"pointer"}}>
        <i className="ti ti-user-plus" style={{fontSize:22}} aria-hidden="true"/>
        {lang==="es"?"Contacto":"Contact"}
      </button>
    </div>}
    <div style={{marginBottom:20}}>
      <div style={{fontSize:22,fontWeight:800,color:T.g9,letterSpacing:"-0.02em"}}>{t.overview}</div>
      <div style={{fontSize:12,color:T.g4,marginTop:2}}>{new Date().toLocaleDateString(lang==="es"?"es-ES":"en-US",{weekday:"long",month:"long",day:"numeric"})}</div>
    </div>
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:24}}>
      <StatCard label={t.activeProjects} value={active.length} icon="building" accent/>
      <StatCard label={t.pendingQuotes} value={pending.length} icon="clock"/>
      <StatCard label={t.approved} value={data.quotes.filter(q=>q.status==="Approved").length} icon="circle-check" color="green"/>
    </div>
    {active.length>0&&<div style={{marginBottom:24}}>
      <div style={{fontSize:11,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginBottom:10}}>{lang==="es"?"PROYECTOS ACTIVOS":"ACTIVE PROJECTS"}</div>
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {active.map(p=>(
          <div key={p.id} onClick={()=>onNav("projects",p)} style={{
            display:"flex",alignItems:"center",justifyContent:"space-between",
            background:T.wh,borderRadius:14,padding:p.photo?"0":"16px 18px",
            border:`1px solid ${T.g15}`,cursor:"pointer",
            boxShadow:"0 1px 4px rgba(0,0,0,.06)",
            transition:"box-shadow .15s",overflow:"hidden",
          }}
            onMouseEnter={e=>e.currentTarget.style.boxShadow="0 4px 14px rgba(0,0,0,.1)"}
            onMouseLeave={e=>e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,.06)"}
          >
            {p.photo
              ?<div style={{display:"flex",alignItems:"center",flex:1,minWidth:0}}>
                <div style={{width:64,height:64,flexShrink:0,overflow:"hidden"}}>
                  <img src={p.photo} alt={p.name} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
                </div>
                <div style={{padding:"12px 14px",flex:1,minWidth:0}}>
                  <div style={{fontWeight:800,fontSize:18,color:T.g9,letterSpacing:"-0.02em",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</div>
                </div>
              </div>
              :<div style={{fontWeight:800,fontSize:22,color:T.g9,letterSpacing:"-0.02em",flex:1,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</div>
            }
            <div style={{display:"flex",alignItems:"center",gap:10,flexShrink:0,paddingRight:p.photo?14:0}}>
              <i className="ti ti-chevron-right" style={{fontSize:16,color:T.g3}} aria-hidden="true"/>
            </div>
          </div>
        ))}
      </div>
    </div>}
    {pending.length>0&&<div style={{marginBottom:24}}>
      <div style={{fontSize:11,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginBottom:10}}>PENDING FOLLOW-UPS</div>
      <Card noPad>
        {pending.slice(0,5).map((q,i)=>{
          const v=data.vendors.find(x=>x.id===q.vendorId);
          const p=data.projects.find(x=>x.id===q.projectId);
          return <div key={q.id} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 16px",borderBottom:i<Math.min(pending.length,5)-1?`1px solid ${T.g15}`:"none"}}>
            <div style={{width:8,height:8,borderRadius:"50%",background:T.am,flexShrink:0}}/>
            <div style={{flex:1,minWidth:0}}><div style={{fontSize:13,fontWeight:600,color:T.g9,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{q.title}</div>
            <div style={{fontSize:11,color:T.g4}}>{[v?.name,p?.name].filter(Boolean).join(" · ")}</div></div>
            <Badge status={q.status}/>
          </div>;
        })}
      </Card>
    </div>}
    {(data.expenses?.length||data.quotes?.length||data.contacts?.length||data.projects?.length)>0&&<RecentActivity data={data} history={data.history||[]} lang={lang} onNav={onNav}/>}
  </div>;
}

function ProjectsView({data,onSelect,onAdd,onDelete,onUpdate,lang="en"}){
  const t=TR[lang]||TR.en;
  const [confirmDel,setConfirmDel]=useState(null);
  const [editing,setEditing]=useState(null);
  const [editForm,setEditForm]=useState({});
  const editPhotoRef=useRef(null);
  const ue=(k,v)=>setEditForm(f=>({...f,[k]:v}));

  if(!data.projects.length)return <div style={{textAlign:"center",padding:"60px 20px"}}>
    <i className="ti ti-building" style={{fontSize:48,color:T.g3,display:"block",marginBottom:12}} aria-hidden="true"/>
    <div style={{fontSize:16,fontWeight:700,color:T.g7,marginBottom:8}}>No projects yet</div>
    <Btn icon="plus" onClick={onAdd}>Create first project</Btn>
  </div>;

  return <div style={{display:"flex",flexDirection:"column",gap:10}}>
    {confirmDel&&<ConfirmDelete label={confirmDel.name} onConfirm={()=>{onDelete&&onDelete(confirmDel.id);setConfirmDel(null);}} onCancel={()=>setConfirmDel(null)}/>}

    {/* Edit Project Modal */}
    {editing&&<Modal title={lang==="es"?"Editar Proyecto":"Edit Project"} onClose={()=>setEditing(null)} width={520}>
      {/* Photo upload */}
      <div style={{marginBottom:18}}>
        <input ref={editPhotoRef} type="file" accept="image/*" style={{display:"none"}} onChange={async e=>{
          const file=e.target.files?.[0];
          if(!file)return;
          const compressed=await compressImage(file,800,800,0.75);
          ue("photo",compressed);
          e.target.value="";
        }}/>
        {editForm.photo
          ?<div style={{position:"relative",borderRadius:14,overflow:"hidden",height:140,marginBottom:4}}>
            <img src={editForm.photo} alt="Project" style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
            <div style={{position:"absolute",inset:0,background:"linear-gradient(to top,rgba(0,0,0,.35) 0%,transparent 50%)"}}/>
            <button onClick={()=>ue("photo",null)} style={{position:"absolute",top:8,right:8,background:"rgba(0,0,0,.55)",border:"none",borderRadius:"50%",width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",color:"#fff",fontSize:14}}>✕</button>
            <button onClick={()=>editPhotoRef.current?.click()} style={{position:"absolute",bottom:8,right:8,background:"rgba(0,0,0,.55)",border:"none",borderRadius:8,padding:"5px 10px",cursor:"pointer",color:"#fff",fontSize:11,fontWeight:700,fontFamily:SYS}}>{lang==="es"?"Cambiar":"Change"}</button>
          </div>
          :<button onClick={()=>editPhotoRef.current?.click()} style={{
            width:"100%",height:90,borderRadius:14,border:`2px dashed ${T.g2}`,
            background:T.g05,cursor:"pointer",display:"flex",flexDirection:"column",
            alignItems:"center",justifyContent:"center",gap:6,marginBottom:4,
          }}>
            <i className="ti ti-camera" style={{fontSize:20,color:T.g4}} aria-hidden="true"/>
            <span style={{fontSize:12,fontWeight:600,color:T.g4,fontFamily:SYS}}>{lang==="es"?"Agregar Foto":"Add Project Photo"}</span>
          </button>
        }
      </div>
      <FF label="Project name *"><Inp value={editForm.name||""} onChange={e=>ue("name",e.target.value)} placeholder="4050 N 45th Ave"/></FF>
      <FF label="Address"><Inp value={editForm.address||""} onChange={e=>ue("address",e.target.value)} placeholder="123 Main St, City, State"/></FF>
      <FF label="Description"><Txa value={editForm.description||""} onChange={e=>ue("description",e.target.value)} rows={2} placeholder="Brief project description…"/></FF>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <FF label="Status"><Sel value={editForm.status||"Planning"} onChange={v=>ue("status",v)} options={PROJ_ST}/></FF>
        <FF label="Budget ($)"><Inp type="number" value={editForm.budget||""} onChange={e=>ue("budget",e.target.value)} placeholder="150000"/></FF>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <FF label="Start date"><input type="date" style={IS} value={editForm.startDate||""} onChange={e=>ue("startDate",e.target.value)}/></FF>
        <FF label="End date"><input type="date" style={IS} value={editForm.endDate||""} onChange={e=>ue("endDate",e.target.value)}/></FF>
      </div>
      <FF label="Notes"><Txa value={editForm.notes||""} onChange={e=>ue("notes",e.target.value)} rows={2} placeholder="Additional notes…"/></FF>
      <div style={{display:"flex",gap:10,marginTop:12}}>
        <Btn variant="secondary" onClick={()=>setEditing(null)} full>Cancel</Btn>
        <Btn icon="check" onClick={()=>{
          if(!editForm.name)return;
          onUpdate&&onUpdate(editing.id,editForm);
          toast(lang==="es"?"Cambios guardados":"Changes saved");
          setEditing(null);
        }} disabled={!editForm.name} full>Save Changes</Btn>
      </div>
    </Modal>}

    {/* New Project button */}
    <button onClick={onAdd} style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,background:T.g9,color:"#FFF",border:"none",borderRadius:999,padding:"9px 14px",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:SYS,alignSelf:"flex-start",transition:"transform .1s"}}
      onMouseDown={e=>{e.currentTarget.style.transform="scale(.96)"}} onMouseUp={e=>{e.currentTarget.style.transform="scale(1)"}} onMouseLeave={e=>{e.currentTarget.style.transform="scale(1)"}}>
      <i className="ti ti-plus" style={{fontSize:15}} aria-hidden="true"/>New Project
    </button>

    {data.projects.map(p=>{
      const allPExp=data.expenses.filter(e=>e.projectId===p.id);
      const pExp=allPExp.filter(e=>e.tab==="Labor"||e.tab==="Materials").reduce((s,e)=>s+(Number(e.amount)||0),0);
      const b=Number(p.budget)||0;
      const pct=b>0?Math.min(Math.round((pExp/b)*100),100):0;
      const over=pExp>b&&b>0;
      const quoteCount=data.quotes.filter(q=>q.projectId===p.id).length;
      return <div key={p.id} onClick={()=>onSelect(p)} style={{
        background:T.wh,borderRadius:16,border:`1px solid ${T.g15}`,
        overflow:"hidden",cursor:"pointer",
        boxShadow:"0 1px 6px rgba(0,0,0,.06)",
        transition:"box-shadow .15s",
      }}
        onMouseEnter={e=>e.currentTarget.style.boxShadow="0 4px 18px rgba(0,0,0,.1)"}
        onMouseLeave={e=>e.currentTarget.style.boxShadow="0 1px 6px rgba(0,0,0,.06)"}
      >
        {/* Photo banner if available */}
        {p.photo&&<div style={{height:110,overflow:"hidden",position:"relative"}}>
          <img src={p.photo} alt={p.name} style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}/>
          <div style={{position:"absolute",inset:0,background:"linear-gradient(to top,rgba(0,0,0,.4) 0%,transparent 60%)"}}/>
          {/* Action buttons overlay */}
          <div style={{position:"absolute",top:8,right:8,display:"flex",gap:6}} onClick={e=>e.stopPropagation()}>
            <button onClick={()=>{setEditForm({...p});setEditing(p);}} style={{background:"rgba(0,0,0,.55)",border:"none",borderRadius:8,width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
              <i className="ti ti-pencil" style={{fontSize:13,color:"#fff"}} aria-hidden="true"/>
            </button>
            <button onClick={()=>setConfirmDel(p)} style={{background:"rgba(200,0,0,.6)",border:"none",borderRadius:8,width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
              <i className="ti ti-trash" style={{fontSize:13,color:"#fff"}} aria-hidden="true"/>
            </button>
          </div>
        </div>}

        {/* Top row: name + action buttons (when no photo) */}
        {!p.photo&&<div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 14px 0"}}>
          <div style={{fontWeight:800,fontSize:16,color:T.g9,flex:1,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</div>
          <div style={{display:"flex",gap:6,flexShrink:0,marginLeft:8}} onClick={e=>e.stopPropagation()}>
            <button onClick={()=>{setEditForm({...p});setEditing(p);}} style={{background:T.g1,border:"none",borderRadius:8,width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
              <i className="ti ti-pencil" style={{fontSize:13,color:T.g5}} aria-hidden="true"/>
            </button>
            <button onClick={()=>setConfirmDel(p)} style={{background:T.rdl,border:"none",borderRadius:8,width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
              <i className="ti ti-trash" style={{fontSize:13,color:T.rd}} aria-hidden="true"/>
            </button>
          </div>
        </div>}

        {/* Name row when photo exists */}
        {p.photo&&<div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 14px 0"}}>
          <div style={{fontWeight:800,fontSize:16,color:T.g9,flex:1,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</div>
        </div>}

        {/* Address */}
        {p.address&&<div style={{fontSize:11,color:T.g4,padding:"3px 14px 10px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.address}</div>}

        {/* 2×3 info grid */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",borderTop:`1px solid ${T.g15}`}}>
          {[
            {label:lang==="es"?"Presupuesto":"Budget",val:b>0?fmt(b):"—"},
            {label:lang==="es"?"Gastado":"Spent",val:pExp>0?fmt(pExp):"$0"},
            {label:lang==="es"?"Cotizaciones":"Quotes",val:String(quoteCount)},
          ].map((cell,i)=>(
            <div key={i} style={{
              padding:"10px 14px 14px",
              borderRight:i<2?`1px solid ${T.g15}`:"none",
            }}>
              <div style={{fontSize:10,fontWeight:600,color:T.g4,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:3}}>{cell.label}</div>
              <div style={{fontSize:14,fontWeight:800,color:over&&cell.label.toLowerCase().includes("spent")?T.rd:T.g9}}>{cell.val}</div>
            </div>
          ))}
        </div>
      </div>;
    })}
  </div>;
}

/* ── PROJECT ATTACHMENTS ── */
function ProjectAttachments({project,onUpdate,onClose,lang="en"}){
  const fileRef=useRef(null);
  const [url,setUrl]=useState("");
  const [urlName,setUrlName]=useState("");
  const [addingUrl,setAddingUrl]=useState(false);

  const fmtSz=b=>b<1024*1024?`${Math.round(b/1024)}KB`:`${(b/1024/1024).toFixed(1)}MB`;

  const addFile=e=>{
    const files=Array.from(e.target.files||[]);
    if(!files.length)return;
    let count=0;
    files.forEach(file=>{
      const reader=new FileReader();
      reader.onload=ev=>{
        const att={type:"file",name:file.name,fileType:file.type,size:fmtSz(file.size),dataUrl:ev.target.result,addedAt:new Date().toISOString()};
        const updated={...project,attachments:[...(project.attachments||[]),att]};
        onUpdate&&onUpdate(project.id,updated);
        count++;
        if(count===files.length)onClose();
      };
      reader.readAsDataURL(file);
    });
    e.target.value="";
  };

  const addUrl=()=>{
    if(!url.trim())return;
    const att={type:"url",name:urlName.trim()||url.trim(),url:url.trim(),addedAt:new Date().toISOString()};
    const updated={...project,attachments:[...(project.attachments||[]),att]};
    onUpdate&&onUpdate(project.id,updated);
    setUrl("");setUrlName("");setAddingUrl(false);onClose();
  };

  return <Modal title={lang==="es"?"Adjuntar Archivos":"Attach Files & Links"} onClose={onClose} width={480}>
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {/* File picker */}
      <button onClick={()=>fileRef.current&&fileRef.current.click()} style={{display:"flex",alignItems:"center",gap:14,padding:"16px",borderRadius:14,border:`2px dashed ${T.g2}`,background:T.g05,cursor:"pointer",fontFamily:SYS,textAlign:"left"}}>
        <div style={{width:44,height:44,borderRadius:12,background:T.bll,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className="ti ti-folder-open" style={{fontSize:22,color:T.bl}} aria-hidden="true"/>
        </div>
        <div>
          <div style={{fontSize:14,fontWeight:700,color:T.g9}}>Browse Files</div>
          <div style={{fontSize:12,color:T.g4,marginTop:2}}>PDFs, images, documents — any file type</div>
        </div>
      </button>
      <input ref={fileRef} type="file" accept="*/*" multiple style={{display:"none"}} onChange={addFile}/>

      {/* Photo library */}
      <button onClick={()=>{const i=document.createElement("input");i.type="file";i.accept="image/*";i.multiple=true;i.onchange=addFile;i.click();}} style={{display:"flex",alignItems:"center",gap:14,padding:"16px",borderRadius:14,border:`2px dashed ${T.g2}`,background:T.g05,cursor:"pointer",fontFamily:SYS,textAlign:"left"}}>
        <div style={{width:44,height:44,borderRadius:12,background:T.grl,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className="ti ti-photo" style={{fontSize:22,color:T.gr}} aria-hidden="true"/>
        </div>
        <div>
          <div style={{fontSize:14,fontWeight:700,color:T.g9}}>Photo Library</div>
          <div style={{fontSize:12,color:T.g4,marginTop:2}}>Select photos from your library</div>
        </div>
      </button>

      {/* URL */}
      {!addingUrl
        ?<button onClick={()=>setAddingUrl(true)} style={{display:"flex",alignItems:"center",gap:14,padding:"16px",borderRadius:14,border:`2px dashed ${T.g2}`,background:T.g05,cursor:"pointer",fontFamily:SYS,textAlign:"left"}}>
          <div style={{width:44,height:44,borderRadius:12,background:T.orl,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
            <i className="ti ti-link" style={{fontSize:22,color:T.or}} aria-hidden="true"/>
          </div>
          <div>
            <div style={{fontSize:14,fontWeight:700,color:T.g9}}>Add URL Link</div>
            <div style={{fontSize:12,color:T.g4,marginTop:2}}>Google Drive, Dropbox, website, or any link</div>
          </div>
        </button>
        :<div style={{background:T.g05,borderRadius:14,padding:"14px",border:`1px solid ${T.g15}`}}>
          <FF label="URL *"><Inp value={url} onChange={e=>setUrl(e.target.value)} placeholder="https://…"/></FF>
          <FF label="Label (optional)"><Inp value={urlName} onChange={e=>setUrlName(e.target.value)} placeholder="e.g. Floor plan, Contract…"/></FF>
          <div style={{display:"flex",gap:8,marginTop:4}}>
            <Btn variant="secondary" onClick={()=>{setAddingUrl(false);setUrl("");setUrlName("");}} full>Cancel</Btn>
            <Btn icon="check" onClick={addUrl} disabled={!url.trim()} full>Add Link</Btn>
          </div>
        </div>
      }
    </div>
  </Modal>;
}

/* ── PROJECT DOC SECTION MODAL ── */
function ProjectDocSection({title,icon,color,colorLight,docs,onUpdate,onClose,lang}){
  const fileRef=useRef(null);
  const cameraRef=useRef(null);

  const handleFile=async(e)=>{
    const file=e.target.files?.[0];
    if(!file)return;
    let dataUrl;
    if(file.type.startsWith("image/")){
      dataUrl=await compressImage(file,1200,1600,0.75);
    } else {
      dataUrl=await new Promise(res=>{const r=new FileReader();r.onload=ev=>res(ev.target.result);r.readAsDataURL(file);});
    }
    const doc={name:file.name,size:file.size,fileType:file.type,dataUrl,addedAt:new Date().toISOString()};
    onUpdate([...docs,doc]);
    e.target.value="";
  };

  return <Modal title={title} onClose={onClose} width={520}>
    <input ref={fileRef} type="file" accept="*/*" style={{display:"none"}} onChange={handleFile}/>
    <input ref={cameraRef} type="file" accept="image/*" capture="environment" style={{display:"none"}} onChange={handleFile}/>

    {/* Upload buttons */}
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:18}}>
      <button onClick={()=>cameraRef.current?.click()} style={{
        display:"flex",flexDirection:"column",alignItems:"center",gap:8,
        padding:"18px",borderRadius:14,cursor:"pointer",
        border:`2px dashed ${color}`,background:colorLight,
        color:color,fontFamily:SYS,fontSize:13,fontWeight:700,
      }}>
        <i className="ti ti-camera" style={{fontSize:24}} aria-hidden="true"/>
        {lang==="es"?"Tomar Foto":"Take Photo"}
      </button>
      <button onClick={()=>fileRef.current?.click()} style={{
        display:"flex",flexDirection:"column",alignItems:"center",gap:8,
        padding:"18px",borderRadius:14,cursor:"pointer",
        border:`2px dashed rgba(0,0,0,.15)`,background:T.g05,
        color:T.g5,fontFamily:SYS,fontSize:13,fontWeight:700,
      }}>
        <i className="ti ti-upload" style={{fontSize:24}} aria-hidden="true"/>
        {lang==="es"?"Subir Archivo":"Upload File"}
      </button>
    </div>

    {/* Saved docs */}
    {docs.length===0&&<div style={{textAlign:"center",padding:"20px",color:T.g4,fontSize:13}}>
      {lang==="es"?"Sin documentos aún":"No documents yet"}
    </div>}
    <div style={{display:"flex",flexDirection:"column",gap:8}}>
      {docs.map((d,i)=>{
        const isPdf=d.fileType?.includes("pdf");
        const isImg=d.fileType?.startsWith("image");
        return <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",background:T.wh,borderRadius:12,border:`1px solid ${T.g15}`}}>
          <div style={{width:38,height:38,borderRadius:9,background:colorLight,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
            <i className={`ti ti-${isPdf?"file-type-pdf":isImg?"photo":"file"}`} style={{fontSize:18,color:color}} aria-hidden="true"/>
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:13,fontWeight:700,color:T.g9,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.name}</div>
            <div style={{fontSize:11,color:T.g4}}>{d.fileType} · {d.addedAt?new Date(d.addedAt).toLocaleDateString():""}</div>
          </div>
          {/* Preview */}
          <button onClick={()=>{
            openPreview(d.dataUrl,d.name,d.fileType);
          }} style={{background:T.g1,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>
            <i className="ti ti-eye" style={{fontSize:15,color:T.g5}} aria-hidden="true"/>
          </button>
          {/* Download */}
          <button onClick={()=>saveFile(d.dataUrl,d.name)} style={{background:T.bll,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>
            <i className="ti ti-download" style={{fontSize:15,color:T.bl}} aria-hidden="true"/>
          </button>
          {/* Delete */}
          <button onClick={()=>{if(window.confirm(lang==="es"?"¿Eliminar este documento?":"Delete this document?")){onUpdate(docs.filter((_,j)=>j!==i));}}} style={{background:T.rdl,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>
            <i className="ti ti-trash" style={{fontSize:15,color:T.rd}} aria-hidden="true"/>
          </button>
        </div>;
      })}
    </div>
  </Modal>;
}

/* ── INLINE DOC LIST ── */
function DocListSection({title,icon,color,colorLight,docs,onDelete}){
  return <div style={{marginBottom:18}}>
    <div style={{fontSize:11,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginBottom:10,display:"flex",alignItems:"center",gap:6}}>
      <i className={`ti ti-${icon}`} style={{fontSize:12,color}} aria-hidden="true"/>
      {title}
    </div>
    <div style={{display:"flex",flexDirection:"column",gap:8}}>
      {docs.map((d,i)=>{
        const isPdf=d.fileType?.includes("pdf");
        const isImg=d.fileType?.startsWith("image");
        return <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",background:T.wh,borderRadius:12,border:`1px solid ${T.g15}`,boxShadow:"0 1px 4px rgba(0,0,0,.06)"}}>
          <div style={{width:38,height:38,borderRadius:9,background:colorLight,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
            <i className={`ti ti-${isPdf?"file-type-pdf":isImg?"photo":"file"}`} style={{fontSize:18,color}} aria-hidden="true"/>
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:13,fontWeight:700,color:T.g9,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{d.name}</div>
            <div style={{fontSize:11,color:T.g4}}>{d.addedAt?new Date(d.addedAt).toLocaleDateString():""}</div>
          </div>
          <button onClick={()=>{
            openPreview(d.dataUrl,d.name,d.fileType);
          }} style={{background:T.g1,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>
            <i className="ti ti-eye" style={{fontSize:15,color:T.g5}} aria-hidden="true"/>
          </button>
          <button onClick={()=>saveFile(d.dataUrl,d.name)} style={{background:T.bll,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>
            <i className="ti ti-download" style={{fontSize:15,color:T.bl}} aria-hidden="true"/>
          </button>
          <button onClick={()=>onDelete(i)} style={{background:T.rdl,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>
            <i className="ti ti-trash" style={{fontSize:15,color:T.rd}} aria-hidden="true"/>
          </button>
        </div>;
      })}
    </div>
  </div>;
}

function ProjectDetail({project,data,onRQ,onAddQ,onAddE,onUpdateQuote,onDeleteQuote,onUpdateExpense,onDeleteExpense,onUpdateProject,lang="en"}){
  const t=TR[lang]||TR.en;
  const [tab,st]=useState("Labor");
  const [selectedQuote,setSelectedQuote]=useState(null);
  const [selectedExpense,setSelectedExpense]=useState(null);
  const [showAttach,setShowAttach]=useState(false);
  const [showLegal,setShowLegal]=useState(false);
  const [showClosing,setShowClosing]=useState(false);
  const allQuotes=data.quotes.filter(q=>q.projectId===project.id);
  const quotes=allQuotes.filter(q=>
    q.tab===tab||
    q.tab==="Labor & Materials"||
    q.tab==="Both"||
    (tab==="Labor"&&(!q.tab||q.tab==="Labor"))||
    (tab==="Materials"&&q.tab==="Materials")||
    (tab==="Mortgage"&&q.tab==="Mortgage")
  );
  const exps=data.expenses
    .filter(e=>e.projectId===project.id&&(e.tab===tab||(tab==="Mortgage"&&e.tab==="Mortgage")))
    .sort((a,b)=>new Date(b.created_at||b.date||0)-new Date(a.created_at||a.date||0));
  const allExp=data.expenses.filter(e=>e.projectId===project.id);
  const tot=allExp.reduce((s,e)=>s+(Number(e.amount)||0),0);
  const lab=allExp.filter(e=>e.tab==="Labor").reduce((s,e)=>s+(Number(e.amount)||0),0);
  const mat=allExp.filter(e=>e.tab==="Materials").reduce((s,e)=>s+(Number(e.amount)||0),0);
  const mor=allExp.filter(e=>e.tab==="Mortgage").reduce((s,e)=>s+(Number(e.amount)||0),0);
  const bud=Number(project.budget)||0;
  const labMat=lab+mat; // progress bar excludes mortgage
  const pct=bud>0?Math.round((labMat/bud)*100):0;
  const byCat={};quotes.forEach(q=>{if(!byCat[q.category])byCat[q.category]=[];byCat[q.category].push(q);});
  return <div>
    {selectedQuote&&<QuoteDetailModal lang={lang} quote={selectedQuote} data={data} onClose={()=>setSelectedQuote(null)} onUpdate={(id,changes)=>{onUpdateQuote&&onUpdateQuote(id,changes);toast("Quote saved");setSelectedQuote(null);}} onDelete={(id)=>{onDeleteQuote&&onDeleteQuote(id);setSelectedQuote(null);}}/>}
    {selectedExpense&&<ExpenseDetailModal lang={lang} expense={selectedExpense} data={data} onClose={()=>setSelectedExpense(null)} onUpdate={(id,changes)=>{onUpdateExpense&&onUpdateExpense(id,changes);toast("Expense saved");setSelectedExpense(null);}} onDelete={(id)=>{onDeleteExpense&&onDeleteExpense(id);setSelectedExpense(null);}}/>}
    <div style={{background:`linear-gradient(135deg,${T.g9} 0%,${T.g8} 100%)`,borderRadius:20,padding:"20px",marginBottom:16,color:T.wh}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
        <div><div style={{fontSize:19,fontWeight:800,letterSpacing:"-0.02em",marginBottom:3}}>{project.name}</div>
        {project.address&&<div style={{fontSize:12,color:T.g4}}>{project.address}</div>}</div>
        <div style={{position:"relative",flexShrink:0}}>
          <select
            value={project.status||"Planning"}
            onChange={e=>{onUpdateProject&&onUpdateProject(project.id,{...project,status:e.target.value});}}
            style={{
              appearance:"none",WebkitAppearance:"none",
              background:"rgba(0,0,0,.55)",
              color:"#fff",
              border:`1px solid ${T.gr}`,
              borderRadius:999,
              padding:"7px 26px 7px 12px",
              fontSize:12,
              fontWeight:300,
              fontFamily:"'Helvetica Neue',Helvetica,Arial,sans-serif",
              cursor:"pointer",
              outline:"none",
              letterSpacing:"0.01em",
              width:`${(project.status||"Planning").length*7.5+42}px`,
            }}
          >
            {PROJ_ST.map(s=><option key={s} value={s}>{s}</option>)}
          </select>
          <i className="ti ti-chevron-down" style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",fontSize:10,color:T.gr,pointerEvents:"none"}} aria-hidden="true"/>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8,marginBottom:bud>0?14:0}}>
        {[[t.spent,fmt(labMat)],[t.labor,fmt(lab)],[t.materials,fmt(mat)],[t.mortgage,fmt(mor)]].map(([k,v])=>(
          <div key={k} style={{background:"rgba(255,255,255,.09)",borderRadius:12,padding:"10px 12px"}}>
            <div style={{fontSize:17,fontWeight:800}}>{v}</div>
            <div style={{fontSize:11,color:T.g5,marginTop:2}}>{k}</div>
          </div>
        ))}
      </div>
      {bud>0&&<div>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:T.g5,marginBottom:5}}>
          <span>{fmt(labMat)} utilized out of {fmt(bud)} budget</span>
          <span style={{color:labMat>bud?"#FF6B6B":"#4DE89A",fontWeight:700}}>{pct}%</span>
        </div>
        <div style={{height:6,borderRadius:6,background:"rgba(255,255,255,.12)",overflow:"hidden"}}>
          <div style={{height:"100%",width:`${Math.min(100,pct)}%`,background:labMat>bud?T.rd:T.bl,borderRadius:6}}/>
        </div>
      </div>}
    </div>
    {/* 2x3 action buttons — equal size, uniform style */}
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:18}}>
      {[
        {icon:"mail",label:t.requestQuote,action:()=>onRQ(null,null,project,null,tab)},
        {icon:"plus",label:t.addQuote,action:()=>onAddQ(project,tab)},
        {icon:"receipt",label:t.addExpense,action:()=>onAddE(project,tab)},
        {icon:"paperclip",label:t.attachFiles,action:()=>setShowAttach(true)},
        {icon:"scale",label:lang==="es"?"Docs Legales":"Legal Docs",action:()=>setShowLegal(true)},
        {icon:"file-check",label:lang==="es"?"Docs Cierre":"Closing Docs",action:()=>setShowClosing(true)},
      ].map(({icon,label,action})=>(
        <button key={label} onClick={action} style={{
          display:"flex",alignItems:"center",justifyContent:"center",gap:7,
          padding:"13px 10px",borderRadius:14,cursor:"pointer",
          fontFamily:SYS,fontSize:13,fontWeight:700,
          border:`1.5px solid ${T.g2}`,
          background:T.wh,color:T.g7,
          boxShadow:"0 1px 4px rgba(0,0,0,.06)",
        }}>
          <i className={`ti ti-${icon}`} style={{fontSize:16,flexShrink:0}} aria-hidden="true"/>
          {label}
        </button>
      ))}
    </div>

    {/* Project Attachments modal */}
    {showAttach&&<ProjectAttachments project={project} onUpdate={onUpdateProject} onClose={()=>setShowAttach(false)}/>}

    {/* Legal Docs modal */}
    {showLegal&&<ProjectDocSection
      title={lang==="es"?"Documentos Legales":"Legal Documents"}
      icon="scale"
      color={T.pu||"#7C3AED"}
      colorLight="rgba(124,58,237,.12)"
      docs={project.legalDocs||[]}
      onUpdate={docs=>onUpdateProject&&onUpdateProject(project.id,{...project,legalDocs:docs})}
      onClose={()=>setShowLegal(false)}
      lang={lang}
    />}

    {/* Closing Docs modal */}
    {showClosing&&<ProjectDocSection
      title={lang==="es"?"Documentos de Cierre":"Closing Documents"}
      icon="file-check"
      color={T.am||"#F59E0B"}
      colorLight="rgba(245,158,11,.12)"
      docs={project.closingDocs||[]}
      onUpdate={docs=>onUpdateProject&&onUpdateProject(project.id,{...project,closingDocs:docs})}
      onClose={()=>setShowClosing(false)}
      lang={lang}
    />}

    {/* FILES & LINKS */}
    {(project.attachments||[]).length>0&&<div style={{marginBottom:18}}>
      <div style={{fontSize:11,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginBottom:10}}>{t.filesLinks}</div>
      <div style={{display:"flex",flexDirection:"column",gap:8}}>
        {(project.attachments||[]).map((a,i)=>{
          const isPdf=a.type==="file"&&a.fileType?.includes("pdf");
          const isImg=a.type==="file"&&a.fileType?.includes("image");
          return <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",background:T.wh,borderRadius:12,border:`1px solid ${T.g15}`,boxShadow:"0 1px 4px rgba(0,0,0,.06)"}}>
            <div style={{width:40,height:40,borderRadius:10,background:a.type==="url"?T.bll:isPdf?T.rdl:T.grl,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className={`ti ti-${a.type==="url"?"link":isPdf?"file-type-pdf":isImg?"photo":"file"}`} style={{fontSize:20,color:a.type==="url"?T.bl:isPdf?T.rd:T.gr}} aria-hidden="true"/>
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:13,fontWeight:700,color:T.g9,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.name}</div>
              {a.size&&<div style={{fontSize:11,color:T.g4,marginTop:1}}>{a.size}</div>}
              {a.type==="url"&&<div style={{fontSize:11,color:T.g4,marginTop:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.url}</div>}
            </div>
            <div style={{display:"flex",gap:6,flexShrink:0}}>
              {a.type==="url"&&<button onClick={()=>window.open(a.url,"_blank")} style={{background:T.bll,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
                <i className="ti ti-external-link" style={{fontSize:15,color:T.bl}} aria-hidden="true"/>
              </button>}
              {a.type==="file"&&<button onClick={()=>openPreview(a.dataUrl,a.name,a.fileType)} style={{background:T.g1,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
                <i className="ti ti-zoom-in" style={{fontSize:15,color:T.g6}} aria-hidden="true"/>
              </button>}
              {a.type==="file"&&<button onClick={()=>{saveFile(a.dataUrl, a.name);}} style={{background:T.bll,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
                <i className="ti ti-download" style={{fontSize:15,color:T.bl}} aria-hidden="true"/>
              </button>}
              <button onClick={()=>{if(window.confirm("Delete this file?")){{const updated={...project,attachments:(project.attachments||[]).filter((_,j)=>j!==i)};onUpdateProject&&onUpdateProject(project.id,updated);}};}} style={{background:T.rdl,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
                <i className="ti ti-trash" style={{fontSize:15,color:T.rd}} aria-hidden="true"/>
              </button>
            </div>
          </div>;
        })}
      </div>
    </div>}

    {/* LEGAL DOCUMENTS inline */}
    {(project.legalDocs||[]).length>0&&<DocListSection
      title={lang==="es"?"DOCUMENTOS LEGALES":"LEGAL DOCUMENTS"}
      icon="scale" color="#7C3AED" colorLight="rgba(124,58,237,.12)"
      docs={project.legalDocs||[]}
      onDelete={i=>{const d=[...(project.legalDocs||[])];d.splice(i,1);onUpdateProject&&onUpdateProject(project.id,{...project,legalDocs:d});}}
    />}

    {/* CLOSING DOCUMENTS inline */}
    {(project.closingDocs||[]).length>0&&<DocListSection
      title={lang==="es"?"DOCUMENTOS DE CIERRE":"CLOSING DOCUMENTS"}
      icon="file-check" color="#F59E0B" colorLight="rgba(245,158,11,.12)"
      docs={project.closingDocs||[]}
      onDelete={i=>{const d=[...(project.closingDocs||[])];d.splice(i,1);onUpdateProject&&onUpdateProject(project.id,{...project,closingDocs:d});}}
    />}

    {/* QUOTES BY CATEGORY */}
    {Object.keys(byCat).length>0&&<div style={{marginBottom:20}}>
      <div style={{fontSize:11,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginBottom:10}}>{t.quotesByCategory}</div>
      {Object.entries(byCat).map(([cat,cq])=><div key={cat} style={{marginBottom:14}}>
        {cq.map(q=>{const v=data.vendors.find(x=>x.id===q.vendorId);
          return <div key={q.id} onClick={()=>setSelectedQuote(q)} style={{background:T.wh,borderRadius:14,marginBottom:10,cursor:"pointer",border:`1px solid ${T.g15}`,boxShadow:"0 1px 4px rgba(0,0,0,.06)",overflow:"hidden",transition:"box-shadow .15s"}}
            onMouseEnter={e=>{e.currentTarget.style.boxShadow="0 4px 16px rgba(0,0,0,.1)"}} onMouseLeave={e=>{e.currentTarget.style.boxShadow="0 1px 4px rgba(0,0,0,.06)"}}>
            {/* Title row */}
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 14px 8px"}}>
              <div style={{fontWeight:700,fontSize:14,color:T.g9,flex:1,minWidth:0,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{q.title}</div>
              <i className="ti ti-chevron-right" style={{fontSize:13,color:T.g3,flexShrink:0,marginLeft:8}} aria-hidden="true"/>
            </div>
            {/* 2-col grid: Category | Vendor / Amount | Status */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",borderTop:`1px solid ${T.g15}`}}>
              <div style={{padding:"8px 14px",borderRight:`1px solid ${T.g15}`}}>
                <div style={{fontSize:10,fontWeight:600,color:T.g4,marginBottom:4,textTransform:"uppercase",letterSpacing:"0.06em"}}>Category</div>
                {q.category?<span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:6,background:T.g1,color:T.g6}}>{q.category}</span>:<span style={{fontSize:12,color:T.g4}}>—</span>}
              </div>
              <div style={{padding:"8px 14px"}}>
                <div style={{fontSize:10,fontWeight:600,color:T.g4,marginBottom:4,textTransform:"uppercase",letterSpacing:"0.06em"}}>Vendor</div>
                <div style={{fontSize:12,fontWeight:600,color:T.g7,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{v?.name||"—"}</div>
              </div>
              <div style={{padding:"8px 14px",borderTop:`1px solid ${T.g15}`,borderRight:`1px solid ${T.g15}`}}>
                <div style={{fontSize:10,fontWeight:600,color:T.g4,marginBottom:4,textTransform:"uppercase",letterSpacing:"0.06em"}}>Amount</div>
                <div style={{fontSize:15,fontWeight:800,color:T.g9}}>{q.amount?`$${Number(q.amount).toLocaleString()}`:"—"}</div>
              </div>
              <div style={{padding:"8px 14px",borderTop:`1px solid ${T.g15}`}}>
                <div style={{fontSize:10,fontWeight:600,color:T.g4,marginBottom:4,textTransform:"uppercase",letterSpacing:"0.06em"}}>Status</div>
                <Badge status={q.status}/>
              </div>
            </div>
            {(q.attachFile||q.attachUrl)&&<div style={{padding:"6px 14px 10px",display:"flex",gap:12,borderTop:`1px solid ${T.g15}`}}>
              {q.attachFile&&<div style={{fontSize:10,color:T.bl,display:"flex",alignItems:"center",gap:3}}><i className="ti ti-paperclip" style={{fontSize:10}} aria-hidden="true"/>Attachment</div>}
              {q.attachUrl&&<div style={{fontSize:10,color:T.bl,display:"flex",alignItems:"center",gap:3}}><i className="ti ti-link" style={{fontSize:10}} aria-hidden="true"/>Link</div>}
            </div>}
          </div>;
        })}
      </div>)}
    </div>}

    {/* LABOR / MATERIALS / MORTGAGE — dark card matching summary */}
    <div style={{background:`linear-gradient(135deg,${T.g9} 0%,${T.g8} 100%)`,borderRadius:16,padding:"4px",marginBottom:18}}>
      <div style={{display:"flex",gap:2}}>
        {[t.labor,t.materials,t.mortgage].map(tt=><button key={tt} onClick={()=>st(tt)} style={{flex:1,padding:"11px 6px",borderRadius:13,border:"none",cursor:"pointer",background:tab===tt?"rgba(255,255,255,.15)":"transparent",color:tab===tt?T.wh:"rgba(255,255,255,.5)",fontWeight:tab===t?800:500,fontSize:13,transition:"all .2s",fontFamily:SYS}}>{tt}</button>)}
      </div>
    </div>
    {exps.length>0&&<div style={{marginBottom:20}}>
      <div style={{fontSize:11,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginBottom:10}}>{t.expenses}</div>
      <Card noPad>
        {exps.map((e,i)=>{const v=data.vendors.find(x=>x.id===e.vendorId);
          return <div key={e.id} onClick={()=>setSelectedExpense(e)} style={{display:"flex",alignItems:"center",gap:10,padding:"12px 16px",borderBottom:i<exps.length-1?`1px solid ${T.g15}`:"none",cursor:"pointer"}}
            onMouseEnter={el=>el.currentTarget.style.background=T.g05} onMouseLeave={el=>el.currentTarget.style.background="transparent"}>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontWeight:600,fontSize:13,color:T.g9}}>{e.name}</div>
              <div style={{fontSize:11,color:T.g4,display:"flex",gap:6,flexWrap:"wrap"}}>
                {e.category&&<span>{e.category}</span>}
                {v&&<span>· {v.name}</span>}
                {e.date&&<span>· {e.date}</span>}
              </div>
            </div>
            <span style={{fontWeight:800,fontSize:14,flexShrink:0}}>${Number(e.amount).toLocaleString()}</span>
            <Badge status={e.paymentStatus}/>
            <i className="ti ti-chevron-right" style={{fontSize:13,color:T.g3,flexShrink:0}} aria-hidden="true"/>
          </div>;
        })}
      </Card>
    </div>}
    {quotes.length===0&&exps.length===0&&<div style={{textAlign:"center",padding:"40px",color:T.g4}}>
      <i className={`ti ti-${tab==="Labor"?"tools":"package"}`} style={{fontSize:36,display:"block",marginBottom:8,opacity:.25}} aria-hidden="true"/>
      <div style={{fontSize:14,fontWeight:600}}>No {tab.toLowerCase()} items yet</div>
    </div>}
  </div>;
}

function ContactsView({data,onRQ,onAddContact,onAddVendor,onUpdateVendor,onDeleteVendor,onUpdateContact,onDeleteContact,lang="en"}){
  const t=TR[lang]||TR.en;
  const [creating,setCreating]=useState(false);
  const [selected,setSelected]=useState(null);
  const [editing,setEditing]=useState(false);
  const [editForm,setEditForm]=useState(null);
  const [confirmDel,setConfirmDel]=useState(false);
  const [search,setSearch]=useState("");
  const [filterCat,setFilterCat]=useState("");
  const [view,setView]=useState("contacts"); // "contacts" | "vendors"
  const [selectedVendor,setSelectedVendor]=useState(null);
  const [editingVendor,setEditingVendor]=useState(false);
  const [vendorForm,setVendorForm]=useState(null);
  const [confirmDelVendor,setConfirmDelVendor]=useState(false);
  const mob=typeof window!=="undefined"&&window.innerWidth<768;
  const showList=!selected&&!creating||!mob;
  const showForm=selected||creating;
  const topCats=[...new Set(data.contacts.flatMap(c=>c.categories||[]))];
  const filtered=data.contacts.filter(c=>{
    const mq=!search||[c.firstName,c.lastName,c.role,c.email,c.company,...(c.categories||[])].some(x=>x&&x.toLowerCase().includes(search.toLowerCase()));
    const mc=!filterCat||(c.categories||[]).includes(filterCat);
    return mq&&mc;
  });

  /* ── VENDORS VIEW ── */

  if(!data.contacts.length&&!creating)return <div style={{textAlign:"center",padding:"60px 20px"}}>
    <i className="ti ti-users" style={{fontSize:48,color:T.g3,display:"block",marginBottom:12}} aria-hidden="true"/>
    <div style={{fontSize:16,fontWeight:700,color:T.g7,marginBottom:8}}>No contacts yet</div>
    <Btn icon="user-plus" onClick={()=>setCreating(true)}>Add First Contact</Btn>
  </div>;

  return <div style={{display:"flex",gap:16,minHeight:500,position:"relative"}}>

    {/* ── LIST PANEL ── */}
    {showList&&<div style={{
      width:mob?"100%":showForm?"320px":"100%",
      flexShrink:0,
      border:`1.5px solid ${T.g2}`,
      borderRadius:16,overflow:"hidden",
      background:T.wh,display:"flex",flexDirection:"column"
    }}>
      {/* ── Sticky header: search + filters ── */}
      <div style={{padding:"10px 14px 8px",borderBottom:`1px solid ${T.g15}`,flexShrink:0}}>
        <div style={{display:"flex",gap:8,marginBottom:12,alignItems:"center"}}>
          <div style={{position:"relative",flex:1}}>
            <i className="ti ti-search" style={{position:"absolute",left:11,top:"50%",transform:"translateY(-50%)",color:T.g4,fontSize:14,pointerEvents:"none"}} aria-hidden="true"/>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search…" style={{...IS,padding:"8px 10px 8px 32px",borderRadius:10,width:"100%",fontSize:14,border:`1px solid ${T.g2}`}}/>
          </div>
          <button onClick={()=>{setCreating(true);setSelected(null);}} style={{background:T.bl,border:"none",color:T.wh,borderRadius:10,padding:"8px 14px",cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:SYS,flexShrink:0,whiteSpace:"nowrap"}}>{lang==="es"?"+ Nuevo":"+ New"}</button>
        </div>
        {view==="contacts"&&topCats.length>0&&<div style={{display:"flex",flexWrap:"wrap",gap:5,paddingBottom:6}}>
          <button onClick={()=>setFilterCat("")} style={{padding:"4px 11px",borderRadius:20,fontSize:11,fontWeight:600,cursor:"pointer",border:"none",background:!filterCat?T.bl:T.g1,color:!filterCat?T.wh:T.g5,fontFamily:SYS}}>{lang==="es"?"Todos":"All"}</button>
          {topCats.map(cat=><button key={cat} onClick={()=>setFilterCat(filterCat===cat?"":cat)} style={{padding:"4px 11px",borderRadius:20,fontSize:11,fontWeight:600,cursor:"pointer",border:"none",background:filterCat===cat?T.bl:T.g1,color:filterCat===cat?T.wh:T.g5,fontFamily:SYS}}>{cat}</button>)}
        </div>}
        {/* Tab switcher — below filters */}
        <div style={{background:`linear-gradient(135deg,${T.g9} 0%,${T.g8} 100%)`,borderRadius:10,padding:"3px",marginTop:8}}>
          <div style={{display:"flex",gap:2}}>
            <button onClick={()=>setView("contacts")} style={{flex:1,padding:"8px 6px",borderRadius:8,border:"none",cursor:"pointer",background:view==="contacts"?"rgba(255,255,255,.15)":"transparent",color:view==="contacts"?T.wh:"rgba(255,255,255,.5)",fontWeight:view==="contacts"?800:500,fontSize:12,transition:"all .2s",fontFamily:SYS}}>{lang==="es"?"Contactos":"Contacts"}</button>
            <button onClick={()=>setView("vendors")} style={{flex:1,padding:"8px 6px",borderRadius:8,border:"none",cursor:"pointer",background:view==="vendors"?"rgba(255,255,255,.15)":"transparent",color:view==="vendors"?T.wh:"rgba(255,255,255,.5)",fontWeight:view==="vendors"?800:500,fontSize:12,transition:"all .2s",fontFamily:SYS}}>{lang==="es"?"Proveedores":"Vendors"}</button>
          </div>
        </div>
        <div style={{fontSize:11,color:T.g4,marginTop:8,fontWeight:500}}>
          {view==="contacts"?`${filtered.length} contact${filtered.length!==1?"s":""}`:`${data.vendors.length} vendor${data.vendors.length!==1?"s":""}`}
        </div>
      </div>

      {/* ── Scrollable content area — same height regardless of view ── */}
      <div style={{flex:1,overflowY:"auto"}}>
        {view==="contacts"&&filtered.map((c,idx)=>{
          const isSel=selected?.id===c.id;
          return <div key={c.id} onClick={()=>{setSelected(isSel?null:c);setCreating(false);}} style={{display:"flex",gap:12,alignItems:"center",padding:"13px 14px",background:isSel?T.bll:T.wh,cursor:"pointer",borderBottom:`1px solid ${T.g15}`,transition:"background .12s"}}>
            <Ava name={`${c.firstName} ${c.lastName}`} size={42} idx={idx}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontWeight:700,fontSize:14,color:isSel?T.bld:T.g9}}>{c.firstName} {c.lastName}</div>
              <div style={{fontSize:12,color:T.g4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{[c.role,c.company].filter(Boolean).join(" · ")||"No role"}</div>
              {(c.categories||[]).length>0&&<div style={{display:"flex",gap:3,marginTop:4,flexWrap:"wrap"}}>
                {c.categories.slice(0,3).map(cat=><span key={cat} style={{fontSize:10,padding:"2px 7px",borderRadius:6,background:T.bll,color:T.bld,fontWeight:700}}>{cat}</span>)}
              </div>}
            </div>
            <div style={{display:"flex",gap:6,flexShrink:0}}>
              {(c.phone||c.businessPhone)&&<button onClick={e=>{e.stopPropagation();window.location.href=`tel:${(c.phone||c.businessPhone).replace(/\D/g,"")}`}} style={{background:T.grl,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}} title="Call">
                <i className="ti ti-phone" style={{fontSize:14,color:T.gr}} aria-hidden="true"/>
              </button>}
              {(c.phone||c.businessPhone)&&<button onClick={e=>{e.stopPropagation();window.location.href=`sms:${(c.phone||c.businessPhone).replace(/\D/g,"")}`}} style={{background:T.bll,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}} title="Text">
                <i className="ti ti-message" style={{fontSize:14,color:T.bl}} aria-hidden="true"/>
              </button>}
              <button onClick={e=>{e.stopPropagation();onRQ(c,null);}} style={{background:T.g1,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}} title="Email">
                <i className="ti ti-mail" style={{fontSize:14,color:T.g5}} aria-hidden="true"/>
              </button>
            </div>
          </div>;
        })}
        {view==="vendors"&&(data.vendors.length===0
          ?<div style={{textAlign:"center",padding:"60px 20px"}}>
            <i className="ti ti-briefcase" style={{fontSize:48,color:T.g3,display:"block",marginBottom:12}} aria-hidden="true"/>
            <div style={{fontSize:16,fontWeight:700,color:T.g7}}>{lang==="es"?"Sin proveedores":"No vendors yet"}</div>
          </div>
          :data.vendors.map((v,idx)=>{
            const vc=data.contacts.filter(c=>c.company===v.name);
            const vq=data.quotes.filter(q=>q.vendorId===v.id);
            const isSel=selectedVendor?.id===v.id;
            return <div key={v.id} onClick={()=>setSelectedVendor(isSel?null:v)} style={{display:"flex",alignItems:"center",gap:12,padding:"13px 14px",borderBottom:`1px solid ${T.g15}`,background:isSel?T.bll:T.wh,cursor:"pointer",transition:"background .12s"}}>
              <Ava name={v.name} size={42} idx={idx+2}/>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:700,fontSize:14,color:isSel?T.bld:T.g9,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{v.name}</div>
                <div style={{fontSize:12,color:T.g4,marginTop:2}}>{vc.length} {lang==="es"?"contacto(s)":"contact(s)"} · {vq.length} {lang==="es"?"cotización(es)":"quote(s)"}</div>
                {v.phone&&<div style={{fontSize:11,color:T.g5,marginTop:1}}>{v.phone}</div>}
              </div>
              <div style={{display:"flex",gap:6,flexShrink:0}}>
                {v.phone&&<button onClick={e=>{e.stopPropagation();window.location.href=`tel:${v.phone.replace(/\D/g,"")}`}} style={{background:T.grl,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
                  <i className="ti ti-phone" style={{fontSize:14,color:T.gr}} aria-hidden="true"/>
                </button>}
                {v.phone&&<button onClick={e=>{e.stopPropagation();window.location.href=`sms:${v.phone.replace(/\D/g,"")}`}} style={{background:T.bll,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
                  <i className="ti ti-message" style={{fontSize:14,color:T.bl}} aria-hidden="true"/>
                </button>}
                <button onClick={e=>{e.stopPropagation();onRQ(null,v);}} style={{background:T.g1,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
                  <i className="ti ti-mail" style={{fontSize:14,color:T.g5}} aria-hidden="true"/>
                </button>
              </div>
            </div>;
          })
        )}
      </div>
    </div>}

    {/* ── VENDOR DETAIL MODAL ── */}
    {selectedVendor&&<Modal title={editingVendor?(lang==="es"?"Editar Proveedor":"Edit Vendor"):(lang==="es"?"Proveedor":"Vendor")} onClose={()=>{setSelectedVendor(null);setEditingVendor(false);setVendorForm(null);}}>
      {confirmDelVendor&&<ConfirmDelete label={selectedVendor.name} onConfirm={()=>{
        onDeleteVendor&&onDeleteVendor(selectedVendor.id);
        setSelectedVendor(null);setConfirmDelVendor(false);setEditingVendor(false);
      }} onCancel={()=>setConfirmDelVendor(false)}/>}
      {!confirmDelVendor&&!editingVendor&&<div>
        {/* Action buttons */}
        <div style={{display:"flex",gap:8,marginBottom:20}}>
          <button onClick={()=>{setEditingVendor(true);setVendorForm({...selectedVendor});}} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6,padding:"10px",borderRadius:12,border:`1px solid ${T.bl}`,background:T.bll,color:T.bld,fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:SYS}}>
            <i className="ti ti-pencil" style={{fontSize:14}} aria-hidden="true"/>{lang==="es"?"Editar":"Edit"}
          </button>
          <button onClick={()=>setConfirmDelVendor(true)} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6,padding:"10px",borderRadius:12,border:`1px solid ${T.rd}`,background:T.rdl,color:T.rd,fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:SYS}}>
            <i className="ti ti-trash" style={{fontSize:14}} aria-hidden="true"/>{lang==="es"?"Eliminar":"Delete"}
          </button>
        </div>
        {/* Dark header card */}
        <div style={{background:`linear-gradient(135deg,${T.g9} 0%,${T.g8} 100%)`,borderRadius:16,padding:"20px",marginBottom:20,display:"flex",alignItems:"center",gap:14}}>
          <Ava name={selectedVendor.name} size={52} idx={0}/>
          <div>
            <div style={{fontSize:18,fontWeight:800,color:T.wh}}>{selectedVendor.name}</div>
            {selectedVendor.email&&<div style={{fontSize:12,color:"rgba(255,255,255,.6)",marginTop:3}}>{selectedVendor.email}</div>}
          </div>
        </div>
        {/* Info rows */}
        {[
          {icon:"phone",label:lang==="es"?"Teléfono":"Phone",val:selectedVendor.phone},
          {icon:"mail",label:"Email",val:selectedVendor.email},
          {icon:"map-pin",label:lang==="es"?"Dirección":"Address",val:selectedVendor.address},
          {icon:"notes",label:lang==="es"?"Notas":"Notes",val:selectedVendor.notes},
        ].filter(r=>r.val).map(r=><div key={r.label} style={{display:"flex",alignItems:"flex-start",gap:12,padding:"12px 0",borderBottom:`1px solid ${T.g15}`}}>
          <div style={{width:32,height:32,borderRadius:8,background:T.g1,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
            <i className={`ti ti-${r.icon}`} style={{fontSize:15,color:T.g5}} aria-hidden="true"/>
          </div>
          <div>
            <div style={{fontSize:11,color:T.g4,fontWeight:600,marginBottom:2}}>{r.label}</div>
            <div style={{fontSize:14,fontWeight:600,color:T.g9}}>{r.val}</div>
          </div>
        </div>)}
        {/* Related contacts */}
        {data.contacts.filter(c=>c.company===selectedVendor.name).length>0&&<div style={{marginTop:16}}>
          <div style={{fontSize:11,fontWeight:800,color:T.g4,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:10}}>{lang==="es"?"CONTACTOS":"CONTACTS"}</div>
          {data.contacts.filter(c=>c.company===selectedVendor.name).map((c,i)=><div key={c.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0",borderBottom:`1px solid ${T.g15}`}}>
            <Ava name={`${c.firstName} ${c.lastName}`} size={32} idx={i}/>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:700,color:T.g9}}>{c.firstName} {c.lastName}</div>
              {c.role&&<div style={{fontSize:11,color:T.g5}}>{c.role}</div>}
            </div>
          </div>)}
        </div>}
      </div>}
      {!confirmDelVendor&&editingVendor&&vendorForm&&<div>
        {[
          {key:"name",label:lang==="es"?"Nombre":"Name",placeholder:"Company name"},
          {key:"phone",label:lang==="es"?"Teléfono":"Phone",placeholder:"555-000-0000"},
          {key:"email",label:"Email",placeholder:"company@email.com"},
          {key:"address",label:lang==="es"?"Dirección":"Address",placeholder:"123 Main St"},
          {key:"notes",label:lang==="es"?"Notas":"Notes",placeholder:"Notes…",multi:true},
        ].map(f=><FF key={f.key} label={f.label}>
          {f.multi
            ?<Txa value={vendorForm[f.key]||""} onChange={e=>setVendorForm(p=>({...p,[f.key]:e.target.value}))} placeholder={f.placeholder}/>
            :<Inp value={vendorForm[f.key]||""} onChange={e=>setVendorForm(p=>({...p,[f.key]:e.target.value}))} placeholder={f.placeholder}/>
          }
        </FF>)}
        <div style={{display:"flex",gap:10,marginTop:8}}>
          <button onClick={()=>{setEditingVendor(false);setVendorForm(null);}} style={{flex:1,padding:"12px",borderRadius:12,border:`1px solid ${T.g2}`,background:T.wh,color:T.g6,fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:SYS}}>{lang==="es"?"Cancelar":"Cancel"}</button>
          <button onClick={()=>{
            onAddVendor&&onAddVendor(vendorForm);
            setSelectedVendor(vendorForm);
            setEditingVendor(false);setVendorForm(null);
          }} style={{flex:2,padding:"12px",borderRadius:12,border:"none",background:T.bl,color:T.wh,fontWeight:700,fontSize:13,cursor:"pointer",fontFamily:SYS}}>{lang==="es"?"Guardar Cambios":"Save Changes"}</button>
        </div>
      </div>}
    </Modal>}
    {showForm&&<div style={{
      flex:1,width:mob?"100%":undefined,
      border:`1.5px solid ${T.g2}`,borderRadius:16,
      overflow:"hidden",background:T.wh,
      display:"flex",flexDirection:"column",minWidth:0
    }}>
      {creating
        ?<div style={{flex:1,overflowY:"auto",padding:"0 20px 28px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"16px 0 12px",position:"sticky",top:0,background:T.wh,zIndex:2,borderBottom:`1px solid ${T.g15}`,marginBottom:4}}>
            <div>
              {mob&&<button onClick={()=>setCreating(false)} style={{display:"flex",alignItems:"center",gap:5,background:"none",border:"none",cursor:"pointer",color:T.bl,fontSize:13,fontWeight:700,fontFamily:SYS,padding:"0 0 6px"}}>
                <i className="ti ti-arrow-left" style={{fontSize:14}} aria-hidden="true"/>Back
              </button>}
              <div style={{fontSize:17,fontWeight:800,color:T.g9}}>New Contact</div>
              <div style={{fontSize:12,color:T.g4,marginTop:1}}>Fill in the details below</div>
            </div>
            {!mob&&<button onClick={()=>setCreating(false)} style={{background:T.g1,border:"none",borderRadius:"50%",width:28,height:28,cursor:"pointer",color:T.g5,fontSize:14,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>}
          </div>
          <ContactForm vendors={data.vendors} onSave={f=>{onAddContact(f);setCreating(false);}} onClose={()=>setCreating(false)} onNewVendor={onAddVendor} lang={lang}/>
        </div>
        :<div style={{flex:1,overflowY:"auto",padding:"0 20px 28px"}}>
          {/* ── Header ── */}
          <div style={{padding:"10px 0 10px",position:"sticky",top:0,background:T.wh,zIndex:2,borderBottom:`1px solid ${T.g15}`}}>
            {!editing
              ?<div style={{display:"flex",alignItems:"center",gap:6}}>
                {mob&&<button onClick={()=>{setSelected(null);setEditing(false);}} style={{background:T.g1,border:"none",borderRadius:"50%",width:32,height:32,cursor:"pointer",color:T.g5,flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <i className="ti ti-arrow-left" style={{fontSize:15}} aria-hidden="true"/>
                </button>}
                {/* Quote */}
                <button onClick={()=>onRQ(selected,null)} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:4,background:T.orl,border:`1px solid ${T.or}`,borderRadius:999,padding:"9px 4px",cursor:"pointer",color:T.or,fontSize:12,fontWeight:700,fontFamily:SYS,minWidth:0}}>
                  <i className="ti ti-mail" style={{fontSize:13,flexShrink:0}} aria-hidden="true"/>
                  <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{lang==="es"?"Cotizar":"Quote"}</span>
                </button>
                {/* Edit */}
                <button onClick={()=>{setEditing(true);setEditForm({...selected});}} style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:4,background:T.bll,border:`1px solid ${T.bl}`,borderRadius:999,padding:"9px 4px",cursor:"pointer",color:T.bld,fontSize:12,fontWeight:700,fontFamily:SYS,minWidth:0}}>
                  <i className="ti ti-pencil" style={{fontSize:13,flexShrink:0}} aria-hidden="true"/>
                  <span style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{lang==="es"?"Editar":"Edit"}</span>
                </button>
                {/* Share via SMS */}
                <button onClick={()=>{
                  const c=selected;
                  const msg=`${c.firstName} ${c.lastName}${c.role?` — ${c.role}`:""}${c.company?` @ ${c.company}`:""}${c.phone?`\n📞 ${c.phone}`:""}${c.email?`\n✉️ ${c.email}`:""}`;
                  window.location.href=`sms:?body=${encodeURIComponent(msg)}`;
                }} style={{display:"flex",alignItems:"center",justifyContent:"center",background:"rgba(52,199,89,.12)",border:`1px solid ${T.gr}`,borderRadius:999,width:38,height:38,cursor:"pointer",flexShrink:0}}>
                  <i className="ti ti-share" style={{fontSize:14,color:T.gr}} aria-hidden="true"/>
                </button>
                {/* Delete — icon only */}
                <button onClick={()=>setConfirmDel(true)} style={{display:"flex",alignItems:"center",justifyContent:"center",background:T.rdl,border:`1px solid ${T.rd}`,borderRadius:999,width:38,height:38,cursor:"pointer",flexShrink:0}}>
                  <i className="ti ti-trash" style={{fontSize:14,color:T.rd}} aria-hidden="true"/>
                </button>
                {!mob&&<button onClick={()=>{setSelected(null);setEditing(false);}} style={{background:T.g1,border:"none",borderRadius:"50%",width:28,height:28,cursor:"pointer",color:T.g5,flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14}}>✕</button>}
              </div>
              :<div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  {mob&&<button onClick={()=>setEditing(false)} style={{background:T.g1,border:"none",borderRadius:"50%",width:30,height:30,cursor:"pointer",color:T.g5,display:"flex",alignItems:"center",justifyContent:"center"}}>
                    <i className="ti ti-arrow-left" style={{fontSize:15}} aria-hidden="true"/>
                  </button>}
                  <span style={{fontSize:15,fontWeight:800,color:T.g9}}>{lang==="es"?"Editar Contacto":"Edit Contact"}</span>
                </div>
                <button onClick={()=>setEditing(false)} style={{background:T.g1,border:"none",borderRadius:8,padding:"5px 12px",cursor:"pointer",color:T.g5,fontSize:12,fontWeight:700,fontFamily:SYS}}>Cancel</button>
              </div>
            }
          </div>
          {confirmDel&&<ConfirmDelete label={`${selected.firstName} ${selected.lastName}`} onConfirm={()=>{onDeleteContact&&onDeleteContact(selected.id);setSelected(null);setEditing(false);setConfirmDel(false);}} onCancel={()=>setConfirmDel(false)}/>}

          {/* ── EDIT MODE ── */}
          {editing&&editForm&&<div style={{paddingTop:12}}>
            {/* Identity */}
            <div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginBottom:10,display:"flex",alignItems:"center",gap:6}}>
              <div style={{width:3,height:12,borderRadius:2,background:T.or}}/>Identity
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <FF label="First name"><Inp value={editForm.firstName||""} onChange={e=>setEditForm(f=>({...f,firstName:e.target.value}))}/></FF>
              <FF label="Last name"><Inp value={editForm.lastName||""} onChange={e=>setEditForm(f=>({...f,lastName:e.target.value}))}/></FF>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <FF label="Role / Trade"><Inp value={editForm.role||""} onChange={e=>setEditForm(f=>({...f,role:e.target.value}))} placeholder="Estimator"/></FF>
              <FF label="Status"><Sel value={editForm.status||"Active"} onChange={v=>setEditForm(f=>({...f,status:v}))} options={["Active","Preferred","Inactive","Blacklisted"]}/></FF>
            </div>
            {/* Company */}
            <div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",margin:"14px 0 10px",display:"flex",alignItems:"center",gap:6}}>
              <div style={{width:3,height:12,borderRadius:2,background:T.or}}/>Company
            </div>
            <FF label="Company / Vendor">
              <CompanyPicker vendors={data.vendors} value={editForm.company||""} onChange={v=>setEditForm(f=>({...f,company:v}))} onNewVendor={nv=>{onAddVendor&&onAddVendor(nv);}}/>
            </FF>
            {/* Contact info */}
            <div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",margin:"14px 0 10px",display:"flex",alignItems:"center",gap:6}}>
              <div style={{width:3,height:12,borderRadius:2,background:T.or}}/>Contact Info
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <FF label="Direct phone"><Inp value={editForm.phone||""} onChange={e=>setEditForm(f=>({...f,phone:e.target.value}))} placeholder="555-000-0000"/></FF>
              <FF label="Business phone"><Inp value={editForm.businessPhone||""} onChange={e=>setEditForm(f=>({...f,businessPhone:e.target.value}))} placeholder="555-000-0000"/></FF>
            </div>
            <FF label="Email"><Inp value={editForm.email||""} onChange={e=>setEditForm(f=>({...f,email:e.target.value}))} placeholder="email@company.com"/></FF>
            <FF label="Address"><Inp value={editForm.address||""} onChange={e=>setEditForm(f=>({...f,address:e.target.value}))}/></FF>
            {/* Categories */}
            <div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",margin:"14px 0 10px",display:"flex",alignItems:"center",gap:6}}>
              <div style={{width:3,height:12,borderRadius:2,background:T.or}}/>Trade Categories
            </div>
            <CatPicker selected={editForm.categories||[]} onChange={v=>setEditForm(f=>({...f,categories:v}))}/>
            {/* Notes */}
            <div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",margin:"14px 0 10px",display:"flex",alignItems:"center",gap:6}}>
              <div style={{width:3,height:12,borderRadius:2,background:T.or}}/>Notes
            </div>
            <FF label="Internal notes"><Txa value={editForm.notes||""} onChange={e=>setEditForm(f=>({...f,notes:e.target.value}))} rows={3} placeholder="Reliability notes, pricing history…"/></FF>
            {/* Save */}
            <div style={{display:"flex",gap:10,marginTop:12,paddingTop:12,borderTop:`1px solid ${T.g15}`}}>
              <Btn variant="secondary" onClick={()=>setEditing(false)} full>Cancel</Btn>
              <Btn icon="check" onClick={()=>{
                const updated={...selected,...editForm};
                onUpdateContact&&onUpdateContact(selected.id,updated);
                setSelected(updated);
                setEditing(false);
              }} disabled={!editForm.firstName} full>Save Changes</Btn>
            </div>
          </div>}

          {/* ── VIEW MODE ── */}
          {!editing&&<>
            <div style={{display:"flex",gap:14,alignItems:"center",padding:"16px 0",borderBottom:`1px solid ${T.g15}`}}>
              <Ava name={`${selected.firstName} ${selected.lastName}`} size={56} idx={0}/>
              <div>
                <div style={{fontSize:20,fontWeight:800,color:T.g9}}>{selected.firstName} {selected.lastName}</div>
                <div style={{fontSize:13,color:T.g5,marginTop:2}}>{[selected.role,selected.company].filter(Boolean).join(" · ")||"No role"}</div>
                {selected.status&&selected.status!=="Active"&&<span style={{display:"inline-block",marginTop:5,fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:8,background:T.bll,color:T.bld}}>{selected.status}</span>}
              </div>
            </div>
            {[{icon:"phone",label:"Direct Phone",val:selected.phone},{icon:"building",label:"Business Phone",val:selected.businessPhone},{icon:"mail",label:"Email",val:selected.email},{icon:"map-pin",label:"Address",val:selected.address},{icon:"message",label:"Preferred Contact",val:selected.preferredContact}].filter(r=>r.val).map(r=>{
              let pressTimer=null;
              let copyDone=false;

              const copyToClipboard=(val)=>{
                // Try modern API first
                if(navigator.clipboard && navigator.clipboard.writeText){
                  navigator.clipboard.writeText(val).then(()=>toast("Copied!")).catch(()=>fallbackCopy(val));
                } else {
                  fallbackCopy(val);
                }
              };

              const fallbackCopy=(val)=>{
                const el=document.createElement("input");
                el.value=val;
                el.style.cssText="position:fixed;top:0;left:0;opacity:0;font-size:16px;";
                document.body.appendChild(el);
                el.focus();
                el.setSelectionRange(0,val.length);
                try{document.execCommand("copy");toast("Copied!");}catch(e){}
                document.body.removeChild(el);
              };

              const startPress=(e)=>{
                e.preventDefault();
                copyDone=false;
                pressTimer=setTimeout(()=>{
                  copyDone=true;
                  copyToClipboard(r.val);
                },500);
              };
              const endPress=(e)=>{
                if(pressTimer){clearTimeout(pressTimer);pressTimer=null;}
              };

              return <div key={r.label}
                onTouchStart={startPress}
                onTouchEnd={endPress}
                onTouchCancel={endPress}
                onTouchMove={endPress}
                onMouseDown={startPress}
                onMouseUp={endPress}
                onMouseLeave={endPress}
                style={{display:"flex",gap:10,padding:"12px 0",borderBottom:`1px solid ${T.g15}`,WebkitUserSelect:"none",userSelect:"none",WebkitTouchCallout:"none",cursor:"default",touchAction:"none"}}>
                <div style={{width:26,height:26,borderRadius:8,background:T.g1,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,pointerEvents:"none"}}>
                  <i className={`ti ti-${r.icon}`} style={{fontSize:13,color:T.g5}} aria-hidden="true"/>
                </div>
                <div style={{pointerEvents:"none"}}>
                  <div style={{fontSize:10,color:T.g4,fontWeight:600}}>{r.label}</div>
                  <div style={{fontSize:13,color:T.g9,fontWeight:600,marginTop:1}}>{r.val}</div>
                </div>
              </div>;
            })}
            {(selected.categories||[]).length>0&&<div style={{marginTop:14}}>
              <div style={{fontSize:11,fontWeight:700,color:T.g4,marginBottom:8,textTransform:"uppercase",letterSpacing:"0.06em"}}>Trade Categories</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:5}}>{selected.categories.map(cat=><span key={cat} style={{fontSize:11,padding:"3px 9px",borderRadius:8,background:T.bll,color:T.bld,fontWeight:700}}>{cat}</span>)}</div>
            </div>}
            {selected.notes&&<div style={{marginTop:14}}>
              <div style={{fontSize:11,fontWeight:700,color:T.g4,marginBottom:6,textTransform:"uppercase",letterSpacing:"0.06em"}}>Notes</div>
              <div style={{background:T.g05,borderRadius:10,padding:"10px 12px",fontSize:13,color:T.g7,lineHeight:1.6}}>{selected.notes}</div>
            </div>}
            {data.quotes.filter(q=>q.contactId===selected.id).length>0&&<div style={{marginTop:14}}>
              <div style={{fontSize:11,fontWeight:700,color:T.g4,marginBottom:8,textTransform:"uppercase",letterSpacing:"0.06em"}}>Quote History</div>
              {data.quotes.filter(q=>q.contactId===selected.id).slice(0,5).map(q=>(
                <div key={q.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 10px",borderRadius:10,background:T.g05,marginBottom:6}}>
                  <div><div style={{fontSize:13,fontWeight:600,color:T.g8}}>{q.title}</div><div style={{fontSize:11,color:T.g4}}>{q.category}</div></div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    {q.amount&&<span style={{fontWeight:700,fontSize:13}}>${Number(q.amount).toLocaleString()}</span>}
                    <Badge status={q.status}/>
                  </div>
                </div>
              ))}
            </div>}
          </>}
        </div>
      }
    </div>}
  </div>;
}

function VendorsView({data,onRQ,onAdd}){
  if(!data.vendors.length)return <div style={{textAlign:"center",padding:"60px 20px"}}>
    <i className="ti ti-briefcase" style={{fontSize:48,color:T.g3,display:"block",marginBottom:12}} aria-hidden="true"/>
    <div style={{fontSize:16,fontWeight:700,color:T.g7,marginBottom:8}}>No vendors yet</div>
    <Btn icon="plus" onClick={onAdd}>Add first vendor</Btn>
  </div>;
  return <div style={{display:"flex",flexDirection:"column",gap:10}}>
    {data.vendors.map((v,idx)=>{
      const vc=data.contacts.filter(c=>c.company===v.name);
      const vq=data.quotes.filter(q=>q.vendorId===v.id);
      return <Card key={v.id}>
        <div style={{display:"flex",gap:12,alignItems:"center"}}>
          <Ava name={v.name} size={46} idx={idx+2}/>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontWeight:700,fontSize:14,color:T.g9}}>{v.name}</div>
            <div style={{fontSize:12,color:T.g4,marginTop:1}}>{vc.length} contact{vc.length!==1?"s":""} · {vq.length} quote{vq.length!==1?"s":""}</div>
            {v.phone&&<div style={{fontSize:12,color:T.g5,marginTop:2}}>{v.phone}</div>}
            {(v.categories||[]).length>0&&<div style={{display:"flex",gap:4,flexWrap:"wrap",marginTop:5}}>{v.categories.slice(0,3).map(cat=><span key={cat} style={{fontSize:10,padding:"2px 7px",borderRadius:6,background:T.orl,color:T.or,fontWeight:700}}>{cat}</span>)}</div>}
          </div>
          <button onClick={()=>onRQ(null,v)} style={{background:T.g1,border:"none",borderRadius:8,width:32,height:32,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>
            <i className="ti ti-mail" style={{fontSize:15,color:T.g5}} aria-hidden="true"/>
          </button>
        </div>
      </Card>;
    })}
  </div>;
}

function SmartSearch({data,onRQ,onNav,lang="en"}){
  const t=TR[lang]||TR.en;
  const [q,sq]=useState("");
  const [filter,setFilter]=useState("all");
  const [res,setRes]=useState({contacts:[],vendors:[],projects:[],quotes:[],expenses:[]});

  useEffect(()=>{
    if(!q.trim()){setRes({contacts:[],vendors:[],projects:[],quotes:[],expenses:[]});return;}
    const lq=q.toLowerCase();

    const contacts=data.contacts.filter(c=>
      [c.firstName,c.lastName,c.role,c.email,c.company,...(c.categories||[])].some(f=>f&&f.toLowerCase().includes(lq))
    );
    const vendors=data.vendors.filter(v=>
      [v.name,v.email,v.phone,...(v.categories||[])].some(f=>f&&f.toLowerCase().includes(lq))
    );
    const projects=data.projects.filter(p=>
      [p.name,p.address,p.description,p.status].some(f=>f&&f.toLowerCase().includes(lq))
    );
    const quotes=data.quotes.filter(q2=>{
      const v=data.vendors.find(x=>x.id===q2.vendorId);
      const p=data.projects.find(x=>x.id===q2.projectId);
      return [q2.title,q2.category,q2.tab,q2.status,v?.name,p?.name].some(f=>f&&f.toLowerCase().includes(lq));
    });
    const expenses=data.expenses.filter(e=>{
      const v=data.vendors.find(x=>x.id===e.vendorId);
      const p=data.projects.find(x=>x.id===e.projectId);
      return [e.name,e.category,e.tab,e.paymentStatus,v?.name,p?.name].some(f=>f&&f.toLowerCase().includes(lq));
    });

    setRes({contacts,vendors,projects,quotes,expenses});
  },[q,data]);

  const total=res.contacts.length+res.vendors.length+res.projects.length+res.quotes.length+res.expenses.length;

  const FILTERS=[
    {id:"all",    label:"All",      count:total},
    {id:"projects", label:"Projects", count:res.projects.length,  icon:"building"},
    {id:"quotes",   label:"Quotes",   count:res.quotes.length,    icon:"file-text"},
    {id:"contacts", label:"Contacts", count:res.contacts.length,  icon:"users"},
    {id:"vendors",  label:"Vendors",  count:res.vendors.length,   icon:"briefcase"},
    {id:"expenses", label:"Expenses", count:res.expenses.length,  icon:"receipt"},
  ];

  const TypeTag=({label,color="blue"})=>{
    const cfg={blue:{bg:T.bll,co:T.bld},orange:{bg:T.orl,co:T.or},green:{bg:T.grl,co:"#166534"},purple:{bg:T.pul,co:"#5B2D9E"},red:{bg:T.rdl,co:"#B91C1C"}};
    const c=cfg[color]||cfg.blue;
    return <span style={{fontSize:9.5,fontWeight:700,padding:"2px 7px",borderRadius:6,background:c.bg,color:c.co,flexShrink:0,textTransform:"uppercase",letterSpacing:"0.04em"}}>{label}</span>;
  };

  const fmt=n=>"$"+Math.round(n).toLocaleString();

  return <div>
    {/* Search bar */}
    <div style={{position:"relative",marginBottom:14}}>
      <i className="ti ti-search" style={{position:"absolute",left:13,top:"50%",transform:"translateY(-50%)",color:T.g4,fontSize:18,pointerEvents:"none"}} aria-hidden="true"/>
      <input value={q} onChange={e=>sq(e.target.value)}
        placeholder={t.searchPlaceholder}
        style={{...IS,paddingLeft:42,borderRadius:14}}/>
      {q&&<button onClick={()=>{sq("");setFilter("all");}} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:T.g2,border:"none",borderRadius:"50%",width:22,height:22,cursor:"pointer",color:T.g6,fontSize:13,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>}
    </div>

    {/* Filter tabs — only show when there are results */}
    {q&&total>0&&<div style={{display:"flex",gap:6,overflowX:"auto",marginBottom:16,paddingBottom:2}}>
      {FILTERS.filter(f=>f.id==="all"||f.count>0).map(f=>(
        <button key={f.id} onClick={()=>setFilter(f.id)} style={{
          display:"flex",alignItems:"center",gap:5,
          padding:"6px 12px",borderRadius:20,fontSize:12,fontWeight:700,
          cursor:"pointer",border:"none",flexShrink:0,fontFamily:SYS,
          background:filter===f.id?T.bl:T.g1,
          color:filter===f.id?T.wh:T.g5,
          transition:"all .15s",
        }}>
          {f.icon&&<i className={`ti ti-${f.icon}`} style={{fontSize:13}} aria-hidden="true"/>}
          {f.label}
          {f.count>0&&<span style={{
            fontSize:10,fontWeight:800,padding:"1px 6px",borderRadius:10,
            background:filter===f.id?"rgba(255,255,255,.25)":"rgba(0,0,0,.08)",
          }}>{f.count}</span>}
        </button>
      ))}
    </div>}

    {/* Quick filters when empty */}
    {!q&&<div style={{background:T.wh,borderRadius:16,border:`1px solid ${T.g15}`,overflow:"hidden",marginBottom:20,boxShadow:"0 1px 4px rgba(0,0,0,.06)"}}>
      {/* Header */}
      <div style={{padding:"12px 16px 10px",borderBottom:`1px solid ${T.g15}`,display:"flex",alignItems:"center",gap:8}}>
        <i className="ti ti-search" style={{fontSize:14,color:T.g4}} aria-hidden="true"/>
        <span style={{fontSize:12,fontWeight:700,color:T.g5,letterSpacing:"0.07em",textTransform:"uppercase"}}>{t.quickSearch}</span>
      </div>
      {/* Tags grouped in rows */}
      <div style={{padding:"12px 14px 14px"}}>
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {[
            {tag:"Plumbing",icon:"droplet"},
            {tag:"Electrical",icon:"bolt"},
            {tag:"Stone",icon:"mountain"},
            {tag:"Tiles",icon:"grid-dots"},
            {tag:"HVAC",icon:"air-conditioning"},
            {tag:"Flooring",icon:"layout-board"},
            {tag:"Kitchen",icon:"tools-kitchen"},
            {tag:"Windows",icon:"window"},
            {tag:"Paint",icon:"brush"},
            {tag:"Cabinets",icon:"box"},
            {tag:"Design",icon:"pencil"},
            {tag:"Approved",icon:"circle-check"},
            {tag:"Pending",icon:"clock"},
            {tag:"Unpaid",icon:"receipt"},
          ].map(({tag,icon})=>(
            <button key={tag} onClick={()=>sq(tag)} style={{
              display:"flex",alignItems:"center",gap:5,
              padding:"6px 12px",borderRadius:20,
              fontSize:12,fontWeight:500,
              cursor:"pointer",
              border:`1px solid ${T.g2}`,
              background:T.g05,
              color:T.g6,
              fontFamily:SYS,
              transition:"all .15s",
            }}
              onMouseEnter={e=>{e.currentTarget.style.background=T.g1;e.currentTarget.style.color=T.g9;}}
              onMouseLeave={e=>{e.currentTarget.style.background=T.g05;e.currentTarget.style.color=T.g6;}}
            >
              <i className={`ti ti-${icon}`} style={{fontSize:12,flexShrink:0}} aria-hidden="true"/>
              {tag}
            </button>
          ))}
        </div>
      </div>
    </div>}

    {/* No results */}
    {q&&total===0&&<div style={{textAlign:"center",padding:"48px 20px",color:T.g4}}>
      <i className="ti ti-mood-empty" style={{fontSize:40,display:"block",marginBottom:8,opacity:.3}} aria-hidden="true"/>
      <div style={{fontSize:15,fontWeight:700,color:T.g6,marginBottom:4}}>No results for "{q}"</div>
      <div style={{fontSize:13}}>Try a different keyword</div>
    </div>}

    {/* Results */}
    <div style={{display:"flex",flexDirection:"column",gap:8}}>

      {/* PROJECTS */}
      {(filter==="all"||filter==="projects")&&res.projects.length>0&&<>
        {filter==="all"&&<div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginTop:4}}>PROJECTS</div>}
        {res.projects.map(p=>{
          const pExp=data.expenses.filter(e=>e.projectId===p.id).reduce((s,e)=>s+(Number(e.amount)||0),0);
          return <Card key={p.id} onClick={()=>onNav&&onNav("projects",p)}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <div style={{width:40,height:40,borderRadius:12,background:T.g1,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                <i className="ti ti-building" style={{fontSize:20,color:T.g5}} aria-hidden="true"/>
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
                  <span style={{fontWeight:700,fontSize:14,color:T.g9,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{p.name}</span>
                  <TypeTag label="Project" color="blue"/>
                </div>
                <div style={{fontSize:12,color:T.g4,display:"flex",gap:10,flexWrap:"wrap"}}>
                  {p.address&&<span><i className="ti ti-map-pin" style={{fontSize:11,marginRight:2}} aria-hidden="true"/>{p.address}</span>}
                  {pExp>0&&<span style={{fontWeight:600,color:T.g6}}>{fmt(pExp)} spent</span>}
                </div>
              </div>
              <Badge status={p.status}/>
            </div>
          </Card>;
        })}
      </>}

      {/* QUOTES */}
      {(filter==="all"||filter==="quotes")&&res.quotes.length>0&&<>
        {filter==="all"&&<div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginTop:4}}>QUOTES</div>}
        {res.quotes.map(q2=>{
          const v=data.vendors.find(x=>x.id===q2.vendorId);
          const p=data.projects.find(x=>x.id===q2.projectId);
          return <Card key={q2.id}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:4}}>
                  <span style={{fontWeight:700,fontSize:14,color:T.g9,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{q2.title}</span>
                  <TypeTag label="Quote" color="purple"/>
                </div>
                <div style={{display:"flex",gap:8,fontSize:12,color:T.g4,flexWrap:"wrap"}}>
                  {p&&<span><i className="ti ti-building" style={{fontSize:11,marginRight:2}} aria-hidden="true"/>{p.name}</span>}
                  {v&&<span><i className="ti ti-briefcase" style={{fontSize:11,marginRight:2}} aria-hidden="true"/>{v.name}</span>}
                  {q2.category&&<span>{q2.tab} · {q2.category}</span>}
                </div>
              </div>
              <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:4,flexShrink:0}}>
                {q2.amount&&<span style={{fontWeight:800,fontSize:14,color:T.g9}}>${Number(q2.amount).toLocaleString()}</span>}
                <Badge status={q2.status}/>
              </div>
            </div>
          </Card>;
        })}
      </>}

      {/* CONTACTS */}
      {(filter==="all"||filter==="contacts")&&res.contacts.length>0&&<>
        {filter==="all"&&<div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginTop:4}}>CONTACTS</div>}
        {res.contacts.map((c,idx)=>(
          <Card key={c.id}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <Ava name={`${c.firstName} ${c.lastName}`} size={42} idx={idx}/>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
                  <span style={{fontWeight:700,fontSize:14,color:T.g9}}>{c.firstName} {c.lastName}</span>
                  <TypeTag label="Contact" color="blue"/>
                </div>
                <div style={{fontSize:12,color:T.g4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                  {[c.role,c.company].filter(Boolean).join(" · ")}
                </div>
                {c.phone&&<div style={{fontSize:11,color:T.g5,marginTop:2}}>{c.phone}</div>}
              </div>
              <div style={{display:"flex",gap:6,flexShrink:0}}>
                {(c.phone||c.businessPhone)&&<button onClick={()=>window.location.href=`tel:${(c.phone||c.businessPhone).replace(/\D/g,"")}`} style={{background:T.grl,border:"none",borderRadius:8,width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
                  <i className="ti ti-phone" style={{fontSize:13,color:T.gr}} aria-hidden="true"/>
                </button>}
                {(c.phone||c.businessPhone)&&<button onClick={()=>window.location.href=`sms:${(c.phone||c.businessPhone).replace(/\D/g,"")}`} style={{background:T.bll,border:"none",borderRadius:8,width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
                  <i className="ti ti-message" style={{fontSize:13,color:T.bl}} aria-hidden="true"/>
                </button>}
                <button onClick={()=>onRQ(c,null)} style={{background:T.g1,border:"none",borderRadius:8,width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
                  <i className="ti ti-mail" style={{fontSize:13,color:T.g5}} aria-hidden="true"/>
                </button>
              </div>
            </div>
          </Card>
        ))}
      </>}

      {/* VENDORS */}
      {(filter==="all"||filter==="vendors")&&res.vendors.length>0&&<>
        {filter==="all"&&<div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginTop:4}}>VENDORS</div>}
        {res.vendors.map((v,idx)=>(
          <Card key={v.id}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <Ava name={v.name} size={42} idx={idx+3}/>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
                  <span style={{fontWeight:700,fontSize:14,color:T.g9}}>{v.name}</span>
                  <TypeTag label="Vendor" color="orange"/>
                </div>
                {(v.categories||[]).length>0&&<div style={{fontSize:12,color:T.g4,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{v.categories.join(", ")}</div>}
                {v.phone&&<div style={{fontSize:11,color:T.g5,marginTop:2}}>{v.phone}</div>}
              </div>
              <Btn size="sm" variant="outline_orange" onClick={()=>onRQ(null,v)}>Quote</Btn>
            </div>
          </Card>
        ))}
      </>}

      {/* EXPENSES */}
      {(filter==="all"||filter==="expenses")&&res.expenses.length>0&&<>
        {filter==="all"&&<div style={{fontSize:10,fontWeight:800,color:T.g4,letterSpacing:"0.09em",textTransform:"uppercase",marginTop:4}}>EXPENSES</div>}
        {res.expenses.map(e=>{
          const v=data.vendors.find(x=>x.id===e.vendorId);
          const p=data.projects.find(x=>x.id===e.projectId);
          return <Card key={e.id}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:4}}>
                  <span style={{fontWeight:700,fontSize:14,color:T.g9,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{e.name}</span>
                  <TypeTag label="Expense" color="green"/>
                </div>
                <div style={{display:"flex",gap:8,fontSize:12,color:T.g4,flexWrap:"wrap"}}>
                  {p&&<span><i className="ti ti-building" style={{fontSize:11,marginRight:2}} aria-hidden="true"/>{p.name}</span>}
                  {v&&<span><i className="ti ti-briefcase" style={{fontSize:11,marginRight:2}} aria-hidden="true"/>{v.name}</span>}
                  {e.category&&<span>{e.tab} · {e.category}</span>}
                </div>
              </div>
              <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:4,flexShrink:0}}>
                <span style={{fontWeight:800,fontSize:14,color:T.g9}}>${Number(e.amount).toLocaleString()}</span>
                <Badge status={e.paymentStatus}/>
              </div>
            </div>
          </Card>;
        })}
      </>}

    </div>
  </div>;
}

function QuotesView({data,onAdd,onDelete}){
  const [confirmDel,setConfirmDel]=useState(null);
  if(!data.quotes.length)return <div style={{textAlign:"center",padding:"60px 20px"}}>
    <i className="ti ti-file-text" style={{fontSize:48,color:T.g3,display:"block",marginBottom:12}} aria-hidden="true"/>
    <div style={{fontSize:16,fontWeight:700,color:T.g7,marginBottom:8}}>No quotes yet</div>
    <Btn icon="plus" onClick={onAdd}>Add first quote</Btn>
  </div>;
  return <div style={{display:"flex",flexDirection:"column",gap:8}}>
    {confirmDel&&<ConfirmDelete label={confirmDel.title} onConfirm={()=>{onDelete&&onDelete(confirmDel.id);setConfirmDel(null);}} onCancel={()=>setConfirmDel(null)}/>}
    {data.quotes.map(q=>{
      const v=data.vendors.find(x=>x.id===q.vendorId);
      const p=data.projects.find(x=>x.id===q.projectId);
      return <Card key={q.id}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontWeight:700,fontSize:14,color:T.g9,marginBottom:4}}>{q.title}</div>
            <div style={{display:"flex",gap:10,fontSize:12,color:T.g4,flexWrap:"wrap"}}>
              {p&&<span><i className="ti ti-building" style={{fontSize:11,marginRight:2}} aria-hidden="true"/>{p.name}</span>}
              {v&&<span><i className="ti ti-briefcase" style={{fontSize:11,marginRight:2}} aria-hidden="true"/>{v.name}</span>}
              {q.category&&<span>{q.tab} · {q.category}</span>}
            </div>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center",flexShrink:0}}>
            {q.amount&&<span style={{fontWeight:800,fontSize:15,color:T.g9}}>${Number(q.amount).toLocaleString()}</span>}
            <Badge status={q.status}/>
            <button onClick={()=>setConfirmDel(q)} style={{background:T.rdl,border:"none",borderRadius:8,width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>
              <i className="ti ti-trash" style={{fontSize:14,color:T.rd}} aria-hidden="true"/>
            </button>
          </div>
        </div>
      </Card>;
    })}
  </div>;
}

function ExpensesView({data,onAdd,onDelete,onUpdate}){
  const [confirmDel,setConfirmDel]=useState(null);
  const [selectedExpense,setSelectedExpense]=useState(null);
  const tot=data.expenses.reduce((s,e)=>s+(Number(e.amount)||0),0);
  const lab=data.expenses.filter(e=>e.tab==="Labor").reduce((s,e)=>s+(Number(e.amount)||0),0);
  const mat=data.expenses.filter(e=>e.tab==="Materials").reduce((s,e)=>s+(Number(e.amount)||0),0);
  if(!data.expenses.length)return <div style={{textAlign:"center",padding:"60px 20px"}}>
    <i className="ti ti-receipt" style={{fontSize:48,color:T.g3,display:"block",marginBottom:12}} aria-hidden="true"/>
    <div style={{fontSize:16,fontWeight:700,color:T.g7,marginBottom:8}}>No expenses yet</div>
    <Btn icon="plus" onClick={onAdd}>Add first expense</Btn>
  </div>;
  return <div>
    {confirmDel&&<ConfirmDelete label={confirmDel.name} onConfirm={()=>{onDelete&&onDelete(confirmDel.id);setConfirmDel(null);}} onCancel={()=>setConfirmDel(null)}/>}
    {selectedExpense&&<ExpenseDetailModal expense={selectedExpense} data={data} onClose={()=>setSelectedExpense(null)} onUpdate={(id,changes)=>{onUpdate&&onUpdate(id,changes);setSelectedExpense(null);}} onDelete={(id)=>{onDelete&&onDelete(id);setSelectedExpense(null);}}/>}
    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:18}}>
      <StatCard label="Total expenses" value={fmt(tot)} icon="receipt" accent/>
      <StatCard label="Labor" value={fmt(lab)} icon="tools" color="blue"/>
      <StatCard label="Materials" value={fmt(mat)} icon="package" color="green"/>
    </div>
    <div style={{display:"flex",flexDirection:"column",gap:8}}>
      {data.expenses.map(e=>{
        const v=data.vendors.find(x=>x.id===e.vendorId);
        const p=data.projects.find(x=>x.id===e.projectId);
        return <Card key={e.id} onClick={()=>setSelectedExpense(e)} style={{cursor:"pointer"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontWeight:700,fontSize:14,color:T.g9}}>{e.name}</div>
              <div style={{fontSize:12,color:T.g4,marginTop:2,display:"flex",gap:8,flexWrap:"wrap"}}>
                {p&&<span>{p.name}</span>}
                <span>{e.tab}{e.category?` · ${e.category}`:""}</span>
                {v&&<span>{v.name}</span>}
                {e.date&&<span>{e.date}</span>}
              </div>
            </div>
            <div style={{display:"flex",gap:8,alignItems:"center",flexShrink:0}}>
              <span style={{fontWeight:800,fontSize:15,color:T.g9}}>${Number(e.amount).toLocaleString()}</span>
              <Badge status={e.paymentStatus}/>
              <button onClick={ev=>{ev.stopPropagation();setConfirmDel(e);}} style={{background:T.rdl,border:"none",borderRadius:8,width:30,height:30,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",flexShrink:0}}>
                <i className="ti ti-trash" style={{fontSize:14,color:T.rd}} aria-hidden="true"/>
              </button>
            </div>
          </div>
        </Card>;
      })}
    </div>
  </div>;
}

function ReportsView({data}){
  if(!data.projects.length)return <div style={{textAlign:"center",padding:"60px 20px",color:T.g4}}>
    <i className="ti ti-chart-bar" style={{fontSize:48,color:T.g3,display:"block",marginBottom:12}} aria-hidden="true"/>
    <div style={{fontSize:16,fontWeight:700}}>Add projects to see reports</div>
  </div>;
  return <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
    {data.projects.map(p=>{
      const pe=data.expenses.filter(e=>e.projectId===p.id);
      const tot=pe.reduce((s,e)=>s+(Number(e.amount)||0),0);
      const lab=pe.filter(e=>e.tab==="Labor").reduce((s,e)=>s+(Number(e.amount)||0),0);
      const mat=pe.filter(e=>e.tab==="Materials").reduce((s,e)=>s+(Number(e.amount)||0),0);
      const b=Number(p.budget)||0;
      const aq=data.quotes.filter(q=>q.projectId===p.id&&q.status==="Approved").reduce((s,q)=>s+(Number(q.amount)||0),0);
      const pct=b>0?Math.round((tot/b)*100):0;
      return <Card key={p.id}>
        <div style={{marginBottom:12}}><div style={{fontWeight:800,fontSize:15,color:T.g9,marginBottom:5}}>{p.name}</div><Badge status={p.status}/></div>
        {b>0&&<div style={{marginBottom:12}}><PBar pct={pct} over={tot>b}/><div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:T.g4,marginTop:4}}>
          <span>{pct}%</span><span style={{color:tot>b?"#B91C1C":"#166534",fontWeight:700}}>{tot>b?`Over ${fmt(tot-b)}`:`Under ${fmt(b-tot)}`}</span>
        </div></div>}
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          {[["Budget",b>0?fmt(b):"—"],["Total expenses",fmt(tot)],["Labor",fmt(lab)],["Materials",fmt(mat)],["Approved quotes",fmt(aq)]].map(([k,v])=><tr key={k} style={{borderTop:`1px solid ${T.g15}`}}>
            <td style={{padding:"7px 0",fontSize:12,color:T.g5}}>{k}</td>
            <td style={{padding:"7px 0",textAlign:"right",fontSize:13,fontWeight:800,color:T.g9}}>{v}</td>
          </tr>)}
        </table>
      </Card>;
    })}
  </div>;
}

/* ── MOBILE NAV ── */
function MobileNav({sec,nav,lang}){
  const es=lang==="es";
  const ITEMS=[
    {id:"dashboard", label:es?"Inicio":"Home",    icon:"home"},
    {id:"projects",  label:es?"Proyectos":"Projects", icon:"building"},
    {id:"search",    label:es?"Buscar":"Search",  icon:"search"},
    {id:"contacts",  label:es?"Contactos":"Contacts", icon:"users"},
  ];
  const [pressed,setPressed]=useState(null);
  return <div data-nav="mobile" style={{
    position:"fixed",
    bottom:15,
    left:15,right:15,
    zIndex:100,
    display:"flex",alignItems:"center",gap:6,
    background:"rgba(255,255,255,0.55)",
    backdropFilter:"saturate(180%) blur(24px)",
    WebkitBackdropFilter:"saturate(180%) blur(24px)",
    borderRadius:999,
    border:"1px solid rgba(200,200,200,0.45)",
    padding:"5px 5px",
    boxShadow:"0 4px 30px rgba(0,0,0,0.08)",
  }}>
    {ITEMS.map(item=>{
      const act=sec===item.id;
      return <button key={item.id}
        onPointerDown={()=>setPressed(item.id)}
        onPointerUp={()=>{setPressed(null);nav(item.id);}}
        onPointerLeave={()=>setPressed(null)}
        style={{flex:1,border:act?"none":"1px solid #bababa",borderRadius:999,padding:"8px 4px 7px",cursor:"pointer",fontFamily:SYS,background:act?T.bl:"#E0E0E0",color:act?"#FFF":"#2C2C2E",fontSize:10,fontWeight:700,letterSpacing:"0.01em",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",transform:pressed===item.id?"scale(.93)":"scale(1)",transition:"transform .1s",WebkitTapHighlightColor:"transparent",boxShadow:"none",display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
        <i className={`ti ti-${item.icon}`} style={{fontSize:22,lineHeight:1}} aria-hidden="true"/>
        {item.label}
      </button>;
    })}
  </div>;
}

/* ── APP ── */
/* ── iOS-compatible download/share function ── */
async function saveFile(dataUrl, filename){
  // Convert dataUrl to blob
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  const file = new File([blob], filename, {type: blob.type});
  
  // iOS Safari: use Web Share API to route to Files app
  if(navigator.share && navigator.canShare && navigator.canShare({files:[file]})){
    try{
      await navigator.share({files:[file], title: filename});
      return;
    }catch(e){
      if(e.name==="AbortError") return; // user cancelled
    }
  }
  
  // Fallback: standard anchor download (works on desktop/Android)
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}


/* ── PREVIEW WINDOW HELPER ── */
function openPreview(dataUrl, name, fileType){
  const win=window.open();
  if(!win) return;
  const isPdf=fileType?.includes("pdf");
  const isImg=fileType?.startsWith("image")||(!isPdf&&(name?.match(/\.(jpg|jpeg|png|gif|webp)$/i)));
  let body="";
  if(isPdf) body='<embed src="'+dataUrl+'" type="application/pdf" style="width:100vw;height:100vh;"/>';
  else if(isImg) body='<img src="'+dataUrl+'" style="max-width:100%;height:auto;"/>';
  else{ win.location.href=dataUrl; return; }
  win.document.write('<html><head><title>'+name+'</title><meta name="viewport" content="width=device-width,initial-scale=1"><style>*{margin:0;padding:0;}body{background:#000;display:flex;align-items:center;justify-content:center;min-height:100vh;}</style></head><body>'+body+'</body></html>');
  win.document.close();
}

/* ── LOCK SCREEN ── */
function LockScreen({onUnlock,onContractor}){
  const [input,setInput]=useState("");
  const [shake,setShake]=useState(false);
  const [unlocking,setUnlocking]=useState(false);
  const [quoteIdx,setQuoteIdx]=useState(0);
  const [displayIdx,setDisplayIdx]=useState(0);
  const [quoteVisible,setQuoteVisible]=useState(true);
  const CODE="1990";
  const CODE2="2026";

  const QUOTES=[
    {text:"Be like water, my friend.",author:"Bruce Lee"},
    {text:"Stay hungry, stay foolish.",author:"Steve Jobs"},
    {text:"The obstacle is the way.",author:"Marcus Aurelius"},
    {text:"Discipline equals freedom.",author:"Jocko Willink"},
    {text:"Details make perfection.",author:"da Vinci"},
    {text:"Excellence is a habit.",author:"Aristotle"},
    {text:"Dream big, start small.",author:"Unknown"},
    {text:"Work hard in silence.",author:"Unknown"},
    {text:"Do the work. Every day.",author:"Unknown"},
    {text:"Make it simple, but significant.",author:"Don Draper"},
    {text:"Fall seven, rise eight.",author:"Japanese Proverb"},
    {text:"Action is the foundational key.",author:"Pablo Picasso"},
    {text:"Done is better than perfect.",author:"Sheryl Sandberg"},
    {text:"Push yourself, no one else will.",author:"Unknown"},
    {text:"Great things never come easy.",author:"Unknown"},
    {text:"Focus on the step ahead.",author:"Unknown"},
    {text:"Be the change you wish to see.",author:"Gandhi"},
    {text:"Simplicity is the soul of efficiency.",author:"Austin Freeman"},
    {text:"One day or day one.",author:"Unknown"},
    {text:"Sweat is just fat crying.",author:"Unknown"},
    {text:"Start where you are.",author:"Arthur Ashe"},
    {text:"Move fast. Break things.",author:"Mark Zuckerberg"},
    {text:"Ideas are cheap. Execution is everything.",author:"Unknown"},
    {text:"Be obsessed or be average.",author:"Grant Cardone"},
    {text:"Earn your keep.",author:"Unknown"},
    {text:"The best revenge is massive success.",author:"Frank Sinatra"},
    {text:"Stay focused and never quit.",author:"Unknown"},
    {text:"Adapt. Overcome. Improvise.",author:"Clint Eastwood"},
    {text:"You become what you think.",author:"Wayne Dyer"},
    {text:"Less talk, more action.",author:"Unknown"},
    {text:"Build it and they will come.",author:"Field of Dreams"},
    {text:"Think different.",author:"Apple"},
    {text:"No shortcuts. No excuses.",author:"Unknown"},
    {text:"Clarity is power.",author:"Tony Robbins"},
    {text:"Pressure makes diamonds.",author:"General Patton"},
    {text:"Small steps every single day.",author:"Unknown"},
    {text:"Win the morning, win the day.",author:"Tim Ferriss"},
    {text:"Your vibe attracts your tribe.",author:"Unknown"},
    {text:"You are what you repeatedly do.",author:"Aristotle"},
    {text:"Ship it.",author:"Unknown"},
    {text:"Always be closing.",author:"Glengarry Glen Ross"},
    {text:"Stay humble, hustle hard.",author:"Unknown"},
    {text:"Eat. Sleep. Build.",author:"Unknown"},
    {text:"The best time to start is now.",author:"Unknown"},
    {text:"Make today count.",author:"Unknown"},
    {text:"Comfort is the enemy of progress.",author:"Unknown"},
    {text:"Progress, not perfection.",author:"Unknown"},
    {text:"Show up. Every single day.",author:"Unknown"},
    {text:"Run your own race.",author:"Unknown"},
    {text:"Hard work beats talent.",author:"Tim Notke"},
    {text:"Speak less. Do more.",author:"Unknown"},
    {text:"Earn it every day.",author:"Unknown"},
    {text:"The grind never stops.",author:"Unknown"},
    {text:"Be relentless.",author:"Unknown"},
    {text:"Stop wishing. Start doing.",author:"Unknown"},
    {text:"Your future self is watching.",author:"Unknown"},
    {text:"Execution eats strategy for breakfast.",author:"Unknown"},
    {text:"Make it happen.",author:"Unknown"},
    {text:"Go further than you went yesterday.",author:"Unknown"},
    {text:"Stay in the game.",author:"Unknown"},
    {text:"Create. Don't wait.",author:"Unknown"},
    {text:"Work is worship.",author:"Unknown"},
    {text:"Be bold. Be brief. Be gone.",author:"Unknown"},
    {text:"Do it with passion or not at all.",author:"Rosa Nouchette Carey"},
    {text:"Strong people are harder to kill.",author:"Mark Rippetoe"},
    {text:"No pain, no gain.",author:"Unknown"},
    {text:"Risk more than others think is safe.",author:"Howard Schultz"},
    {text:"Keep going.",author:"Unknown"},
    {text:"You miss 100% of shots you don't take.",author:"Wayne Gretzky"},
    {text:"Be first or be better.",author:"Unknown"},
    {text:"Think big. Act bigger.",author:"Jeffrey Hayzlett"},
    {text:"Success is rented. Pay daily.",author:"Unknown"},
    {text:"Find a way.",author:"Unknown"},
    {text:"Grit is your greatest asset.",author:"Unknown"},
    {text:"Nothing works unless you do.",author:"Maya Angelou"},
    {text:"First, solve the problem.",author:"Unknown"},
    {text:"Brevity is the soul of wit.",author:"Shakespeare"},
    {text:"Quality over quantity. Always.",author:"Unknown"},
    {text:"Be a builder, not a talker.",author:"Unknown"},
    {text:"Every master was once a disaster.",author:"Unknown"},
    {text:"Learn. Adapt. Win.",author:"Unknown"},
    {text:"Build it right.",author:"Unknown"},
    {text:"Trust the process.",author:"Unknown"},
    {text:"Chase excellence, catch success.",author:"Unknown"},
    {text:"Attention to detail separates the best.",author:"Unknown"},
    {text:"Earn your stripes.",author:"Unknown"},
    {text:"Make your mark.",author:"Unknown"},
    {text:"Measure twice, cut once.",author:"Carpenter's Proverb"},
    {text:"Leave it better than you found it.",author:"Unknown"},
    {text:"Build to last.",author:"Unknown"},
    {text:"Craft over shortcuts.",author:"Unknown"},
    {text:"The details are not the details.",author:"Charles Eames"},
    {text:"Strong foundations. Bigger dreams.",author:"Unknown"},
    {text:"Work smart. Finish strong.",author:"Unknown"},
    {text:"Every project tells a story.",author:"Unknown"},
    {text:"Built with purpose.",author:"Unknown"},
    {text:"Legacy is built brick by brick.",author:"Unknown"},
    {text:"Renovation is transformation.",author:"Unknown"},
    {text:"Precision is professionalism.",author:"Unknown"},
    {text:"Make something beautiful today.",author:"Unknown"},
  ];

  useEffect(()=>{
    const interval=setInterval(()=>{
      // Phase 1: fade out
      setQuoteVisible(false);
      // Phase 2: after fade completes, swap displayed text
      setTimeout(()=>{
        setQuoteIdx(prev=>{
          let next;
          do{next=Math.floor(Math.random()*QUOTES.length);}while(next===prev);
          setDisplayIdx(next);
          return next;
        });
        // Phase 3: fade in with new text
        setTimeout(()=>setQuoteVisible(true),80);
      },650);
    },4500);
    return()=>clearInterval(interval);
  },[]);

  const press=(n)=>{
    if(input.length>=4||unlocking)return;
    const next=input+n;
    setInput(next);
    if(next.length===4){
      if(next===CODE){
        setUnlocking(true);
        setTimeout(()=>onUnlock(),600);
      }else if(next===CODE2){
        setUnlocking(true);
        setTimeout(()=>onContractor(),600);
      }else{
        setShake(true);
        setTimeout(()=>{setInput("");setShake(false);},600);
      }
    }
  };

  const del=()=>{if(!unlocking)setInput(i=>i.slice(0,-1));};
  const q=QUOTES[displayIdx];

  const btnStyle={
    background:"rgba(255,255,255,.1)",border:"none",borderRadius:"50%",
    width:"100%",aspectRatio:"1",color:T.wh,fontSize:26,fontWeight:300,
    cursor:"pointer",fontFamily:"'Helvetica Neue',Helvetica,sans-serif",
    display:"flex",alignItems:"center",justifyContent:"center",
    transition:"background .1s",backdropFilter:"blur(10px)",
  };
  const btnEvents={
    onMouseDown:e=>{e.currentTarget.style.background="rgba(255,255,255,.25)"},
    onMouseUp:e=>{e.currentTarget.style.background="rgba(255,255,255,.1)"},
    onMouseLeave:e=>{e.currentTarget.style.background="rgba(255,255,255,.1)"},
    onTouchStart:e=>{e.currentTarget.style.background="rgba(255,255,255,.25)"},
    onTouchEnd:e=>{e.currentTarget.style.background="rgba(255,255,255,.1)"},
  };

  return <div style={{
    position:"fixed",inset:0,
    background:`linear-gradient(160deg,${T.g9} 0%,#0a0a0a 100%)`,
    display:"flex",flexDirection:"column",
    alignItems:"center",justifyContent:"space-between",
    zIndex:99999,
    paddingTop:"env(safe-area-inset-top,44px)",
    paddingBottom:"env(safe-area-inset-bottom,34px)",
    paddingLeft:0,paddingRight:0,
    userSelect:"none",
  }}>
    {/* KARP logo top-left */}
    <div style={{position:"absolute",top:"env(safe-area-inset-top,20px)",left:20}}>
      <KarpLogo h={22} inv/>
    </div>

    {/* Quote + dots + keypad all in one centered column */}
    <div style={{
      flex:1,display:"flex",flexDirection:"column",
      alignItems:"center",justifyContent:"center",
      width:"100%",maxWidth:320,padding:"0 20px",gap:28,
    }}>
      {/* Quote — same gap from dots as keypad */}
      <div key={displayIdx} style={{
        opacity:quoteVisible?1:0,
        transition:"opacity 0.65s ease",
        height:64,display:"flex",flexDirection:"column",
        alignItems:"center",justifyContent:"center",
        textAlign:"center",willChange:"opacity",width:"100%",
      }}>
        <div style={{
          fontSize:17,fontWeight:300,color:"rgba(255,255,255,.88)",
          lineHeight:1.4,fontFamily:"'Helvetica Neue',Helvetica,sans-serif",
          letterSpacing:"0.01em",marginBottom:8,whiteSpace:"nowrap",
        }}>"{q.text}"</div>
        <div style={{fontSize:11,fontWeight:400,color:"rgba(255,255,255,.32)",
          fontFamily:"'Helvetica Neue',Helvetica,sans-serif",letterSpacing:"0.08em",textTransform:"uppercase",
        }}>— {q.author}</div>
      </div>

      {/* 4 PIN dots */}
      <div style={{
        display:"flex",gap:18,
        animation:shake?"shake .5s ease":unlocking?"pulse .6s ease":"none",
      }}>
        {[0,1,2,3].map(i=>(
          <div key={i} style={{
            width:14,height:14,borderRadius:"50%",
            background:i<input.length?(unlocking?T.gr:T.wh):"transparent",
            border:`2px solid ${i<input.length?(unlocking?T.gr:"rgba(255,255,255,.9)"):"rgba(255,255,255,.3)"}`,
            transition:"all .15s",
            transform:i<input.length?"scale(1.1)":"scale(1)",
          }}/>
        ))}
      </div>

      {/* Keypad */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,width:"100%"}}>
        {[1,2,3,4,5,6,7,8,9].map(n=>(
          <button key={n} onClick={()=>press(String(n))} style={btnStyle} {...btnEvents}>{n}</button>
        ))}
        <div/>
        <button onClick={()=>press("0")} style={btnStyle} {...btnEvents}>0</button>
        <button onClick={del} style={{
          background:"transparent",
          border:"1px solid rgba(255,255,255,.25)",
          borderRadius:"50%",
          width:"100%",aspectRatio:"1",
          color:"rgba(255,255,255,.7)",cursor:"pointer",
          display:"flex",alignItems:"center",justifyContent:"center",
        }}
          onTouchStart={e=>{e.currentTarget.style.background="rgba(255,255,255,.1)";}}
          onTouchEnd={e=>{e.currentTarget.style.background="transparent";}}
          onMouseDown={e=>{e.currentTarget.style.background="rgba(255,255,255,.1)";}}
          onMouseUp={e=>{e.currentTarget.style.background="transparent";}}
          onMouseLeave={e=>{e.currentTarget.style.background="transparent";}}
        >
          <i className="ti ti-backspace" style={{fontSize:28}} aria-hidden="true"/>
        </button>
      </div>

      <div style={{fontSize:11,color:"rgba(255,255,255,.2)",fontFamily:"'Helvetica Neue',Helvetica,sans-serif",letterSpacing:"0.08em",textTransform:"uppercase"}}>KARP CONCEPT</div>
    </div>

    <style>{`
      @keyframes shake{0%,100%{transform:translateX(0)}20%,60%{transform:translateX(-8px)}40%,80%{transform:translateX(8px)}}
      @keyframes pulse{0%,100%{opacity:1}50%{opacity:.5}}
    `}</style>
  </div>;
}

/* ── CONTRACTOR VIEW ── */
function ContractorView({data,add,onBack}){
  const[showExpense,setShowExpense]=useState(false);
  const[lang,setLang]=useState("en");
  const[localVendors,setLocalVendors]=useState([]);

  // Merge Supabase vendors with any locally added ones
  const allVendors=[...data.vendors,...localVendors.filter(lv=>!data.vendors.find(v=>v.id===lv.id))];
  const mergedData={...data,vendors:allVendors};
  return <div style={{
    position:"fixed",inset:0,
    background:`linear-gradient(160deg,${T.g9} 0%,#0a0a0a 100%)`,
    display:"flex",flexDirection:"column",
    alignItems:"center",justifyContent:"center",
    zIndex:99998,
    fontFamily:SYS,
  }}>
    {/* Top bar: KARP logo left, lang toggle right */}
    <div style={{position:"absolute",top:"env(safe-area-inset-top,20px)",left:0,right:0,display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 20px"}}>
      <KarpLogo h={22} inv/>
      <button onClick={()=>setLang(l=>l==="en"?"es":"en")} style={{
        background:"rgba(255,255,255,.12)",
        border:"1px solid rgba(255,255,255,.2)",
        borderRadius:999,padding:"7px 14px",
        color:"rgba(255,255,255,.85)",fontSize:12,fontWeight:800,
        cursor:"pointer",fontFamily:SYS,letterSpacing:"0.05em",
        backdropFilter:"blur(8px)",
      }}>{lang==="en"?"ES":"EN"}</button>
    </div>

    {/* Center: button only */}
    {!showExpense&&<div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:15}}>
      <button onClick={()=>setShowExpense(true)} style={{
        display:"flex",alignItems:"center",gap:10,
        background:"rgba(255,255,255,.1)",
        border:"1px solid rgba(255,255,255,.2)",
        borderRadius:20,padding:"18px 36px",
        color:T.wh,fontSize:16,fontWeight:700,
        cursor:"pointer",fontFamily:SYS,
        backdropFilter:"blur(12px)",
        transition:"all .2s",
      }}
        onMouseEnter={e=>{e.currentTarget.style.background="rgba(255,255,255,.2)";}}
        onMouseLeave={e=>{e.currentTarget.style.background="rgba(255,255,255,.1)";}}
        onTouchStart={e=>{e.currentTarget.style.background="rgba(255,255,255,.2)";}}
        onTouchEnd={e=>{e.currentTarget.style.background="rgba(255,255,255,.1)";}}
      >
        <i className="ti ti-plus" style={{fontSize:20}} aria-hidden="true"/>
        {lang==="es"?"Agregar Gasto":"Add New Expense"}
      </button>
      <div style={{fontSize:12,color:"rgba(255,255,255,.3)",letterSpacing:"0.05em"}}>KARP CONCEPT · {lang==="es"?"CONTRATISTA":"CONTRACTOR"}</div>
    </div>}

    {/* Expense form as a sheet */}
    {showExpense&&<div style={{
      position:"absolute",inset:0,
      display:"flex",alignItems:"flex-end",
      background:"rgba(0,0,0,.7)",
    }}>
      <div style={{
        background:T.wh,borderRadius:"22px 22px 0 0",
        width:"100%",maxHeight:"92vh",
        display:"flex",flexDirection:"column",
        boxShadow:"0 -8px 40px rgba(0,0,0,.4)",
      }}>
        {/* Handle + header */}
        <div style={{flexShrink:0,borderBottom:`1px solid ${T.g15}`}}>
          <div style={{display:"flex",justifyContent:"center",padding:"10px 0 6px"}}>
            <div style={{width:36,height:4,borderRadius:4,background:T.g2}}/>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 20px 14px"}}>
            <h2 style={{margin:0,fontSize:18,fontWeight:800,color:T.g9}}>{lang==="es"?"Nuevo Gasto":"New Expense"}</h2>
            <button onClick={()=>setShowExpense(false)} style={{background:T.g1,border:"none",cursor:"pointer",color:T.g5,width:32,height:32,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:16}}>✕</button>
          </div>
        </div>
        {/* Expense form */}
        <div style={{flex:1,overflowY:"auto",padding:"15px 20px 40px"}}>
          <ExpenseForm
            lang={lang}
            data={mergedData}
            onSave={f=>{
              add("expenses",f);toast("Expense saved");
              setShowExpense(false);
            }}
            onClose={()=>setShowExpense(false)}
            onAddVendor={v=>{add("vendors",v);setLocalVendors(prev=>[...prev,v]);}}
          />
        </div>
      </div>
    </div>}
  </div>;
}


const TR={
  en:{
    overview:"Overview",activeProjects:"Active projects",pendingQuotes:"Pending quotes",approved:"Approved",
    newProject:"New Project",addQuote:"Add Quote",addExpense:"Add Expense",attachFiles:"Attach Files",
    requestQuote:"Request Quote",filesLinks:"FILES & LINKS",quotesByCategory:"QUOTES BY CATEGORY",
    expenses:"EXPENSES",labor:"Labor",materials:"Materials",mortgage:"Mortgage",
    noItems:"No items yet",recentActivity:"RECENT ACTIVITY",reports:"Reports",
    searchPlaceholder:"Search projects, quotes, contacts, expenses…",quickSearch:"Quick Search",
    newContact:"New Contact",newExpense:"New Expense",scanCard:"Scan Business Card (AI)",
    scanReceipt:"Scan Receipt or Invoice (AI Auto-Fill)",fillManually:"Or fill in manually",
    saveContact:"Save Contact",saveChanges:"Save Changes",cancel:"Cancel",delete:"Delete",
    edit:"Edit",reply:"Reply",quote:"Quote",attachment:"ATTACHMENT",notes:"NOTES",
    project:"Project",vendor:"Vendor",contact:"Contact",quoteDate:"Quote Date",validUntil:"Valid Until",
    amount:"Amount",status:"Status",category:"Category",type:"Type",date:"Date",
    spent:"Spent",budget:"Budget",noLaborYet:"No labor items yet",noMaterialsYet:"No materials yet",
    noMortgageYet:"No mortgage items yet",noQuotesYet:"No quotes yet",noExpensesYet:"No expenses yet",
    activeProj:"ACTIVE PROJECTS",all:"All",contacts:"Contacts",vendors:"Vendors",projects:"Projects",
    quotes:"Quotes",search:"Search",home:"Home",
    openZoom:"Open & Zoom",download:"Download",browseFiles:"Browse Files",addUrl:"Add URL",
    photoLibrary:"Photo Library",fillForm:"Fill Form",retake:"Retake",
    quoteTitle:"Quote title",description:"Description",paymentStatus:"Payment Status",
    invoiceNumber:"Invoice #",tax:"Tax",
    identity:"IDENTITY",company:"COMPANY",contactInfo:"CONTACT INFO",tradeCategories:"Trade Categories",
    firstName:"First name",lastName:"Last name",role:"Role / Trade",companyVendor:"Company / Vendor",
    directPhone:"Direct phone",businessPhone:"Business phone",email:"Email",address:"Address",
    internalNotes:"Internal notes",quoteHistory:"Quote History",
    areYouSure:"Are you sure?",cannotUndo:"This cannot be undone.",
    editContact:"Edit Contact",editProject:"Edit Project",editQuote:"Edit Quote",editExpense:"Edit Expense",
    quoteDetails:"Quote Details",expenseDetails:"Expense Details",contactDetails:"Contact Details",
    noContactsYet:"No contacts yet",noProjectsYet:"No projects yet",
    utilized:"utilized out of",budget2:"budget",
  },
  es:{
    overview:"Resumen",activeProjects:"Proyectos activos",pendingQuotes:"Cotizaciones pendientes",approved:"Aprobadas",
    newProject:"Nuevo Proyecto",addQuote:"Agregar Cotización",addExpense:"Agregar Gasto",attachFiles:"Adjuntar Archivos",
    requestQuote:"Solicitar Cotización",filesLinks:"ARCHIVOS Y ENLACES",quotesByCategory:"COTIZACIONES POR CATEGORÍA",
    expenses:"GASTOS",labor:"Mano de Obra",materials:"Materiales",mortgage:"Hipoteca",
    noItems:"Sin elementos",recentActivity:"ACTIVIDAD RECIENTE",reports:"Reportes",
    searchPlaceholder:"Buscar proyectos, cotizaciones, contactos, gastos…",quickSearch:"Búsqueda Rápida",
    newContact:"Nuevo Contacto",newExpense:"Nuevo Gasto",scanCard:"Escanear Tarjeta (IA)",
    scanReceipt:"Escanear Recibo o Factura (IA)",fillManually:"O llenar manualmente",
    saveContact:"Guardar Contacto",saveChanges:"Guardar Cambios",cancel:"Cancelar",delete:"Eliminar",
    edit:"Editar",reply:"Responder",quote:"Cotizar",attachment:"ADJUNTO",notes:"NOTAS",
    project:"Proyecto",vendor:"Proveedor",contact:"Contacto",quoteDate:"Fecha Cotización",validUntil:"Válido Hasta",
    amount:"Monto",status:"Estado",category:"Categoría",type:"Tipo",date:"Fecha",
    spent:"Gastado",budget:"Presupuesto",noLaborYet:"Sin mano de obra",noMaterialsYet:"Sin materiales",
    noMortgageYet:"Sin hipoteca",noQuotesYet:"Sin cotizaciones",noExpensesYet:"Sin gastos",
    activeProj:"PROYECTOS ACTIVOS",all:"Todos",contacts:"Contactos",vendors:"Proveedores",projects:"Proyectos",
    quotes:"Cotizaciones",search:"Buscar",home:"Inicio",
    openZoom:"Abrir y Ampliar",download:"Descargar",browseFiles:"Explorar Archivos",addUrl:"Agregar URL",
    photoLibrary:"Biblioteca de Fotos",fillForm:"Llenar Formulario",retake:"Volver a Tomar",
    quoteTitle:"Título de cotización",description:"Descripción",paymentStatus:"Estado de Pago",
    invoiceNumber:"N° Factura",tax:"Impuesto",
    identity:"IDENTIDAD",company:"EMPRESA",contactInfo:"INFORMACIÓN DE CONTACTO",tradeCategories:"Categorías",
    firstName:"Nombre",lastName:"Apellido",role:"Rol / Oficio",companyVendor:"Empresa / Proveedor",
    directPhone:"Teléfono directo",businessPhone:"Teléfono comercial",email:"Correo",address:"Dirección",
    internalNotes:"Notas internas",quoteHistory:"Historial de Cotizaciones",
    areYouSure:"¿Estás seguro?",cannotUndo:"Esta acción no se puede deshacer.",
    editContact:"Editar Contacto",editProject:"Editar Proyecto",editQuote:"Editar Cotización",editExpense:"Editar Gasto",
    quoteDetails:"Detalles de Cotización",expenseDetails:"Detalles del Gasto",contactDetails:"Detalles del Contacto",
    noContactsYet:"Sin contactos aún",noProjectsYet:"Sin proyectos aún",
    utilized:"utilizado de",budget2:"presupuesto",
  },
};

export default function App(){
  const{data,add,remove,hist,loading,syncing,error,dbOk,update}=useData();
  const updateContact=(id,changes)=>{update("contacts",id,changes);hist({message:`Contact updated: ${changes.firstName} ${changes.lastName}`,icon:"user"});toast("Changes saved");};
  const[locked,setLocked]=useState(true);
  const[contractor,setContractor]=useState(false);
  const[lang,setLang]=useState("en");
  const[sec,setSec]=useState("dashboard");
  const[proj,setProj]=useState(null);
  const[modal,setModal]=useState(null);
  const[et,setEt]=useState(null);
  const[dismissErr,setDismissErr]=useState(false);
  useEffect(()=>{setLocked(true);},[]);
  if(locked) return <LockScreen onUnlock={()=>setLocked(false)} onContractor={()=>{setLocked(false);setContractor(true);}}/>;
  if(contractor) return <ContractorView data={data} add={add} onBack={()=>setContractor(false)}/>;
  const mob=typeof window!=="undefined"&&window.innerWidth<768;
  const nav=(s,p)=>{setSec(s);if(p)setProj(p);else setProj(null);};
  const close=()=>setModal(null);
  const rq=(contact,vendor,project,category,tab)=>{setEt({contact,vendor,project:project?.name||"",category:category||"",tab:tab||"Labor"});setModal("email");};
  const ADDS={projects:{label:"New Project",m:"addProject"},quotes:{label:"New Quote",m:"addQuote"},expenses:{label:"New Expense",m:"addExpense"},vendors:{label:"New Vendor",m:"addVendor"}};
  const TITLES={dashboard:"Dashboard",projects:"Projects",contacts:"Contacts",vendors:"Vendors",search:"Smart Search",quotes:"Quotes",expenses:"Expenses",reports:"Reports"};
  const SIDES=[
    {id:"dashboard",icon:"layout-dashboard",label:"Dashboard"},{id:"projects",icon:"building",label:"Projects"},
    {id:"contacts",icon:"users",label:"Contacts"},{id:"vendors",icon:"briefcase",label:"Vendors"},
    {id:"search",icon:"search",label:"Smart Search"},{id:"quotes",icon:"file-text",label:"Quotes"},
    {id:"expenses",icon:"receipt",label:"Expenses"},{id:"reports",icon:"chart-bar",label:"Reports"},
  ];

  // Full-screen loading state on first open
  if(loading)return(
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",height:"100dvh",background:T.g1,fontFamily:SYS,gap:20}}>
      <KarpLogo h={52}/>
      <div style={{fontSize:13,fontWeight:700,color:T.g4,letterSpacing:"0.12em",textTransform:"uppercase"}}>Concept</div>
      <div style={{display:"flex",alignItems:"center",gap:10,marginTop:8}}>
        <div style={{width:18,height:18,borderRadius:"50%",border:`2.5px solid ${T.bl}`,borderTopColor:"transparent",animation:"spin .7s linear infinite"}}/>
        <span style={{fontSize:13,color:T.g4,fontWeight:600}}>Loading your data…</span>
      </div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  const renderContent=()=>{
    if(sec==="projects"&&proj)return <ProjectDetail project={proj} lang={lang} data={data} onRQ={rq} onAddQ={()=>setModal("addQuote")} onAddE={()=>setModal("addExpense")} onUpdateQuote={(id,changes)=>{update("quotes",id,changes);hist({message:"Quote updated",icon:"file-text"});}} onDeleteQuote={(id)=>{remove("quotes",id);hist({message:"Quote deleted",icon:"file-text"});}} onUpdateExpense={(id,changes)=>{update("expenses",id,changes);hist({message:"Expense updated",icon:"receipt"});}} onDeleteExpense={(id)=>{remove("expenses",id);hist({message:"Expense deleted",icon:"receipt"});}} onUpdateProject={(id,changes)=>{update("projects",id,changes);setProj(changes);hist({message:`Project status: ${changes.status}`,icon:"building"});}}/>;
    switch(sec){
      case"dashboard":return <Dashboard data={data} onNav={nav} onAdd={(m)=>setModal(m||"addProject")} lang={lang}/>;
      case"projects":return <ProjectsView data={data} onSelect={p=>setProj(p)} lang={lang} onAdd={()=>setModal("addProject")} onDelete={id=>{remove("projects",id);hist({message:"Project deleted",icon:"building"});}} onUpdate={(id,changes)=>{update("projects",id,changes);hist({message:`Project updated: ${changes.name}`,icon:"building"});}}/>;
      case"contacts":return <ContactsView data={data} lang={lang} onRQ={rq} onAddContact={f=>{add("contacts",f);hist({message:`Contact added: ${f.firstName} ${f.lastName}`,icon:"user"});toast("Contact saved");}} onAddVendor={f=>{add("vendors",f);hist({message:`Vendor added: ${f.name}`,icon:"briefcase"});toast("Vendor saved");}} onUpdateVendor={(id,changes)=>{update("vendors",id,changes);hist({message:`Vendor updated: ${changes.name}`,icon:"briefcase"});toast("Vendor saved");}} onDeleteVendor={id=>{remove("vendors",id);hist({message:"Vendor deleted",icon:"briefcase"});toast("Deleted","error");}} onUpdateContact={(id,changes)=>updateContact(id,changes)} onDeleteContact={id=>{remove("contacts",id);hist({message:"Contact deleted",icon:"user"});toast("Deleted","error");}}/>;
      case"vendors":return <VendorsView data={data} onRQ={rq} onAdd={()=>setModal("addVendor")}/>;
      case"search":return <SmartSearch data={data} onRQ={rq} onNav={nav} lang={lang}/>;
      case"quotes":return <QuotesView data={data} onAdd={()=>setModal("addQuote")} onDelete={id=>{remove("quotes",id);hist({message:"Quote deleted",icon:"file-text"});}}/>;
      case"expenses":return <ExpensesView data={data} onAdd={()=>setModal("addExpense")} onDelete={id=>{remove("expenses",id);hist({message:"Expense deleted",icon:"receipt"});}} onUpdate={(id,changes)=>{update("expenses",id,changes);hist({message:"Expense updated",icon:"receipt"});}}/>;
      case"reports":return <ReportsView data={data}/>;
      default:return null;
    }
  };

  return <div style={{display:"flex",height:"100dvh",background:T.g1,fontFamily:SYS,position:"fixed",top:0,left:0,right:0,bottom:0}}>

    {/* Sidebar */}
    {!mob&&<div style={{width:220,flexShrink:0,background:T.g9,display:"flex",flexDirection:"column",height:"100dvh"}}>
      <div style={{padding:"16px 16px 14px",borderBottom:"1px solid rgba(255,255,255,.07)"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <KarpLogo h={32} inv/>
          <div><div style={{fontSize:10,fontWeight:800,color:"rgba(255,255,255,.9)",letterSpacing:"0.12em",textTransform:"uppercase"}}>Concept</div>
          <div style={{fontSize:9,color:T.g5,fontWeight:600,letterSpacing:"0.06em",textTransform:"uppercase",marginTop:2}}>Project Manager</div></div>
        </div>
      </div>
      <div style={{flex:1,overflowY:"auto",padding:"8px 10px"}}>
        {SIDES.map(item=>{const act=sec===item.id;
          return <button key={item.id} onClick={()=>nav(item.id)} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"9px 12px",borderRadius:10,border:"none",cursor:"pointer",background:act?T.or:"transparent",color:act?T.wh:T.g5,fontSize:13,fontWeight:act?800:600,textAlign:"left",marginBottom:2,fontFamily:SYS}}>
            <i className={`ti ti-${item.icon}`} style={{fontSize:16,flexShrink:0}} aria-hidden="true"/>{item.label}
          </button>;
        })}
      </div>
      <div style={{padding:"10px 16px 16px",borderTop:"1px solid rgba(255,255,255,.07)"}}>
        {/* Sync indicator */}
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:8}}>
          {syncing
            ?<><div style={{width:7,height:7,borderRadius:"50%",background:T.am,animation:"pulse 1s infinite"}}/><span style={{fontSize:11,color:T.g5,fontWeight:600}}>Syncing…</span></>
            :<><div style={{width:7,height:7,borderRadius:"50%",background:T.gr}}/><span style={{fontSize:11,color:T.g5,fontWeight:600}}>Synced to cloud</span></>
          }
        </div>
        <div style={{fontSize:11,color:T.g6,lineHeight:1.8,fontWeight:600}}>
          <div>{data.projects.length} projects</div>
          <div>{data.contacts.length} contacts · {data.vendors.length} vendors</div>
        </div>
      </div>
    </div>}

    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",minWidth:0}}>

      {/* Error / offline banner */}
      {error&&!dismissErr&&<div style={{background:T.aml,borderBottom:`1px solid ${T.am}`,padding:"8px 16px",display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
        <i className="ti ti-wifi-off" style={{fontSize:15,color:"#7A4500",flexShrink:0}} aria-hidden="true"/>
        <span style={{fontSize:12,color:"#7A4500",flex:1,fontWeight:600}}>{error}</span>
        <button onClick={()=>setDismissErr(true)} style={{background:"none",border:"none",cursor:"pointer",color:"#7A4500",fontSize:16,lineHeight:1,padding:0}}>✕</button>
      </div>}

      {/* Mobile header — fixed so glass blur works over scrolling content */}
      {mob
        ?<div style={{background:"rgba(255,255,255,0.65)",backdropFilter:"saturate(200%) blur(20px)",WebkitBackdropFilter:"saturate(200%) blur(20px)",borderBottom:`1px solid rgba(200,200,200,0.3)`,paddingTop:"calc(env(safe-area-inset-top, 0px) + 8px)",paddingBottom:"8px",paddingLeft:"14px",paddingRight:"14px",display:"flex",alignItems:"center",justifyContent:"space-between",position:"fixed",top:0,left:0,right:0,zIndex:100,flexShrink:0}}>
          {/* Left: KARP logo or back */}
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            {proj
              ?<button onClick={()=>setProj(null)} style={{background:T.bl,border:"none",cursor:"pointer",color:T.wh,width:32,height:32,borderRadius:9,display:"flex",alignItems:"center",justifyContent:"center"}}><i className="ti ti-arrow-left" style={{fontSize:16}} aria-hidden="true"/></button>
              :<button onClick={()=>setLocked(true)} style={{background:"none",border:"none",cursor:"pointer",padding:0,display:"flex",alignItems:"center"}}><KarpLogo h={22}/></button>
            }
          </div>
          {/* Right: syncing dot + lang toggle */}
          <div style={{display:"flex",gap:6,alignItems:"center"}}>
            {syncing&&<div style={{width:6,height:6,borderRadius:"50%",background:T.am}}/>}
            <button onClick={()=>setLang(l=>l==="en"?"es":"en")} style={{background:"rgba(0,0,0,.07)",border:"none",borderRadius:999,padding:"7px 12px",fontFamily:SYS,fontSize:12,fontWeight:800,cursor:"pointer",color:T.g6,letterSpacing:"0.04em"}}>
              {lang==="en"?"ES":"EN"}
            </button>
          </div>
        </div>

        /* Desktop header */
        :<div style={{background:T.wh,borderBottom:`1.5px solid ${T.g2}`,padding:"12px 28px",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            {proj&&<><button onClick={()=>setProj(null)} style={{background:"none",border:"none",cursor:"pointer",color:T.bl,fontSize:13,fontWeight:700,padding:0}}>Projects</button>
            <i className="ti ti-chevron-right" style={{fontSize:12,color:T.g3}} aria-hidden="true"/></>}
            <h1 style={{margin:0,fontSize:17,fontWeight:800,color:T.g9}}>{proj?"":["search","projects","contacts"].includes(sec)?"":TITLES[sec]}</h1>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            {/* Sync pill */}
            <div style={{display:"flex",alignItems:"center",gap:5,padding:"5px 10px",borderRadius:999,background:syncing?T.aml:dbOk?T.grl:T.rdl,border:`1px solid ${syncing?T.am:dbOk?T.gr:T.rd}`}}>
              {syncing
                ?<div style={{width:6,height:6,borderRadius:"50%",background:T.am,animation:"pulse 1s infinite"}}/>
                :<i className={`ti ti-${dbOk?"cloud-check":"cloud-off"}`} style={{fontSize:12,color:dbOk?"#166534":"#B91C1C"}} aria-hidden="true"/>
              }
              <span style={{fontSize:10,fontWeight:700,color:syncing?"#7A4500":dbOk?"#166534":"#B91C1C"}}>{syncing?"Syncing…":dbOk?"Cloud saved":"Not connected"}</span>
            </div>
            {sec==="search"&&<Btn icon="mail" variant="outline_orange" size="sm" onClick={()=>setModal("email")}>Request Quote</Btn>}
            <button onClick={()=>setModal("addExpense")} style={{display:"flex",alignItems:"center",gap:7,background:T.bl,color:"#FFF",border:"none",borderRadius:999,padding:"9px 16px",fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:SYS}}
              onMouseDown={e=>{e.currentTarget.style.transform="scale(.96)"}} onMouseUp={e=>{e.currentTarget.style.transform="scale(1)"}} onMouseLeave={e=>{e.currentTarget.style.transform="scale(1)"}}>
              <i className="ti ti-receipt" style={{fontSize:14}} aria-hidden="true"/>Add Expense
            </button>
            <button onClick={()=>setModal("addContact")} style={{display:"flex",alignItems:"center",gap:8,background:T.bl,color:"#FFF",border:"none",borderRadius:999,padding:"9px 16px",fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:SYS}}
              onMouseDown={e=>{e.currentTarget.style.transform="scale(.96)"}} onMouseUp={e=>{e.currentTarget.style.transform="scale(1)"}} onMouseLeave={e=>{e.currentTarget.style.transform="scale(1)"}}>
              <i className="ti ti-user-plus" style={{fontSize:14}} aria-hidden="true"/>Add Contact
            </button>
            {ADDS[sec]&&!proj&&<Btn icon="plus" onClick={()=>setModal(ADDS[sec].m)}>{ADDS[sec].label}</Btn>}
          </div>
        </div>
      }

      {/* Content */}
      <div style={{flex:1,overflowY:"auto",padding:mob?"calc(env(safe-area-inset-top,0px) + 72px) 14px calc(env(safe-area-inset-bottom,0px) + 90px)":"22px 26px"}}>
        {renderContent()}
      </div>
    </div>

    {mob&&<MobileNav sec={sec} nav={nav} lang={lang}/>}

    {/* Modals */}
    {modal==="addProject"&&<Modal title={lang==="es"?"Nuevo Proyecto":"New Project"} onClose={close} width={560}><ProjectForm onSave={f=>{add("projects",f);hist({message:`Project: ${f.name}`,icon:"building"});toast("Project saved");close();}} onClose={close}/></Modal>}
    {modal==="addContact"&&<Modal title={lang==="es"?"Nuevo Contacto":"New Contact"} onClose={close} width={560}><ContactForm lang={lang} vendors={data.vendors} onSave={f=>{add("contacts",f);hist({message:`Contact: ${f.firstName} ${f.lastName}`,icon:"user"});close();}} onClose={close} onNewVendor={nv=>{add("vendors",nv);hist({message:`Vendor: ${nv.name}`,icon:"briefcase"});}}/></Modal>}
    {modal==="addVendor"&&<Modal title="New Vendor" onClose={close} width={520}><VendorForm onSave={f=>{add("vendors",f);hist({message:`Vendor: ${f.name}`,icon:"briefcase"});close();}} onClose={close}/></Modal>}
    {modal==="addQuote"&&<Modal title={lang==="es"?"Nueva Cotización":"New Quote"} onClose={close} width={580}><QuoteForm data={data} onSave={f=>{add("quotes",f);hist({message:`Quote: ${f.title}`,icon:"file-text"});toast("Quote saved");close();}} onClose={close} initialProject={proj} initialTab="Labor"/></Modal>}
    {modal==="addReturn"&&<Modal title={lang==="es"?"Nueva Devolución":"New Return"} onClose={close} width={600}><ExpenseForm lang={lang} data={data} isReturn onSave={f=>{
      const returnF={...f,amount:-(Math.abs(Number(f.amount))),name:f.name||(lang==="es"?"Devolución":"Return"),tab:f.tab||"Materials"};
      add("expenses",returnF);
      hist({message:`Return: ${returnF.name} — $${Math.abs(Number(returnF.amount)).toLocaleString()}`,icon:"arrow-back-up"});
      toast(lang==="es"?"Devolución guardada":"Return saved");
      close();
    }} onClose={close} onAddVendor={v=>{add("vendors",v);hist({message:`Vendor auto-created: ${v.name}`,icon:"briefcase"});}}/></Modal>}
    {modal==="addExpense"&&<Modal title={lang==="es"?"Nuevo Gasto":"New Expense"} onClose={close} width={600}><ExpenseForm lang={lang} data={data} onSave={f=>{add("expenses",f);hist({message:`Expense: ${f.name} — $${Number(f.amount).toLocaleString()}`,icon:"receipt"});toast("Expense saved");close();}} onClose={close} onAddVendor={v=>{add("vendors",v);hist({message:`Vendor auto-created: ${v.name}`,icon:"briefcase"});}}/></Modal>}
    {modal==="email"&&<AIEmail contact={et?.contact} vendor={et?.vendor} project={et?.project} category={et?.category} tab={et?.tab} allContacts={data.contacts} allVendors={data.vendors} onClose={()=>{setModal(null);setEt(null);}} onSent={e=>hist({message:`Quote request: ${e.subject}`,icon:"mail"})} lang={lang}/>}

    <ToastContainer/>
    <style>{`
      *,*::before,*::after{box-sizing:border-box;}
      html{height:100%;background:#0a0a0a;}
      body{height:100%;overflow:hidden;background:#0a0a0a;overscroll-behavior:none;-webkit-overflow-scrolling:touch;margin:0;padding:0;}
      #root{height:100%;background:#0a0a0a;}
      html{
        height:-webkit-fill-available;
        overflow:hidden;
        -webkit-text-size-adjust:100%;
        text-size-adjust:100%;
      }
      body{
        height:100%;
        height:-webkit-fill-available;
        overflow:hidden;
        overscroll-behavior:none;
        -webkit-overflow-scrolling:touch;
      }
      input,select,textarea{
        font-size:16px !important;
        -webkit-text-size-adjust:100%;
      }
      input:focus,select:focus,textarea:focus{
        font-size:16px !important;
        transform:translateZ(0);
      }
      @keyframes spin{to{transform:rotate(360deg)}}
      @keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}
      @keyframes karpSlideUp{from{transform:translateY(100%);opacity:0;}to{transform:translateY(0);opacity:1;}}
      body.karp-modal-open [data-nav="mobile"]{display:none !important;}
      .no-select{-webkit-user-select:none;user-select:none;-webkit-touch-callout:none;}
    `}</style>
  </div>;
}
